/**
 * @typedef Gemoji
 * @property {string} emoji
 *   Example: `'😀'`.
 * @property {Array<string>} names
 *   Example: `['grinning']`.
 * @property {Array<string>} tags
 *   Example: `['smile', 'happy']`.
 * @property {string} description
 *   Example: `'grinning face'`.
 * @property {string} category
 *   Example: `'Smileys & Emotion'`.
 */

/**
 * List of gemoji.
 *
 * @type {Array<Gemoji>}
 */
export const gemoji = [
  {
    emoji: '😀',
    names: ['grinning'],
    tags: ['smile', 'happy'],
    description: 'grinning face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😃',
    names: ['smiley'],
    tags: ['happy', 'joy', 'haha'],
    description: 'grinning face with big eyes',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😄',
    names: ['smile'],
    tags: ['happy', 'joy', 'laugh', 'pleased'],
    description: 'grinning face with smiling eyes',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😁',
    names: ['grin'],
    tags: [],
    description: 'beaming face with smiling eyes',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😆',
    names: ['laughing', 'satisfied'],
    tags: ['happy', 'haha'],
    description: 'grinning squinting face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😅',
    names: ['sweat_smile'],
    tags: ['hot'],
    description: 'grinning face with sweat',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤣',
    names: ['rofl'],
    tags: ['lol', 'laughing'],
    description: 'rolling on the floor laughing',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😂',
    names: ['joy'],
    tags: ['tears'],
    description: 'face with tears of joy',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🙂',
    names: ['slightly_smiling_face'],
    tags: [],
    description: 'slightly smiling face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🙃',
    names: ['upside_down_face'],
    tags: [],
    description: 'upside-down face',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🫠',
  //   names: ['melting_face'],
  //   tags: ['sarcasm', 'dread'],
  //   description: 'melting face',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '😉',
    names: ['wink'],
    tags: ['flirt'],
    description: 'winking face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😊',
    names: ['blush'],
    tags: ['proud'],
    description: 'smiling face with smiling eyes',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😇',
    names: ['innocent'],
    tags: ['angel'],
    description: 'smiling face with halo',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🥰',
    names: ['smiling_face_with_three_hearts'],
    tags: ['love'],
    description: 'smiling face with hearts',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😍',
    names: ['heart_eyes'],
    tags: ['love', 'crush'],
    description: 'smiling face with heart-eyes',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤩',
    names: ['star_struck'],
    tags: ['eyes'],
    description: 'star-struck',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😘',
    names: ['kissing_heart'],
    tags: ['flirt'],
    description: 'face blowing a kiss',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😗',
    names: ['kissing'],
    tags: [],
    description: 'kissing face',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '☺️',
  //   names: ['relaxed'],
  //   tags: ['blush', 'pleased'],
  //   description: 'smiling face',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '😚',
    names: ['kissing_closed_eyes'],
    tags: [],
    description: 'kissing face with closed eyes',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😙',
    names: ['kissing_smiling_eyes'],
    tags: [],
    description: 'kissing face with smiling eyes',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🥲',
  //   names: ['smiling_face_with_tear'],
  //   tags: [],
  //   description: 'smiling face with tear',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '😋',
    names: ['yum'],
    tags: ['tongue', 'lick'],
    description: 'face savoring food',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😛',
    names: ['stuck_out_tongue'],
    tags: [],
    description: 'face with tongue',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😜',
    names: ['stuck_out_tongue_winking_eye'],
    tags: ['prank', 'silly'],
    description: 'winking face with tongue',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤪',
    names: ['zany_face'],
    tags: ['goofy', 'wacky'],
    description: 'zany face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😝',
    names: ['stuck_out_tongue_closed_eyes'],
    tags: ['prank'],
    description: 'squinting face with tongue',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤑',
    names: ['money_mouth_face'],
    tags: ['rich'],
    description: 'money-mouth face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤗',
    names: ['hugs'],
    tags: [],
    description: 'smiling face with open hands',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤭',
    names: ['hand_over_mouth'],
    tags: ['quiet', 'whoops'],
    description: 'face with hand over mouth',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🫢',
  //   names: ['face_with_open_eyes_and_hand_over_mouth'],
  //   tags: ['gasp', 'shock'],
  //   description: 'face with open eyes and hand over mouth',
  //   category: 'Smileys & Emotion'
  // },
  // {
  //   emoji: '🫣',
  //   names: ['face_with_peeking_eye'],
  //   tags: [],
  //   description: 'face with peeking eye',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '🤫',
    names: ['shushing_face'],
    tags: ['silence', 'quiet'],
    description: 'shushing face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤔',
    names: ['thinking'],
    tags: [],
    description: 'thinking face',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🫡',
  //   names: ['saluting_face'],
  //   tags: ['respect'],
  //   description: 'saluting face',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '🤐',
    names: ['zipper_mouth_face'],
    tags: ['silence', 'hush'],
    description: 'zipper-mouth face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤨',
    names: ['raised_eyebrow'],
    tags: ['suspicious'],
    description: 'face with raised eyebrow',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😐',
    names: ['neutral_face'],
    tags: ['meh'],
    description: 'neutral face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😑',
    names: ['expressionless'],
    tags: [],
    description: 'expressionless face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😶',
    names: ['no_mouth'],
    tags: ['mute', 'silence'],
    description: 'face without mouth',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🫥',
  //   names: ['dotted_line_face'],
  //   tags: ['invisible'],
  //   description: 'dotted line face',
  //   category: 'Smileys & Emotion'
  // },
  // {
  //   emoji: '😶‍🌫️',
  //   names: ['face_in_clouds'],
  //   tags: [],
  //   description: 'face in clouds',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '😏',
    names: ['smirk'],
    tags: ['smug'],
    description: 'smirking face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😒',
    names: ['unamused'],
    tags: ['meh'],
    description: 'unamused face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🙄',
    names: ['roll_eyes'],
    tags: [],
    description: 'face with rolling eyes',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😬',
    names: ['grimacing'],
    tags: [],
    description: 'grimacing face',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '😮‍💨',
  //   names: ['face_exhaling'],
  //   tags: [],
  //   description: 'face exhaling',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '🤥',
    names: ['lying_face'],
    tags: ['liar'],
    description: 'lying face',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🫨',
  //   names: ['shaking_face'],
  //   tags: ['shock'],
  //   description: 'shaking face',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '😌',
    names: ['relieved'],
    tags: ['whew'],
    description: 'relieved face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😔',
    names: ['pensive'],
    tags: [],
    description: 'pensive face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😪',
    names: ['sleepy'],
    tags: ['tired'],
    description: 'sleepy face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤤',
    names: ['drooling_face'],
    tags: [],
    description: 'drooling face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😴',
    names: ['sleeping'],
    tags: ['zzz'],
    description: 'sleeping face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😷',
    names: ['mask'],
    tags: ['sick', 'ill'],
    description: 'face with medical mask',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤒',
    names: ['face_with_thermometer'],
    tags: ['sick'],
    description: 'face with thermometer',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤕',
    names: ['face_with_head_bandage'],
    tags: ['hurt'],
    description: 'face with head-bandage',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤢',
    names: ['nauseated_face'],
    tags: ['sick', 'barf', 'disgusted'],
    description: 'nauseated face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤮',
    names: ['vomiting_face'],
    tags: ['barf', 'sick'],
    description: 'face vomiting',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤧',
    names: ['sneezing_face'],
    tags: ['achoo', 'sick'],
    description: 'sneezing face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🥵',
    names: ['hot_face'],
    tags: ['heat', 'sweating'],
    description: 'hot face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🥶',
    names: ['cold_face'],
    tags: ['freezing', 'ice'],
    description: 'cold face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🥴',
    names: ['woozy_face'],
    tags: ['groggy'],
    description: 'woozy face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😵',
    names: ['dizzy_face'],
    tags: [],
    description: 'face with crossed-out eyes',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '😵‍💫',
  //   names: ['face_with_spiral_eyes'],
  //   tags: [],
  //   description: 'face with spiral eyes',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '🤯',
    names: ['exploding_head'],
    tags: ['mind', 'blown'],
    description: 'exploding head',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤠',
    names: ['cowboy_hat_face'],
    tags: [],
    description: 'cowboy hat face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🥳',
    names: ['partying_face'],
    tags: ['celebration', 'birthday'],
    description: 'partying face',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🥸',
  //   names: ['disguised_face'],
  //   tags: [],
  //   description: 'disguised face',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '😎',
    names: ['sunglasses'],
    tags: ['cool'],
    description: 'smiling face with sunglasses',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤓',
    names: ['nerd_face'],
    tags: ['geek', 'glasses'],
    description: 'nerd face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🧐',
    names: ['monocle_face'],
    tags: [],
    description: 'face with monocle',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😕',
    names: ['confused'],
    tags: [],
    description: 'confused face',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🫤',
  //   names: ['face_with_diagonal_mouth'],
  //   tags: ['confused'],
  //   description: 'face with diagonal mouth',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '😟',
    names: ['worried'],
    tags: ['nervous'],
    description: 'worried face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🙁',
    names: ['slightly_frowning_face'],
    tags: [],
    description: 'slightly frowning face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '☹️',
    names: ['frowning_face'],
    tags: [],
    description: 'frowning face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😮',
    names: ['open_mouth'],
    tags: ['surprise', 'impressed', 'wow'],
    description: 'face with open mouth',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😯',
    names: ['hushed'],
    tags: ['silence', 'speechless'],
    description: 'hushed face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😲',
    names: ['astonished'],
    tags: ['amazed', 'gasp'],
    description: 'astonished face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😳',
    names: ['flushed'],
    tags: [],
    description: 'flushed face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🥺',
    names: ['pleading_face'],
    tags: ['puppy', 'eyes'],
    description: 'pleading face',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🥹',
  //   names: ['face_holding_back_tears'],
  //   tags: ['tears', 'gratitude'],
  //   description: 'face holding back tears',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '😦',
    names: ['frowning'],
    tags: [],
    description: 'frowning face with open mouth',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😧',
    names: ['anguished'],
    tags: ['stunned'],
    description: 'anguished face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😨',
    names: ['fearful'],
    tags: ['scared', 'shocked', 'oops'],
    description: 'fearful face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😰',
    names: ['cold_sweat'],
    tags: ['nervous'],
    description: 'anxious face with sweat',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😥',
    names: ['disappointed_relieved'],
    tags: ['phew', 'sweat', 'nervous'],
    description: 'sad but relieved face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😢',
    names: ['cry'],
    tags: ['sad', 'tear'],
    description: 'crying face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😭',
    names: ['sob'],
    tags: ['sad', 'cry', 'bawling'],
    description: 'loudly crying face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😱',
    names: ['scream'],
    tags: ['horror', 'shocked'],
    description: 'face screaming in fear',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😖',
    names: ['confounded'],
    tags: [],
    description: 'confounded face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😣',
    names: ['persevere'],
    tags: ['struggling'],
    description: 'persevering face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😞',
    names: ['disappointed'],
    tags: ['sad'],
    description: 'disappointed face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😓',
    names: ['sweat'],
    tags: [],
    description: 'downcast face with sweat',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😩',
    names: ['weary'],
    tags: ['tired'],
    description: 'weary face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😫',
    names: ['tired_face'],
    tags: ['upset', 'whine'],
    description: 'tired face',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🥱',
  //   names: ['yawning_face'],
  //   tags: [],
  //   description: 'yawning face',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '😤',
    names: ['triumph'],
    tags: ['smug'],
    description: 'face with steam from nose',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😡',
    names: ['rage', 'pout'],
    tags: ['angry'],
    description: 'enraged face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😠',
    names: ['angry'],
    tags: ['mad', 'annoyed'],
    description: 'angry face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤬',
    names: ['cursing_face'],
    tags: ['foul'],
    description: 'face with symbols on mouth',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😈',
    names: ['smiling_imp'],
    tags: ['devil', 'evil', 'horns'],
    description: 'smiling face with horns',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '👿',
    names: ['imp'],
    tags: ['angry', 'devil', 'evil', 'horns'],
    description: 'angry face with horns',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💀',
    names: ['skull'],
    tags: ['dead', 'danger', 'poison'],
    description: 'skull',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '☠️',
    names: ['skull_and_crossbones'],
    tags: ['danger', 'pirate'],
    description: 'skull and crossbones',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💩',
    names: ['hankey', 'poop', 'shit'],
    tags: ['crap'],
    description: 'pile of poo',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤡',
    names: ['clown_face'],
    tags: [],
    description: 'clown face',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '👹',
    names: ['japanese_ogre'],
    tags: ['monster'],
    description: 'ogre',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '👺',
    names: ['japanese_goblin'],
    tags: [],
    description: 'goblin',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '👻',
    names: ['ghost'],
    tags: ['halloween'],
    description: 'ghost',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '👽',
    names: ['alien'],
    tags: ['ufo'],
    description: 'alien',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '👾',
    names: ['space_invader'],
    tags: ['game', 'retro'],
    description: 'alien monster',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🤖',
    names: ['robot'],
    tags: [],
    description: 'robot',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😺',
    names: ['smiley_cat'],
    tags: [],
    description: 'grinning cat',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😸',
    names: ['smile_cat'],
    tags: [],
    description: 'grinning cat with smiling eyes',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😹',
    names: ['joy_cat'],
    tags: [],
    description: 'cat with tears of joy',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😻',
    names: ['heart_eyes_cat'],
    tags: [],
    description: 'smiling cat with heart-eyes',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😼',
    names: ['smirk_cat'],
    tags: [],
    description: 'cat with wry smile',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😽',
    names: ['kissing_cat'],
    tags: [],
    description: 'kissing cat',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🙀',
    names: ['scream_cat'],
    tags: ['horror'],
    description: 'weary cat',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😿',
    names: ['crying_cat_face'],
    tags: ['sad', 'tear'],
    description: 'crying cat',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '😾',
    names: ['pouting_cat'],
    tags: [],
    description: 'pouting cat',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🙈',
    names: ['see_no_evil'],
    tags: ['monkey', 'blind', 'ignore'],
    description: 'see-no-evil monkey',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🙉',
    names: ['hear_no_evil'],
    tags: ['monkey', 'deaf'],
    description: 'hear-no-evil monkey',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🙊',
    names: ['speak_no_evil'],
    tags: ['monkey', 'mute', 'hush'],
    description: 'speak-no-evil monkey',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💌',
    names: ['love_letter'],
    tags: ['email', 'envelope'],
    description: 'love letter',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💘',
    names: ['cupid'],
    tags: ['love', 'heart'],
    description: 'heart with arrow',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💝',
    names: ['gift_heart'],
    tags: ['chocolates'],
    description: 'heart with ribbon',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💖',
    names: ['sparkling_heart'],
    tags: [],
    description: 'sparkling heart',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💗',
    names: ['heartpulse'],
    tags: [],
    description: 'growing heart',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💓',
    names: ['heartbeat'],
    tags: [],
    description: 'beating heart',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💞',
    names: ['revolving_hearts'],
    tags: [],
    description: 'revolving hearts',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💕',
    names: ['two_hearts'],
    tags: [],
    description: 'two hearts',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💟',
    names: ['heart_decoration'],
    tags: [],
    description: 'heart decoration',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '❣️',
    names: ['heavy_heart_exclamation'],
    tags: [],
    description: 'heart exclamation',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💔',
    names: ['broken_heart'],
    tags: [],
    description: 'broken heart',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '❤️‍🔥',
  //   names: ['heart_on_fire'],
  //   tags: [],
  //   description: 'heart on fire',
  //   category: 'Smileys & Emotion'
  // },
  // {
  //   emoji: '❤️‍🩹',
  //   names: ['mending_heart'],
  //   tags: [],
  //   description: 'mending heart',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '❤️',
    names: ['heart'],
    tags: ['love'],
    description: 'red heart',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🩷',
  //   names: ['pink_heart'],
  //   tags: [],
  //   description: 'pink heart',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '🧡',
    names: ['orange_heart'],
    tags: [],
    description: 'orange heart',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💛',
    names: ['yellow_heart'],
    tags: [],
    description: 'yellow heart',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💚',
    names: ['green_heart'],
    tags: [],
    description: 'green heart',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💙',
    names: ['blue_heart'],
    tags: [],
    description: 'blue heart',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🩵',
  //   names: ['light_blue_heart'],
  //   tags: [],
  //   description: 'light blue heart',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '💜',
    names: ['purple_heart'],
    tags: [],
    description: 'purple heart',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🤎',
  //   names: ['brown_heart'],
  //   tags: [],
  //   description: 'brown heart',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '🖤',
    names: ['black_heart'],
    tags: [],
    description: 'black heart',
    category: 'Smileys & Emotion'
  },
  // {
  //   emoji: '🩶',
  //   names: ['grey_heart'],
  //   tags: [],
  //   description: 'grey heart',
  //   category: 'Smileys & Emotion'
  // },
  // {
  //   emoji: '🤍',
  //   names: ['white_heart'],
  //   tags: [],
  //   description: 'white heart',
  //   category: 'Smileys & Emotion'
  // },
  {
    emoji: '💋',
    names: ['kiss'],
    tags: ['lipstick'],
    description: 'kiss mark',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💯',
    names: ['100'],
    tags: ['score', 'perfect'],
    description: 'hundred points',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💢',
    names: ['anger'],
    tags: ['angry'],
    description: 'anger symbol',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💥',
    names: ['boom', 'collision'],
    tags: ['explode'],
    description: 'collision',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💫',
    names: ['dizzy'],
    tags: ['star'],
    description: 'dizzy',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💦',
    names: ['sweat_drops'],
    tags: ['water', 'workout'],
    description: 'sweat droplets',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💨',
    names: ['dash'],
    tags: ['wind', 'blow', 'fast'],
    description: 'dashing away',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🕳️',
    names: ['hole'],
    tags: [],
    description: 'hole',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💬',
    names: ['speech_balloon'],
    tags: ['comment'],
    description: 'speech balloon',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '👁️‍🗨️',
    names: ['eye_speech_bubble'],
    tags: [],
    description: 'eye in speech bubble',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🗨️',
    names: ['left_speech_bubble'],
    tags: [],
    description: 'left speech bubble',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '🗯️',
    names: ['right_anger_bubble'],
    tags: [],
    description: 'right anger bubble',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💭',
    names: ['thought_balloon'],
    tags: ['thinking'],
    description: 'thought balloon',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '💤',
    names: ['zzz'],
    tags: ['sleeping'],
    description: 'ZZZ',
    category: 'Smileys & Emotion'
  },
  {
    emoji: '👋',
    names: ['wave'],
    tags: ['goodbye'],
    description: 'waving hand',
    category: 'People & Body'
  },
  {
    emoji: '🤚',
    names: ['raised_back_of_hand'],
    tags: [],
    description: 'raised back of hand',
    category: 'People & Body'
  },
  {
    emoji: '🖐️',
    names: ['raised_hand_with_fingers_splayed'],
    tags: [],
    description: 'hand with fingers splayed',
    category: 'People & Body'
  },
  {
    emoji: '✋',
    names: ['hand', 'raised_hand'],
    tags: ['highfive', 'stop'],
    description: 'raised hand',
    category: 'People & Body'
  },
  {
    emoji: '🖖',
    names: ['vulcan_salute'],
    tags: ['prosper', 'spock'],
    description: 'vulcan salute',
    category: 'People & Body'
  },
  // {
  //   emoji: '🫱',
  //   names: ['rightwards_hand'],
  //   tags: [],
  //   description: 'rightwards hand',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🫲',
  //   names: ['leftwards_hand'],
  //   tags: [],
  //   description: 'leftwards hand',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🫳',
  //   names: ['palm_down_hand'],
  //   tags: [],
  //   description: 'palm down hand',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🫴',
  //   names: ['palm_up_hand'],
  //   tags: [],
  //   description: 'palm up hand',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🫷',
  //   names: ['leftwards_pushing_hand'],
  //   tags: [],
  //   description: 'leftwards pushing hand',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🫸',
  //   names: ['rightwards_pushing_hand'],
  //   tags: [],
  //   description: 'rightwards pushing hand',
  //   category: 'People & Body'
  // },
  {
    emoji: '👌',
    names: ['ok_hand'],
    tags: [],
    description: 'OK hand',
    category: 'People & Body'
  },
  // {
  //   emoji: '🤌',
  //   names: ['pinched_fingers'],
  //   tags: [],
  //   description: 'pinched fingers',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🤏',
  //   names: ['pinching_hand'],
  //   tags: [],
  //   description: 'pinching hand',
  //   category: 'People & Body'
  // },
  {
    emoji: '✌️',
    names: ['v'],
    tags: ['victory', 'peace'],
    description: 'victory hand',
    category: 'People & Body'
  },
  {
    emoji: '🤞',
    names: ['crossed_fingers'],
    tags: ['luck', 'hopeful'],
    description: 'crossed fingers',
    category: 'People & Body'
  },
  // {
  //   emoji: '🫰',
  //   names: ['hand_with_index_finger_and_thumb_crossed'],
  //   tags: [],
  //   description: 'hand with index finger and thumb crossed',
  //   category: 'People & Body'
  // },
  {
    emoji: '🤟',
    names: ['love_you_gesture'],
    tags: [],
    description: 'love-you gesture',
    category: 'People & Body'
  },
  {
    emoji: '🤘',
    names: ['metal'],
    tags: [],
    description: 'sign of the horns',
    category: 'People & Body'
  },
  {
    emoji: '🤙',
    names: ['call_me_hand'],
    tags: [],
    description: 'call me hand',
    category: 'People & Body'
  },
  {
    emoji: '👈',
    names: ['point_left'],
    tags: [],
    description: 'backhand index pointing left',
    category: 'People & Body'
  },
  {
    emoji: '👉',
    names: ['point_right'],
    tags: [],
    description: 'backhand index pointing right',
    category: 'People & Body'
  },
  {
    emoji: '👆',
    names: ['point_up_2'],
    tags: [],
    description: 'backhand index pointing up',
    category: 'People & Body'
  },
  {
    emoji: '🖕',
    names: ['middle_finger', 'fu'],
    tags: [],
    description: 'middle finger',
    category: 'People & Body'
  },
  {
    emoji: '👇',
    names: ['point_down'],
    tags: [],
    description: 'backhand index pointing down',
    category: 'People & Body'
  },
  {
    emoji: '☝️',
    names: ['point_up'],
    tags: [],
    description: 'index pointing up',
    category: 'People & Body'
  },
  // {
  //   emoji: '🫵',
  //   names: ['index_pointing_at_the_viewer'],
  //   tags: [],
  //   description: 'index pointing at the viewer',
  //   category: 'People & Body'
  // },
  {
    emoji: '👍',
    names: ['+1', 'thumbsup'],
    tags: ['approve', 'ok'],
    description: 'thumbs up',
    category: 'People & Body'
  },
  {
    emoji: '👎',
    names: ['-1', 'thumbsdown'],
    tags: ['disapprove', 'bury'],
    description: 'thumbs down',
    category: 'People & Body'
  },
  {
    emoji: '✊',
    names: ['fist_raised', 'fist'],
    tags: ['power'],
    description: 'raised fist',
    category: 'People & Body'
  },
  {
    emoji: '👊',
    names: ['fist_oncoming', 'facepunch', 'punch'],
    tags: ['attack'],
    description: 'oncoming fist',
    category: 'People & Body'
  },
  {
    emoji: '🤛',
    names: ['fist_left'],
    tags: [],
    description: 'left-facing fist',
    category: 'People & Body'
  },
  {
    emoji: '🤜',
    names: ['fist_right'],
    tags: [],
    description: 'right-facing fist',
    category: 'People & Body'
  },
  {
    emoji: '👏',
    names: ['clap'],
    tags: ['praise', 'applause'],
    description: 'clapping hands',
    category: 'People & Body'
  },
  {
    emoji: '🙌',
    names: ['raised_hands'],
    tags: ['hooray'],
    description: 'raising hands',
    category: 'People & Body'
  },
  // {
  //   emoji: '🫶',
  //   names: ['heart_hands'],
  //   tags: ['love'],
  //   description: 'heart hands',
  //   category: 'People & Body'
  // },
  {
    emoji: '👐',
    names: ['open_hands'],
    tags: [],
    description: 'open hands',
    category: 'People & Body'
  },
  {
    emoji: '🤲',
    names: ['palms_up_together'],
    tags: [],
    description: 'palms up together',
    category: 'People & Body'
  },
  {
    emoji: '🤝',
    names: ['handshake'],
    tags: ['deal'],
    description: 'handshake',
    category: 'People & Body'
  },
  {
    emoji: '🙏',
    names: ['pray'],
    tags: ['please', 'hope', 'wish'],
    description: 'folded hands',
    category: 'People & Body'
  },
  {
    emoji: '✍️',
    names: ['writing_hand'],
    tags: [],
    description: 'writing hand',
    category: 'People & Body'
  },
  {
    emoji: '💅',
    names: ['nail_care'],
    tags: ['beauty', 'manicure'],
    description: 'nail polish',
    category: 'People & Body'
  },
  {
    emoji: '🤳',
    names: ['selfie'],
    tags: [],
    description: 'selfie',
    category: 'People & Body'
  },
  {
    emoji: '💪',
    names: ['muscle'],
    tags: ['flex', 'bicep', 'strong', 'workout'],
    description: 'flexed biceps',
    category: 'People & Body'
  },
  // {
  //   emoji: '🦾',
  //   names: ['mechanical_arm'],
  //   tags: [],
  //   description: 'mechanical arm',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🦿',
  //   names: ['mechanical_leg'],
  //   tags: [],
  //   description: 'mechanical leg',
  //   category: 'People & Body'
  // },
  {
    emoji: '🦵',
    names: ['leg'],
    tags: [],
    description: 'leg',
    category: 'People & Body'
  },
  {
    emoji: '🦶',
    names: ['foot'],
    tags: [],
    description: 'foot',
    category: 'People & Body'
  },
  {
    emoji: '👂',
    names: ['ear'],
    tags: ['hear', 'sound', 'listen'],
    description: 'ear',
    category: 'People & Body'
  },
  // {
  //   emoji: '🦻',
  //   names: ['ear_with_hearing_aid'],
  //   tags: [],
  //   description: 'ear with hearing aid',
  //   category: 'People & Body'
  // },
  {
    emoji: '👃',
    names: ['nose'],
    tags: ['smell'],
    description: 'nose',
    category: 'People & Body'
  },
  {
    emoji: '🧠',
    names: ['brain'],
    tags: [],
    description: 'brain',
    category: 'People & Body'
  },
  // {
  //   emoji: '🫀',
  //   names: ['anatomical_heart'],
  //   tags: [],
  //   description: 'anatomical heart',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🫁',
  //   names: ['lungs'],
  //   tags: [],
  //   description: 'lungs',
  //   category: 'People & Body'
  // },
  {
    emoji: '🦷',
    names: ['tooth'],
    tags: [],
    description: 'tooth',
    category: 'People & Body'
  },
  {
    emoji: '🦴',
    names: ['bone'],
    tags: [],
    description: 'bone',
    category: 'People & Body'
  },
  {
    emoji: '👀',
    names: ['eyes'],
    tags: ['look', 'see', 'watch'],
    description: 'eyes',
    category: 'People & Body'
  },
  {
    emoji: '👁️',
    names: ['eye'],
    tags: [],
    description: 'eye',
    category: 'People & Body'
  },
  {
    emoji: '👅',
    names: ['tongue'],
    tags: ['taste'],
    description: 'tongue',
    category: 'People & Body'
  },
  {
    emoji: '👄',
    names: ['lips'],
    tags: ['kiss'],
    description: 'mouth',
    category: 'People & Body'
  },
  // {
  //   emoji: '🫦',
  //   names: ['biting_lip'],
  //   tags: [],
  //   description: 'biting lip',
  //   category: 'People & Body'
  // },
  {
    emoji: '👶',
    names: ['baby'],
    tags: ['child', 'newborn'],
    description: 'baby',
    category: 'People & Body'
  },
  {
    emoji: '🧒',
    names: ['child'],
    tags: [],
    description: 'child',
    category: 'People & Body'
  },
  {
    emoji: '👦',
    names: ['boy'],
    tags: ['child'],
    description: 'boy',
    category: 'People & Body'
  },
  {
    emoji: '👧',
    names: ['girl'],
    tags: ['child'],
    description: 'girl',
    category: 'People & Body'
  },
  {
    emoji: '🧑',
    names: ['adult'],
    tags: [],
    description: 'person',
    category: 'People & Body'
  },
  {
    emoji: '👱',
    names: ['blond_haired_person'],
    tags: [],
    description: 'person: blond hair',
    category: 'People & Body'
  },
  {
    emoji: '👨',
    names: ['man'],
    tags: ['mustache', 'father', 'dad'],
    description: 'man',
    category: 'People & Body'
  },
  {
    emoji: '🧔',
    names: ['bearded_person'],
    tags: [],
    description: 'person: beard',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧔‍♂️',
  //   names: ['man_beard'],
  //   tags: [],
  //   description: 'man: beard',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🧔‍♀️',
  //   names: ['woman_beard'],
  //   tags: [],
  //   description: 'woman: beard',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍🦰',
    names: ['red_haired_man'],
    tags: [],
    description: 'man: red hair',
    category: 'People & Body'
  },
  {
    emoji: '👨‍🦱',
    names: ['curly_haired_man'],
    tags: [],
    description: 'man: curly hair',
    category: 'People & Body'
  },
  {
    emoji: '👨‍🦳',
    names: ['white_haired_man'],
    tags: [],
    description: 'man: white hair',
    category: 'People & Body'
  },
  {
    emoji: '👨‍🦲',
    names: ['bald_man'],
    tags: [],
    description: 'man: bald',
    category: 'People & Body'
  },
  {
    emoji: '👩',
    names: ['woman'],
    tags: ['girls'],
    description: 'woman',
    category: 'People & Body'
  },
  {
    emoji: '👩‍🦰',
    names: ['red_haired_woman'],
    tags: [],
    description: 'woman: red hair',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🦰',
  //   names: ['person_red_hair'],
  //   tags: [],
  //   description: 'person: red hair',
  //   category: 'People & Body'
  // },
  {
    emoji: '👩‍🦱',
    names: ['curly_haired_woman'],
    tags: [],
    description: 'woman: curly hair',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🦱',
  //   names: ['person_curly_hair'],
  //   tags: [],
  //   description: 'person: curly hair',
  //   category: 'People & Body'
  // },
  {
    emoji: '👩‍🦳',
    names: ['white_haired_woman'],
    tags: [],
    description: 'woman: white hair',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🦳',
  //   names: ['person_white_hair'],
  //   tags: [],
  //   description: 'person: white hair',
  //   category: 'People & Body'
  // },
  {
    emoji: '👩‍🦲',
    names: ['bald_woman'],
    tags: [],
    description: 'woman: bald',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🦲',
  //   names: ['person_bald'],
  //   tags: [],
  //   description: 'person: bald',
  //   category: 'People & Body'
  // },
  {
    emoji: '👱‍♀️',
    names: ['blond_haired_woman', 'blonde_woman'],
    tags: [],
    description: 'woman: blond hair',
    category: 'People & Body'
  },
  {
    emoji: '👱‍♂️',
    names: ['blond_haired_man'],
    tags: [],
    description: 'man: blond hair',
    category: 'People & Body'
  },
  {
    emoji: '🧓',
    names: ['older_adult'],
    tags: [],
    description: 'older person',
    category: 'People & Body'
  },
  {
    emoji: '👴',
    names: ['older_man'],
    tags: [],
    description: 'old man',
    category: 'People & Body'
  },
  {
    emoji: '👵',
    names: ['older_woman'],
    tags: [],
    description: 'old woman',
    category: 'People & Body'
  },
  {
    emoji: '🙍',
    names: ['frowning_person'],
    tags: [],
    description: 'person frowning',
    category: 'People & Body'
  },
  {
    emoji: '🙍‍♂️',
    names: ['frowning_man'],
    tags: [],
    description: 'man frowning',
    category: 'People & Body'
  },
  {
    emoji: '🙍‍♀️',
    names: ['frowning_woman'],
    tags: [],
    description: 'woman frowning',
    category: 'People & Body'
  },
  {
    emoji: '🙎',
    names: ['pouting_face'],
    tags: [],
    description: 'person pouting',
    category: 'People & Body'
  },
  {
    emoji: '🙎‍♂️',
    names: ['pouting_man'],
    tags: [],
    description: 'man pouting',
    category: 'People & Body'
  },
  {
    emoji: '🙎‍♀️',
    names: ['pouting_woman'],
    tags: [],
    description: 'woman pouting',
    category: 'People & Body'
  },
  {
    emoji: '🙅',
    names: ['no_good'],
    tags: ['stop', 'halt', 'denied'],
    description: 'person gesturing NO',
    category: 'People & Body'
  },
  {
    emoji: '🙅‍♂️',
    names: ['no_good_man', 'ng_man'],
    tags: ['stop', 'halt', 'denied'],
    description: 'man gesturing NO',
    category: 'People & Body'
  },
  {
    emoji: '🙅‍♀️',
    names: ['no_good_woman', 'ng_woman'],
    tags: ['stop', 'halt', 'denied'],
    description: 'woman gesturing NO',
    category: 'People & Body'
  },
  {
    emoji: '🙆',
    names: ['ok_person'],
    tags: [],
    description: 'person gesturing OK',
    category: 'People & Body'
  },
  {
    emoji: '🙆‍♂️',
    names: ['ok_man'],
    tags: [],
    description: 'man gesturing OK',
    category: 'People & Body'
  },
  {
    emoji: '🙆‍♀️',
    names: ['ok_woman'],
    tags: [],
    description: 'woman gesturing OK',
    category: 'People & Body'
  },
  {
    emoji: '💁',
    names: ['tipping_hand_person', 'information_desk_person'],
    tags: [],
    description: 'person tipping hand',
    category: 'People & Body'
  },
  {
    emoji: '💁‍♂️',
    names: ['tipping_hand_man', 'sassy_man'],
    tags: ['information'],
    description: 'man tipping hand',
    category: 'People & Body'
  },
  {
    emoji: '💁‍♀️',
    names: ['tipping_hand_woman', 'sassy_woman'],
    tags: ['information'],
    description: 'woman tipping hand',
    category: 'People & Body'
  },
  {
    emoji: '🙋',
    names: ['raising_hand'],
    tags: [],
    description: 'person raising hand',
    category: 'People & Body'
  },
  {
    emoji: '🙋‍♂️',
    names: ['raising_hand_man'],
    tags: [],
    description: 'man raising hand',
    category: 'People & Body'
  },
  {
    emoji: '🙋‍♀️',
    names: ['raising_hand_woman'],
    tags: [],
    description: 'woman raising hand',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧏',
  //   names: ['deaf_person'],
  //   tags: [],
  //   description: 'deaf person',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🧏‍♂️',
  //   names: ['deaf_man'],
  //   tags: [],
  //   description: 'deaf man',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🧏‍♀️',
  //   names: ['deaf_woman'],
  //   tags: [],
  //   description: 'deaf woman',
  //   category: 'People & Body'
  // },
  {
    emoji: '🙇',
    names: ['bow'],
    tags: ['respect', 'thanks'],
    description: 'person bowing',
    category: 'People & Body'
  },
  {
    emoji: '🙇‍♂️',
    names: ['bowing_man'],
    tags: ['respect', 'thanks'],
    description: 'man bowing',
    category: 'People & Body'
  },
  {
    emoji: '🙇‍♀️',
    names: ['bowing_woman'],
    tags: ['respect', 'thanks'],
    description: 'woman bowing',
    category: 'People & Body'
  },
  {
    emoji: '🤦',
    names: ['facepalm'],
    tags: [],
    description: 'person facepalming',
    category: 'People & Body'
  },
  {
    emoji: '🤦‍♂️',
    names: ['man_facepalming'],
    tags: [],
    description: 'man facepalming',
    category: 'People & Body'
  },
  {
    emoji: '🤦‍♀️',
    names: ['woman_facepalming'],
    tags: [],
    description: 'woman facepalming',
    category: 'People & Body'
  },
  {
    emoji: '🤷',
    names: ['shrug'],
    tags: [],
    description: 'person shrugging',
    category: 'People & Body'
  },
  {
    emoji: '🤷‍♂️',
    names: ['man_shrugging'],
    tags: [],
    description: 'man shrugging',
    category: 'People & Body'
  },
  {
    emoji: '🤷‍♀️',
    names: ['woman_shrugging'],
    tags: [],
    description: 'woman shrugging',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍⚕️',
  //   names: ['health_worker'],
  //   tags: [],
  //   description: 'health worker',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍⚕️',
    names: ['man_health_worker'],
    tags: ['doctor', 'nurse'],
    description: 'man health worker',
    category: 'People & Body'
  },
  {
    emoji: '👩‍⚕️',
    names: ['woman_health_worker'],
    tags: ['doctor', 'nurse'],
    description: 'woman health worker',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🎓',
  //   names: ['student'],
  //   tags: [],
  //   description: 'student',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍🎓',
    names: ['man_student'],
    tags: ['graduation'],
    description: 'man student',
    category: 'People & Body'
  },
  {
    emoji: '👩‍🎓',
    names: ['woman_student'],
    tags: ['graduation'],
    description: 'woman student',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🏫',
  //   names: ['teacher'],
  //   tags: [],
  //   description: 'teacher',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍🏫',
    names: ['man_teacher'],
    tags: ['school', 'professor'],
    description: 'man teacher',
    category: 'People & Body'
  },
  {
    emoji: '👩‍🏫',
    names: ['woman_teacher'],
    tags: ['school', 'professor'],
    description: 'woman teacher',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍⚖️',
  //   names: ['judge'],
  //   tags: [],
  //   description: 'judge',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍⚖️',
    names: ['man_judge'],
    tags: ['justice'],
    description: 'man judge',
    category: 'People & Body'
  },
  {
    emoji: '👩‍⚖️',
    names: ['woman_judge'],
    tags: ['justice'],
    description: 'woman judge',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🌾',
  //   names: ['farmer'],
  //   tags: [],
  //   description: 'farmer',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍🌾',
    names: ['man_farmer'],
    tags: [],
    description: 'man farmer',
    category: 'People & Body'
  },
  {
    emoji: '👩‍🌾',
    names: ['woman_farmer'],
    tags: [],
    description: 'woman farmer',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🍳',
  //   names: ['cook'],
  //   tags: [],
  //   description: 'cook',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍🍳',
    names: ['man_cook'],
    tags: ['chef'],
    description: 'man cook',
    category: 'People & Body'
  },
  {
    emoji: '👩‍🍳',
    names: ['woman_cook'],
    tags: ['chef'],
    description: 'woman cook',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🔧',
  //   names: ['mechanic'],
  //   tags: [],
  //   description: 'mechanic',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍🔧',
    names: ['man_mechanic'],
    tags: [],
    description: 'man mechanic',
    category: 'People & Body'
  },
  {
    emoji: '👩‍🔧',
    names: ['woman_mechanic'],
    tags: [],
    description: 'woman mechanic',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🏭',
  //   names: ['factory_worker'],
  //   tags: [],
  //   description: 'factory worker',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍🏭',
    names: ['man_factory_worker'],
    tags: [],
    description: 'man factory worker',
    category: 'People & Body'
  },
  {
    emoji: '👩‍🏭',
    names: ['woman_factory_worker'],
    tags: [],
    description: 'woman factory worker',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍💼',
  //   names: ['office_worker'],
  //   tags: [],
  //   description: 'office worker',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍💼',
    names: ['man_office_worker'],
    tags: ['business'],
    description: 'man office worker',
    category: 'People & Body'
  },
  {
    emoji: '👩‍💼',
    names: ['woman_office_worker'],
    tags: ['business'],
    description: 'woman office worker',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🔬',
  //   names: ['scientist'],
  //   tags: [],
  //   description: 'scientist',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍🔬',
    names: ['man_scientist'],
    tags: ['research'],
    description: 'man scientist',
    category: 'People & Body'
  },
  {
    emoji: '👩‍🔬',
    names: ['woman_scientist'],
    tags: ['research'],
    description: 'woman scientist',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍💻',
  //   names: ['technologist'],
  //   tags: [],
  //   description: 'technologist',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍💻',
    names: ['man_technologist'],
    tags: ['coder'],
    description: 'man technologist',
    category: 'People & Body'
  },
  {
    emoji: '👩‍💻',
    names: ['woman_technologist'],
    tags: ['coder'],
    description: 'woman technologist',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🎤',
  //   names: ['singer'],
  //   tags: [],
  //   description: 'singer',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍🎤',
    names: ['man_singer'],
    tags: ['rockstar'],
    description: 'man singer',
    category: 'People & Body'
  },
  {
    emoji: '👩‍🎤',
    names: ['woman_singer'],
    tags: ['rockstar'],
    description: 'woman singer',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🎨',
  //   names: ['artist'],
  //   tags: [],
  //   description: 'artist',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍🎨',
    names: ['man_artist'],
    tags: ['painter'],
    description: 'man artist',
    category: 'People & Body'
  },
  {
    emoji: '👩‍🎨',
    names: ['woman_artist'],
    tags: ['painter'],
    description: 'woman artist',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍✈️',
  //   names: ['pilot'],
  //   tags: [],
  //   description: 'pilot',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍✈️',
    names: ['man_pilot'],
    tags: [],
    description: 'man pilot',
    category: 'People & Body'
  },
  {
    emoji: '👩‍✈️',
    names: ['woman_pilot'],
    tags: [],
    description: 'woman pilot',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🚀',
  //   names: ['astronaut'],
  //   tags: [],
  //   description: 'astronaut',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍🚀',
    names: ['man_astronaut'],
    tags: ['space'],
    description: 'man astronaut',
    category: 'People & Body'
  },
  {
    emoji: '👩‍🚀',
    names: ['woman_astronaut'],
    tags: ['space'],
    description: 'woman astronaut',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🚒',
  //   names: ['firefighter'],
  //   tags: [],
  //   description: 'firefighter',
  //   category: 'People & Body'
  // },
  {
    emoji: '👨‍🚒',
    names: ['man_firefighter'],
    tags: [],
    description: 'man firefighter',
    category: 'People & Body'
  },
  {
    emoji: '👩‍🚒',
    names: ['woman_firefighter'],
    tags: [],
    description: 'woman firefighter',
    category: 'People & Body'
  },
  {
    emoji: '👮',
    names: ['police_officer', 'cop'],
    tags: ['law'],
    description: 'police officer',
    category: 'People & Body'
  },
  {
    emoji: '👮‍♂️',
    names: ['policeman'],
    tags: ['law', 'cop'],
    description: 'man police officer',
    category: 'People & Body'
  },
  {
    emoji: '👮‍♀️',
    names: ['policewoman'],
    tags: ['law', 'cop'],
    description: 'woman police officer',
    category: 'People & Body'
  },
  {
    emoji: '🕵️',
    names: ['detective'],
    tags: ['sleuth'],
    description: 'detective',
    category: 'People & Body'
  },
  {
    emoji: '🕵️‍♂️',
    names: ['male_detective'],
    tags: ['sleuth'],
    description: 'man detective',
    category: 'People & Body'
  },
  {
    emoji: '🕵️‍♀️',
    names: ['female_detective'],
    tags: ['sleuth'],
    description: 'woman detective',
    category: 'People & Body'
  },
  {
    emoji: '💂',
    names: ['guard'],
    tags: [],
    description: 'guard',
    category: 'People & Body'
  },
  {
    emoji: '💂‍♂️',
    names: ['guardsman'],
    tags: [],
    description: 'man guard',
    category: 'People & Body'
  },
  {
    emoji: '💂‍♀️',
    names: ['guardswoman'],
    tags: [],
    description: 'woman guard',
    category: 'People & Body'
  },
  // {
  //   emoji: '🥷',
  //   names: ['ninja'],
  //   tags: [],
  //   description: 'ninja',
  //   category: 'People & Body'
  // },
  {
    emoji: '👷',
    names: ['construction_worker'],
    tags: ['helmet'],
    description: 'construction worker',
    category: 'People & Body'
  },
  {
    emoji: '👷‍♂️',
    names: ['construction_worker_man'],
    tags: ['helmet'],
    description: 'man construction worker',
    category: 'People & Body'
  },
  {
    emoji: '👷‍♀️',
    names: ['construction_worker_woman'],
    tags: ['helmet'],
    description: 'woman construction worker',
    category: 'People & Body'
  },
  // {
  //   emoji: '🫅',
  //   names: ['person_with_crown'],
  //   tags: [],
  //   description: 'person with crown',
  //   category: 'People & Body'
  // },
  {
    emoji: '🤴',
    names: ['prince'],
    tags: ['crown', 'royal'],
    description: 'prince',
    category: 'People & Body'
  },
  {
    emoji: '👸',
    names: ['princess'],
    tags: ['crown', 'royal'],
    description: 'princess',
    category: 'People & Body'
  },
  {
    emoji: '👳',
    names: ['person_with_turban'],
    tags: [],
    description: 'person wearing turban',
    category: 'People & Body'
  },
  {
    emoji: '👳‍♂️',
    names: ['man_with_turban'],
    tags: [],
    description: 'man wearing turban',
    category: 'People & Body'
  },
  {
    emoji: '👳‍♀️',
    names: ['woman_with_turban'],
    tags: [],
    description: 'woman wearing turban',
    category: 'People & Body'
  },
  {
    emoji: '👲',
    names: ['man_with_gua_pi_mao'],
    tags: [],
    description: 'person with skullcap',
    category: 'People & Body'
  },
  {
    emoji: '🧕',
    names: ['woman_with_headscarf'],
    tags: ['hijab'],
    description: 'woman with headscarf',
    category: 'People & Body'
  },
  {
    emoji: '🤵',
    names: ['person_in_tuxedo'],
    tags: ['groom', 'marriage', 'wedding'],
    description: 'person in tuxedo',
    category: 'People & Body'
  },
  // {
  //   emoji: '🤵‍♂️',
  //   names: ['man_in_tuxedo'],
  //   tags: [],
  //   description: 'man in tuxedo',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🤵‍♀️',
  //   names: ['woman_in_tuxedo'],
  //   tags: [],
  //   description: 'woman in tuxedo',
  //   category: 'People & Body'
  // },
  {
    emoji: '👰',
    names: ['person_with_veil'],
    tags: ['marriage', 'wedding'],
    description: 'person with veil',
    category: 'People & Body'
  },
  // {
  //   emoji: '👰‍♂️',
  //   names: ['man_with_veil'],
  //   tags: [],
  //   description: 'man with veil',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '👰‍♀️',
  //   names: ['woman_with_veil', 'bride_with_veil'],
  //   tags: [],
  //   description: 'woman with veil',
  //   category: 'People & Body'
  // },
  {
    emoji: '🤰',
    names: ['pregnant_woman'],
    tags: [],
    description: 'pregnant woman',
    category: 'People & Body'
  },
  // {
  //   emoji: '🫃',
  //   names: ['pregnant_man'],
  //   tags: [],
  //   description: 'pregnant man',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🫄',
  //   names: ['pregnant_person'],
  //   tags: [],
  //   description: 'pregnant person',
  //   category: 'People & Body'
  // },
  {
    emoji: '🤱',
    names: ['breast_feeding'],
    tags: ['nursing'],
    description: 'breast-feeding',
    category: 'People & Body'
  },
  // {
  //   emoji: '👩‍🍼',
  //   names: ['woman_feeding_baby'],
  //   tags: [],
  //   description: 'woman feeding baby',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '👨‍🍼',
  //   names: ['man_feeding_baby'],
  //   tags: [],
  //   description: 'man feeding baby',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🧑‍🍼',
  //   names: ['person_feeding_baby'],
  //   tags: [],
  //   description: 'person feeding baby',
  //   category: 'People & Body'
  // },
  {
    emoji: '👼',
    names: ['angel'],
    tags: [],
    description: 'baby angel',
    category: 'People & Body'
  },
  {
    emoji: '🎅',
    names: ['santa'],
    tags: ['christmas'],
    description: 'Santa Claus',
    category: 'People & Body'
  },
  {
    emoji: '🤶',
    names: ['mrs_claus'],
    tags: ['santa'],
    description: 'Mrs. Claus',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🎄',
  //   names: ['mx_claus'],
  //   tags: [],
  //   description: 'mx claus',
  //   category: 'People & Body'
  // },
  {
    emoji: '🦸',
    names: ['superhero'],
    tags: [],
    description: 'superhero',
    category: 'People & Body'
  },
  {
    emoji: '🦸‍♂️',
    names: ['superhero_man'],
    tags: [],
    description: 'man superhero',
    category: 'People & Body'
  },
  {
    emoji: '🦸‍♀️',
    names: ['superhero_woman'],
    tags: [],
    description: 'woman superhero',
    category: 'People & Body'
  },
  {
    emoji: '🦹',
    names: ['supervillain'],
    tags: [],
    description: 'supervillain',
    category: 'People & Body'
  },
  {
    emoji: '🦹‍♂️',
    names: ['supervillain_man'],
    tags: [],
    description: 'man supervillain',
    category: 'People & Body'
  },
  {
    emoji: '🦹‍♀️',
    names: ['supervillain_woman'],
    tags: [],
    description: 'woman supervillain',
    category: 'People & Body'
  },
  {
    emoji: '🧙',
    names: ['mage'],
    tags: ['wizard'],
    description: 'mage',
    category: 'People & Body'
  },
  {
    emoji: '🧙‍♂️',
    names: ['mage_man'],
    tags: ['wizard'],
    description: 'man mage',
    category: 'People & Body'
  },
  {
    emoji: '🧙‍♀️',
    names: ['mage_woman'],
    tags: ['wizard'],
    description: 'woman mage',
    category: 'People & Body'
  },
  {
    emoji: '🧚',
    names: ['fairy'],
    tags: [],
    description: 'fairy',
    category: 'People & Body'
  },
  {
    emoji: '🧚‍♂️',
    names: ['fairy_man'],
    tags: [],
    description: 'man fairy',
    category: 'People & Body'
  },
  {
    emoji: '🧚‍♀️',
    names: ['fairy_woman'],
    tags: [],
    description: 'woman fairy',
    category: 'People & Body'
  },
  {
    emoji: '🧛',
    names: ['vampire'],
    tags: [],
    description: 'vampire',
    category: 'People & Body'
  },
  {
    emoji: '🧛‍♂️',
    names: ['vampire_man'],
    tags: [],
    description: 'man vampire',
    category: 'People & Body'
  },
  {
    emoji: '🧛‍♀️',
    names: ['vampire_woman'],
    tags: [],
    description: 'woman vampire',
    category: 'People & Body'
  },
  {
    emoji: '🧜',
    names: ['merperson'],
    tags: [],
    description: 'merperson',
    category: 'People & Body'
  },
  {
    emoji: '🧜‍♂️',
    names: ['merman'],
    tags: [],
    description: 'merman',
    category: 'People & Body'
  },
  {
    emoji: '🧜‍♀️',
    names: ['mermaid'],
    tags: [],
    description: 'mermaid',
    category: 'People & Body'
  },
  {
    emoji: '🧝',
    names: ['elf'],
    tags: [],
    description: 'elf',
    category: 'People & Body'
  },
  {
    emoji: '🧝‍♂️',
    names: ['elf_man'],
    tags: [],
    description: 'man elf',
    category: 'People & Body'
  },
  {
    emoji: '🧝‍♀️',
    names: ['elf_woman'],
    tags: [],
    description: 'woman elf',
    category: 'People & Body'
  },
  {
    emoji: '🧞',
    names: ['genie'],
    tags: [],
    description: 'genie',
    category: 'People & Body'
  },
  {
    emoji: '🧞‍♂️',
    names: ['genie_man'],
    tags: [],
    description: 'man genie',
    category: 'People & Body'
  },
  {
    emoji: '🧞‍♀️',
    names: ['genie_woman'],
    tags: [],
    description: 'woman genie',
    category: 'People & Body'
  },
  {
    emoji: '🧟',
    names: ['zombie'],
    tags: [],
    description: 'zombie',
    category: 'People & Body'
  },
  {
    emoji: '🧟‍♂️',
    names: ['zombie_man'],
    tags: [],
    description: 'man zombie',
    category: 'People & Body'
  },
  {
    emoji: '🧟‍♀️',
    names: ['zombie_woman'],
    tags: [],
    description: 'woman zombie',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧌',
  //   names: ['troll'],
  //   tags: [],
  //   description: 'troll',
  //   category: 'People & Body'
  // },
  {
    emoji: '💆',
    names: ['massage'],
    tags: ['spa'],
    description: 'person getting massage',
    category: 'People & Body'
  },
  {
    emoji: '💆‍♂️',
    names: ['massage_man'],
    tags: ['spa'],
    description: 'man getting massage',
    category: 'People & Body'
  },
  {
    emoji: '💆‍♀️',
    names: ['massage_woman'],
    tags: ['spa'],
    description: 'woman getting massage',
    category: 'People & Body'
  },
  {
    emoji: '💇',
    names: ['haircut'],
    tags: ['beauty'],
    description: 'person getting haircut',
    category: 'People & Body'
  },
  {
    emoji: '💇‍♂️',
    names: ['haircut_man'],
    tags: [],
    description: 'man getting haircut',
    category: 'People & Body'
  },
  {
    emoji: '💇‍♀️',
    names: ['haircut_woman'],
    tags: [],
    description: 'woman getting haircut',
    category: 'People & Body'
  },
  {
    emoji: '🚶',
    names: ['walking'],
    tags: [],
    description: 'person walking',
    category: 'People & Body'
  },
  {
    emoji: '🚶‍♂️',
    names: ['walking_man'],
    tags: [],
    description: 'man walking',
    category: 'People & Body'
  },
  {
    emoji: '🚶‍♀️',
    names: ['walking_woman'],
    tags: [],
    description: 'woman walking',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧍',
  //   names: ['standing_person'],
  //   tags: [],
  //   description: 'person standing',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🧍‍♂️',
  //   names: ['standing_man'],
  //   tags: [],
  //   description: 'man standing',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🧍‍♀️',
  //   names: ['standing_woman'],
  //   tags: [],
  //   description: 'woman standing',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🧎',
  //   names: ['kneeling_person'],
  //   tags: [],
  //   description: 'person kneeling',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🧎‍♂️',
  //   names: ['kneeling_man'],
  //   tags: [],
  //   description: 'man kneeling',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🧎‍♀️',
  //   names: ['kneeling_woman'],
  //   tags: [],
  //   description: 'woman kneeling',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🧑‍🦯',
  //   names: ['person_with_probing_cane'],
  //   tags: [],
  //   description: 'person with white cane',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '👨‍🦯',
  //   names: ['man_with_probing_cane'],
  //   tags: [],
  //   description: 'man with white cane',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '👩‍🦯',
  //   names: ['woman_with_probing_cane'],
  //   tags: [],
  //   description: 'woman with white cane',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🧑‍🦼',
  //   names: ['person_in_motorized_wheelchair'],
  //   tags: [],
  //   description: 'person in motorized wheelchair',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '👨‍🦼',
  //   names: ['man_in_motorized_wheelchair'],
  //   tags: [],
  //   description: 'man in motorized wheelchair',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '👩‍🦼',
  //   names: ['woman_in_motorized_wheelchair'],
  //   tags: [],
  //   description: 'woman in motorized wheelchair',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '🧑‍🦽',
  //   names: ['person_in_manual_wheelchair'],
  //   tags: [],
  //   description: 'person in manual wheelchair',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '👨‍🦽',
  //   names: ['man_in_manual_wheelchair'],
  //   tags: [],
  //   description: 'man in manual wheelchair',
  //   category: 'People & Body'
  // },
  // {
  //   emoji: '👩‍🦽',
  //   names: ['woman_in_manual_wheelchair'],
  //   tags: [],
  //   description: 'woman in manual wheelchair',
  //   category: 'People & Body'
  // },
  {
    emoji: '🏃',
    names: ['runner', 'running'],
    tags: ['exercise', 'workout', 'marathon'],
    description: 'person running',
    category: 'People & Body'
  },
  {
    emoji: '🏃‍♂️',
    names: ['running_man'],
    tags: ['exercise', 'workout', 'marathon'],
    description: 'man running',
    category: 'People & Body'
  },
  {
    emoji: '🏃‍♀️',
    names: ['running_woman'],
    tags: ['exercise', 'workout', 'marathon'],
    description: 'woman running',
    category: 'People & Body'
  },
  {
    emoji: '💃',
    names: ['woman_dancing', 'dancer'],
    tags: ['dress'],
    description: 'woman dancing',
    category: 'People & Body'
  },
  {
    emoji: '🕺',
    names: ['man_dancing'],
    tags: ['dancer'],
    description: 'man dancing',
    category: 'People & Body'
  },
  {
    emoji: '🕴️',
    names: ['business_suit_levitating'],
    tags: [],
    description: 'person in suit levitating',
    category: 'People & Body'
  },
  {
    emoji: '👯',
    names: ['dancers'],
    tags: ['bunny'],
    description: 'people with bunny ears',
    category: 'People & Body'
  },
  {
    emoji: '👯‍♂️',
    names: ['dancing_men'],
    tags: ['bunny'],
    description: 'men with bunny ears',
    category: 'People & Body'
  },
  {
    emoji: '👯‍♀️',
    names: ['dancing_women'],
    tags: ['bunny'],
    description: 'women with bunny ears',
    category: 'People & Body'
  },
  {
    emoji: '🧖',
    names: ['sauna_person'],
    tags: ['steamy'],
    description: 'person in steamy room',
    category: 'People & Body'
  },
  {
    emoji: '🧖‍♂️',
    names: ['sauna_man'],
    tags: ['steamy'],
    description: 'man in steamy room',
    category: 'People & Body'
  },
  {
    emoji: '🧖‍♀️',
    names: ['sauna_woman'],
    tags: ['steamy'],
    description: 'woman in steamy room',
    category: 'People & Body'
  },
  {
    emoji: '🧗',
    names: ['climbing'],
    tags: ['bouldering'],
    description: 'person climbing',
    category: 'People & Body'
  },
  {
    emoji: '🧗‍♂️',
    names: ['climbing_man'],
    tags: ['bouldering'],
    description: 'man climbing',
    category: 'People & Body'
  },
  {
    emoji: '🧗‍♀️',
    names: ['climbing_woman'],
    tags: ['bouldering'],
    description: 'woman climbing',
    category: 'People & Body'
  },
  {
    emoji: '🤺',
    names: ['person_fencing'],
    tags: [],
    description: 'person fencing',
    category: 'People & Body'
  },
  {
    emoji: '🏇',
    names: ['horse_racing'],
    tags: [],
    description: 'horse racing',
    category: 'People & Body'
  },
  {
    emoji: '⛷️',
    names: ['skier'],
    tags: [],
    description: 'skier',
    category: 'People & Body'
  },
  {
    emoji: '🏂',
    names: ['snowboarder'],
    tags: [],
    description: 'snowboarder',
    category: 'People & Body'
  },
  {
    emoji: '🏌️',
    names: ['golfing'],
    tags: [],
    description: 'person golfing',
    category: 'People & Body'
  },
  {
    emoji: '🏌️‍♂️',
    names: ['golfing_man'],
    tags: [],
    description: 'man golfing',
    category: 'People & Body'
  },
  {
    emoji: '🏌️‍♀️',
    names: ['golfing_woman'],
    tags: [],
    description: 'woman golfing',
    category: 'People & Body'
  },
  {
    emoji: '🏄',
    names: ['surfer'],
    tags: [],
    description: 'person surfing',
    category: 'People & Body'
  },
  {
    emoji: '🏄‍♂️',
    names: ['surfing_man'],
    tags: [],
    description: 'man surfing',
    category: 'People & Body'
  },
  {
    emoji: '🏄‍♀️',
    names: ['surfing_woman'],
    tags: [],
    description: 'woman surfing',
    category: 'People & Body'
  },
  {
    emoji: '🚣',
    names: ['rowboat'],
    tags: [],
    description: 'person rowing boat',
    category: 'People & Body'
  },
  {
    emoji: '🚣‍♂️',
    names: ['rowing_man'],
    tags: [],
    description: 'man rowing boat',
    category: 'People & Body'
  },
  {
    emoji: '🚣‍♀️',
    names: ['rowing_woman'],
    tags: [],
    description: 'woman rowing boat',
    category: 'People & Body'
  },
  {
    emoji: '🏊',
    names: ['swimmer'],
    tags: [],
    description: 'person swimming',
    category: 'People & Body'
  },
  {
    emoji: '🏊‍♂️',
    names: ['swimming_man'],
    tags: [],
    description: 'man swimming',
    category: 'People & Body'
  },
  {
    emoji: '🏊‍♀️',
    names: ['swimming_woman'],
    tags: [],
    description: 'woman swimming',
    category: 'People & Body'
  },
  {
    emoji: '⛹️',
    names: ['bouncing_ball_person'],
    tags: ['basketball'],
    description: 'person bouncing ball',
    category: 'People & Body'
  },
  {
    emoji: '⛹️‍♂️',
    names: ['bouncing_ball_man', 'basketball_man'],
    tags: [],
    description: 'man bouncing ball',
    category: 'People & Body'
  },
  {
    emoji: '⛹️‍♀️',
    names: ['bouncing_ball_woman', 'basketball_woman'],
    tags: [],
    description: 'woman bouncing ball',
    category: 'People & Body'
  },
  {
    emoji: '🏋️',
    names: ['weight_lifting'],
    tags: ['gym', 'workout'],
    description: 'person lifting weights',
    category: 'People & Body'
  },
  {
    emoji: '🏋️‍♂️',
    names: ['weight_lifting_man'],
    tags: ['gym', 'workout'],
    description: 'man lifting weights',
    category: 'People & Body'
  },
  {
    emoji: '🏋️‍♀️',
    names: ['weight_lifting_woman'],
    tags: ['gym', 'workout'],
    description: 'woman lifting weights',
    category: 'People & Body'
  },
  {
    emoji: '🚴',
    names: ['bicyclist'],
    tags: [],
    description: 'person biking',
    category: 'People & Body'
  },
  {
    emoji: '🚴‍♂️',
    names: ['biking_man'],
    tags: [],
    description: 'man biking',
    category: 'People & Body'
  },
  {
    emoji: '🚴‍♀️',
    names: ['biking_woman'],
    tags: [],
    description: 'woman biking',
    category: 'People & Body'
  },
  {
    emoji: '🚵',
    names: ['mountain_bicyclist'],
    tags: [],
    description: 'person mountain biking',
    category: 'People & Body'
  },
  {
    emoji: '🚵‍♂️',
    names: ['mountain_biking_man'],
    tags: [],
    description: 'man mountain biking',
    category: 'People & Body'
  },
  {
    emoji: '🚵‍♀️',
    names: ['mountain_biking_woman'],
    tags: [],
    description: 'woman mountain biking',
    category: 'People & Body'
  },
  {
    emoji: '🤸',
    names: ['cartwheeling'],
    tags: [],
    description: 'person cartwheeling',
    category: 'People & Body'
  },
  {
    emoji: '🤸‍♂️',
    names: ['man_cartwheeling'],
    tags: [],
    description: 'man cartwheeling',
    category: 'People & Body'
  },
  {
    emoji: '🤸‍♀️',
    names: ['woman_cartwheeling'],
    tags: [],
    description: 'woman cartwheeling',
    category: 'People & Body'
  },
  {
    emoji: '🤼',
    names: ['wrestling'],
    tags: [],
    description: 'people wrestling',
    category: 'People & Body'
  },
  {
    emoji: '🤼‍♂️',
    names: ['men_wrestling'],
    tags: [],
    description: 'men wrestling',
    category: 'People & Body'
  },
  {
    emoji: '🤼‍♀️',
    names: ['women_wrestling'],
    tags: [],
    description: 'women wrestling',
    category: 'People & Body'
  },
  {
    emoji: '🤽',
    names: ['water_polo'],
    tags: [],
    description: 'person playing water polo',
    category: 'People & Body'
  },
  {
    emoji: '🤽‍♂️',
    names: ['man_playing_water_polo'],
    tags: [],
    description: 'man playing water polo',
    category: 'People & Body'
  },
  {
    emoji: '🤽‍♀️',
    names: ['woman_playing_water_polo'],
    tags: [],
    description: 'woman playing water polo',
    category: 'People & Body'
  },
  {
    emoji: '🤾',
    names: ['handball_person'],
    tags: [],
    description: 'person playing handball',
    category: 'People & Body'
  },
  {
    emoji: '🤾‍♂️',
    names: ['man_playing_handball'],
    tags: [],
    description: 'man playing handball',
    category: 'People & Body'
  },
  {
    emoji: '🤾‍♀️',
    names: ['woman_playing_handball'],
    tags: [],
    description: 'woman playing handball',
    category: 'People & Body'
  },
  {
    emoji: '🤹',
    names: ['juggling_person'],
    tags: [],
    description: 'person juggling',
    category: 'People & Body'
  },
  {
    emoji: '🤹‍♂️',
    names: ['man_juggling'],
    tags: [],
    description: 'man juggling',
    category: 'People & Body'
  },
  {
    emoji: '🤹‍♀️',
    names: ['woman_juggling'],
    tags: [],
    description: 'woman juggling',
    category: 'People & Body'
  },
  {
    emoji: '🧘',
    names: ['lotus_position'],
    tags: ['meditation'],
    description: 'person in lotus position',
    category: 'People & Body'
  },
  {
    emoji: '🧘‍♂️',
    names: ['lotus_position_man'],
    tags: ['meditation'],
    description: 'man in lotus position',
    category: 'People & Body'
  },
  {
    emoji: '🧘‍♀️',
    names: ['lotus_position_woman'],
    tags: ['meditation'],
    description: 'woman in lotus position',
    category: 'People & Body'
  },
  {
    emoji: '🛀',
    names: ['bath'],
    tags: ['shower'],
    description: 'person taking bath',
    category: 'People & Body'
  },
  {
    emoji: '🛌',
    names: ['sleeping_bed'],
    tags: [],
    description: 'person in bed',
    category: 'People & Body'
  },
  // {
  //   emoji: '🧑‍🤝‍🧑',
  //   names: ['people_holding_hands'],
  //   tags: ['couple', 'date'],
  //   description: 'people holding hands',
  //   category: 'People & Body'
  // },
  {
    emoji: '👭',
    names: ['two_women_holding_hands'],
    tags: ['couple', 'date'],
    description: 'women holding hands',
    category: 'People & Body'
  },
  {
    emoji: '👫',
    names: ['couple'],
    tags: ['date'],
    description: 'woman and man holding hands',
    category: 'People & Body'
  },
  {
    emoji: '👬',
    names: ['two_men_holding_hands'],
    tags: ['couple', 'date'],
    description: 'men holding hands',
    category: 'People & Body'
  },
  {
    emoji: '💏',
    names: ['couplekiss'],
    tags: [],
    description: 'kiss',
    category: 'People & Body'
  },
  {
    emoji: '👩‍❤️‍💋‍👨',
    names: ['couplekiss_man_woman'],
    tags: [],
    description: 'kiss: woman, man',
    category: 'People & Body'
  },
  {
    emoji: '👨‍❤️‍💋‍👨',
    names: ['couplekiss_man_man'],
    tags: [],
    description: 'kiss: man, man',
    category: 'People & Body'
  },
  {
    emoji: '👩‍❤️‍💋‍👩',
    names: ['couplekiss_woman_woman'],
    tags: [],
    description: 'kiss: woman, woman',
    category: 'People & Body'
  },
  {
    emoji: '💑',
    names: ['couple_with_heart'],
    tags: [],
    description: 'couple with heart',
    category: 'People & Body'
  },
  {
    emoji: '👩‍❤️‍👨',
    names: ['couple_with_heart_woman_man'],
    tags: [],
    description: 'couple with heart: woman, man',
    category: 'People & Body'
  },
  {
    emoji: '👨‍❤️‍👨',
    names: ['couple_with_heart_man_man'],
    tags: [],
    description: 'couple with heart: man, man',
    category: 'People & Body'
  },
  {
    emoji: '👩‍❤️‍👩',
    names: ['couple_with_heart_woman_woman'],
    tags: [],
    description: 'couple with heart: woman, woman',
    category: 'People & Body'
  },
  {
    emoji: '👪',
    names: ['family'],
    tags: ['home', 'parents', 'child'],
    description: 'family',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👩‍👦',
    names: ['family_man_woman_boy'],
    tags: [],
    description: 'family: man, woman, boy',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👩‍👧',
    names: ['family_man_woman_girl'],
    tags: [],
    description: 'family: man, woman, girl',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👩‍👧‍👦',
    names: ['family_man_woman_girl_boy'],
    tags: [],
    description: 'family: man, woman, girl, boy',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👩‍👦‍👦',
    names: ['family_man_woman_boy_boy'],
    tags: [],
    description: 'family: man, woman, boy, boy',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👩‍👧‍👧',
    names: ['family_man_woman_girl_girl'],
    tags: [],
    description: 'family: man, woman, girl, girl',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👨‍👦',
    names: ['family_man_man_boy'],
    tags: [],
    description: 'family: man, man, boy',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👨‍👧',
    names: ['family_man_man_girl'],
    tags: [],
    description: 'family: man, man, girl',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👨‍👧‍👦',
    names: ['family_man_man_girl_boy'],
    tags: [],
    description: 'family: man, man, girl, boy',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👨‍👦‍👦',
    names: ['family_man_man_boy_boy'],
    tags: [],
    description: 'family: man, man, boy, boy',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👨‍👧‍👧',
    names: ['family_man_man_girl_girl'],
    tags: [],
    description: 'family: man, man, girl, girl',
    category: 'People & Body'
  },
  {
    emoji: '👩‍👩‍👦',
    names: ['family_woman_woman_boy'],
    tags: [],
    description: 'family: woman, woman, boy',
    category: 'People & Body'
  },
  {
    emoji: '👩‍👩‍👧',
    names: ['family_woman_woman_girl'],
    tags: [],
    description: 'family: woman, woman, girl',
    category: 'People & Body'
  },
  {
    emoji: '👩‍👩‍👧‍👦',
    names: ['family_woman_woman_girl_boy'],
    tags: [],
    description: 'family: woman, woman, girl, boy',
    category: 'People & Body'
  },
  {
    emoji: '👩‍👩‍👦‍👦',
    names: ['family_woman_woman_boy_boy'],
    tags: [],
    description: 'family: woman, woman, boy, boy',
    category: 'People & Body'
  },
  {
    emoji: '👩‍👩‍👧‍👧',
    names: ['family_woman_woman_girl_girl'],
    tags: [],
    description: 'family: woman, woman, girl, girl',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👦',
    names: ['family_man_boy'],
    tags: [],
    description: 'family: man, boy',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👦‍👦',
    names: ['family_man_boy_boy'],
    tags: [],
    description: 'family: man, boy, boy',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👧',
    names: ['family_man_girl'],
    tags: [],
    description: 'family: man, girl',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👧‍👦',
    names: ['family_man_girl_boy'],
    tags: [],
    description: 'family: man, girl, boy',
    category: 'People & Body'
  },
  {
    emoji: '👨‍👧‍👧',
    names: ['family_man_girl_girl'],
    tags: [],
    description: 'family: man, girl, girl',
    category: 'People & Body'
  },
  {
    emoji: '👩‍👦',
    names: ['family_woman_boy'],
    tags: [],
    description: 'family: woman, boy',
    category: 'People & Body'
  },
  {
    emoji: '👩‍👦‍👦',
    names: ['family_woman_boy_boy'],
    tags: [],
    description: 'family: woman, boy, boy',
    category: 'People & Body'
  },
  {
    emoji: '👩‍👧',
    names: ['family_woman_girl'],
    tags: [],
    description: 'family: woman, girl',
    category: 'People & Body'
  },
  {
    emoji: '👩‍👧‍👦',
    names: ['family_woman_girl_boy'],
    tags: [],
    description: 'family: woman, girl, boy',
    category: 'People & Body'
  },
  {
    emoji: '👩‍👧‍👧',
    names: ['family_woman_girl_girl'],
    tags: [],
    description: 'family: woman, girl, girl',
    category: 'People & Body'
  },
  {
    emoji: '🗣️',
    names: ['speaking_head'],
    tags: [],
    description: 'speaking head',
    category: 'People & Body'
  },
  {
    emoji: '👤',
    names: ['bust_in_silhouette'],
    tags: ['user'],
    description: 'bust in silhouette',
    category: 'People & Body'
  },
  {
    emoji: '👥',
    names: ['busts_in_silhouette'],
    tags: ['users', 'group', 'team'],
    description: 'busts in silhouette',
    category: 'People & Body'
  },
  // {
  //   emoji: '🫂',
  //   names: ['people_hugging'],
  //   tags: [],
  //   description: 'people hugging',
  //   category: 'People & Body'
  // },
  {
    emoji: '👣',
    names: ['footprints'],
    tags: ['feet', 'tracks'],
    description: 'footprints',
    category: 'People & Body'
  },
  {
    emoji: '🐵',
    names: ['monkey_face'],
    tags: [],
    description: 'monkey face',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐒',
    names: ['monkey'],
    tags: [],
    description: 'monkey',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦍',
    names: ['gorilla'],
    tags: [],
    description: 'gorilla',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🦧',
  //   names: ['orangutan'],
  //   tags: [],
  //   description: 'orangutan',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🐶',
    names: ['dog'],
    tags: ['pet'],
    description: 'dog face',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐕',
    names: ['dog2'],
    tags: [],
    description: 'dog',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🦮',
  //   names: ['guide_dog'],
  //   tags: [],
  //   description: 'guide dog',
  //   category: 'Animals & Nature'
  // },
  // {
  //   emoji: '🐕‍🦺',
  //   names: ['service_dog'],
  //   tags: [],
  //   description: 'service dog',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🐩',
    names: ['poodle'],
    tags: ['dog'],
    description: 'poodle',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐺',
    names: ['wolf'],
    tags: [],
    description: 'wolf',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦊',
    names: ['fox_face'],
    tags: [],
    description: 'fox',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦝',
    names: ['raccoon'],
    tags: [],
    description: 'raccoon',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐱',
    names: ['cat'],
    tags: ['pet'],
    description: 'cat face',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐈',
    names: ['cat2'],
    tags: [],
    description: 'cat',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🐈‍⬛',
  //   names: ['black_cat'],
  //   tags: [],
  //   description: 'black cat',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🦁',
    names: ['lion'],
    tags: [],
    description: 'lion',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐯',
    names: ['tiger'],
    tags: [],
    description: 'tiger face',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐅',
    names: ['tiger2'],
    tags: [],
    description: 'tiger',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐆',
    names: ['leopard'],
    tags: [],
    description: 'leopard',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐴',
    names: ['horse'],
    tags: [],
    description: 'horse face',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🫎',
  //   names: ['moose'],
  //   tags: ['canada'],
  //   description: 'moose',
  //   category: 'Animals & Nature'
  // },
  // {
  //   emoji: '🫏',
  //   names: ['donkey'],
  //   tags: ['mule'],
  //   description: 'donkey',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🐎',
    names: ['racehorse'],
    tags: ['speed'],
    description: 'horse',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦄',
    names: ['unicorn'],
    tags: [],
    description: 'unicorn',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦓',
    names: ['zebra'],
    tags: [],
    description: 'zebra',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦌',
    names: ['deer'],
    tags: [],
    description: 'deer',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🦬',
  //   names: ['bison'],
  //   tags: [],
  //   description: 'bison',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🐮',
    names: ['cow'],
    tags: [],
    description: 'cow face',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐂',
    names: ['ox'],
    tags: [],
    description: 'ox',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐃',
    names: ['water_buffalo'],
    tags: [],
    description: 'water buffalo',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐄',
    names: ['cow2'],
    tags: [],
    description: 'cow',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐷',
    names: ['pig'],
    tags: [],
    description: 'pig face',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐖',
    names: ['pig2'],
    tags: [],
    description: 'pig',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐗',
    names: ['boar'],
    tags: [],
    description: 'boar',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐽',
    names: ['pig_nose'],
    tags: [],
    description: 'pig nose',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐏',
    names: ['ram'],
    tags: [],
    description: 'ram',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐑',
    names: ['sheep'],
    tags: [],
    description: 'ewe',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐐',
    names: ['goat'],
    tags: [],
    description: 'goat',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐪',
    names: ['dromedary_camel'],
    tags: ['desert'],
    description: 'camel',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐫',
    names: ['camel'],
    tags: [],
    description: 'two-hump camel',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦙',
    names: ['llama'],
    tags: [],
    description: 'llama',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦒',
    names: ['giraffe'],
    tags: [],
    description: 'giraffe',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐘',
    names: ['elephant'],
    tags: [],
    description: 'elephant',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🦣',
  //   names: ['mammoth'],
  //   tags: [],
  //   description: 'mammoth',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🦏',
    names: ['rhinoceros'],
    tags: [],
    description: 'rhinoceros',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦛',
    names: ['hippopotamus'],
    tags: [],
    description: 'hippopotamus',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐭',
    names: ['mouse'],
    tags: [],
    description: 'mouse face',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐁',
    names: ['mouse2'],
    tags: [],
    description: 'mouse',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐀',
    names: ['rat'],
    tags: [],
    description: 'rat',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐹',
    names: ['hamster'],
    tags: ['pet'],
    description: 'hamster',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐰',
    names: ['rabbit'],
    tags: ['bunny'],
    description: 'rabbit face',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐇',
    names: ['rabbit2'],
    tags: [],
    description: 'rabbit',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐿️',
    names: ['chipmunk'],
    tags: [],
    description: 'chipmunk',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🦫',
  //   names: ['beaver'],
  //   tags: [],
  //   description: 'beaver',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🦔',
    names: ['hedgehog'],
    tags: [],
    description: 'hedgehog',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦇',
    names: ['bat'],
    tags: [],
    description: 'bat',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐻',
    names: ['bear'],
    tags: [],
    description: 'bear',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🐻‍❄️',
  //   names: ['polar_bear'],
  //   tags: [],
  //   description: 'polar bear',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🐨',
    names: ['koala'],
    tags: [],
    description: 'koala',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐼',
    names: ['panda_face'],
    tags: [],
    description: 'panda',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🦥',
  //   names: ['sloth'],
  //   tags: [],
  //   description: 'sloth',
  //   category: 'Animals & Nature'
  // },
  // {
  //   emoji: '🦦',
  //   names: ['otter'],
  //   tags: [],
  //   description: 'otter',
  //   category: 'Animals & Nature'
  // },
  // {
  //   emoji: '🦨',
  //   names: ['skunk'],
  //   tags: [],
  //   description: 'skunk',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🦘',
    names: ['kangaroo'],
    tags: [],
    description: 'kangaroo',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦡',
    names: ['badger'],
    tags: [],
    description: 'badger',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐾',
    names: ['feet', 'paw_prints'],
    tags: [],
    description: 'paw prints',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦃',
    names: ['turkey'],
    tags: ['thanksgiving'],
    description: 'turkey',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐔',
    names: ['chicken'],
    tags: [],
    description: 'chicken',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐓',
    names: ['rooster'],
    tags: [],
    description: 'rooster',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐣',
    names: ['hatching_chick'],
    tags: [],
    description: 'hatching chick',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐤',
    names: ['baby_chick'],
    tags: [],
    description: 'baby chick',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐥',
    names: ['hatched_chick'],
    tags: [],
    description: 'front-facing baby chick',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐦',
    names: ['bird'],
    tags: [],
    description: 'bird',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐧',
    names: ['penguin'],
    tags: [],
    description: 'penguin',
    category: 'Animals & Nature'
  },
  {
    emoji: '🕊️',
    names: ['dove'],
    tags: ['peace'],
    description: 'dove',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦅',
    names: ['eagle'],
    tags: [],
    description: 'eagle',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦆',
    names: ['duck'],
    tags: [],
    description: 'duck',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦢',
    names: ['swan'],
    tags: [],
    description: 'swan',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦉',
    names: ['owl'],
    tags: [],
    description: 'owl',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🦤',
  //   names: ['dodo'],
  //   tags: [],
  //   description: 'dodo',
  //   category: 'Animals & Nature'
  // },
  // {
  //   emoji: '🪶',
  //   names: ['feather'],
  //   tags: [],
  //   description: 'feather',
  //   category: 'Animals & Nature'
  // },
  // {
  //   emoji: '🦩',
  //   names: ['flamingo'],
  //   tags: [],
  //   description: 'flamingo',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🦚',
    names: ['peacock'],
    tags: [],
    description: 'peacock',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦜',
    names: ['parrot'],
    tags: [],
    description: 'parrot',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🪽',
  //   names: ['wing'],
  //   tags: ['fly'],
  //   description: 'wing',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🐦‍⬛',
    names: ['black_bird'],
    tags: [],
    description: 'black bird',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🪿',
  //   names: ['goose'],
  //   tags: ['honk'],
  //   description: 'goose',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🐸',
    names: ['frog'],
    tags: [],
    description: 'frog',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐊',
    names: ['crocodile'],
    tags: [],
    description: 'crocodile',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐢',
    names: ['turtle'],
    tags: ['slow'],
    description: 'turtle',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦎',
    names: ['lizard'],
    tags: [],
    description: 'lizard',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐍',
    names: ['snake'],
    tags: [],
    description: 'snake',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐲',
    names: ['dragon_face'],
    tags: [],
    description: 'dragon face',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐉',
    names: ['dragon'],
    tags: [],
    description: 'dragon',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦕',
    names: ['sauropod'],
    tags: ['dinosaur'],
    description: 'sauropod',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦖',
    names: ['t-rex'],
    tags: ['dinosaur'],
    description: 'T-Rex',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐳',
    names: ['whale'],
    tags: ['sea'],
    description: 'spouting whale',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐋',
    names: ['whale2'],
    tags: [],
    description: 'whale',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐬',
    names: ['dolphin', 'flipper'],
    tags: [],
    description: 'dolphin',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🦭',
  //   names: ['seal'],
  //   tags: [],
  //   description: 'seal',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🐟',
    names: ['fish'],
    tags: [],
    description: 'fish',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐠',
    names: ['tropical_fish'],
    tags: [],
    description: 'tropical fish',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐡',
    names: ['blowfish'],
    tags: [],
    description: 'blowfish',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦈',
    names: ['shark'],
    tags: [],
    description: 'shark',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐙',
    names: ['octopus'],
    tags: [],
    description: 'octopus',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐚',
    names: ['shell'],
    tags: ['sea', 'beach'],
    description: 'spiral shell',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🪸',
  //   names: ['coral'],
  //   tags: [],
  //   description: 'coral',
  //   category: 'Animals & Nature'
  // },
  // {
  //   emoji: '🪼',
  //   names: ['jellyfish'],
  //   tags: [],
  //   description: 'jellyfish',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🐌',
    names: ['snail'],
    tags: ['slow'],
    description: 'snail',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦋',
    names: ['butterfly'],
    tags: [],
    description: 'butterfly',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐛',
    names: ['bug'],
    tags: [],
    description: 'bug',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐜',
    names: ['ant'],
    tags: [],
    description: 'ant',
    category: 'Animals & Nature'
  },
  {
    emoji: '🐝',
    names: ['bee', 'honeybee'],
    tags: [],
    description: 'honeybee',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🪲',
  //   names: ['beetle'],
  //   tags: [],
  //   description: 'beetle',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🐞',
    names: ['lady_beetle'],
    tags: ['bug'],
    description: 'lady beetle',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦗',
    names: ['cricket'],
    tags: [],
    description: 'cricket',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🪳',
  //   names: ['cockroach'],
  //   tags: [],
  //   description: 'cockroach',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🕷️',
    names: ['spider'],
    tags: [],
    description: 'spider',
    category: 'Animals & Nature'
  },
  {
    emoji: '🕸️',
    names: ['spider_web'],
    tags: [],
    description: 'spider web',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦂',
    names: ['scorpion'],
    tags: [],
    description: 'scorpion',
    category: 'Animals & Nature'
  },
  {
    emoji: '🦟',
    names: ['mosquito'],
    tags: [],
    description: 'mosquito',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🪰',
  //   names: ['fly'],
  //   tags: [],
  //   description: 'fly',
  //   category: 'Animals & Nature'
  // },
  // {
  //   emoji: '🪱',
  //   names: ['worm'],
  //   tags: [],
  //   description: 'worm',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🦠',
    names: ['microbe'],
    tags: ['germ'],
    description: 'microbe',
    category: 'Animals & Nature'
  },
  {
    emoji: '💐',
    names: ['bouquet'],
    tags: ['flowers'],
    description: 'bouquet',
    category: 'Animals & Nature'
  },
  {
    emoji: '🌸',
    names: ['cherry_blossom'],
    tags: ['flower', 'spring'],
    description: 'cherry blossom',
    category: 'Animals & Nature'
  },
  {
    emoji: '💮',
    names: ['white_flower'],
    tags: [],
    description: 'white flower',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🪷',
  //   names: ['lotus'],
  //   tags: [],
  //   description: 'lotus',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🏵️',
    names: ['rosette'],
    tags: [],
    description: 'rosette',
    category: 'Animals & Nature'
  },
  {
    emoji: '🌹',
    names: ['rose'],
    tags: ['flower'],
    description: 'rose',
    category: 'Animals & Nature'
  },
  {
    emoji: '🥀',
    names: ['wilted_flower'],
    tags: [],
    description: 'wilted flower',
    category: 'Animals & Nature'
  },
  {
    emoji: '🌺',
    names: ['hibiscus'],
    tags: [],
    description: 'hibiscus',
    category: 'Animals & Nature'
  },
  {
    emoji: '🌻',
    names: ['sunflower'],
    tags: [],
    description: 'sunflower',
    category: 'Animals & Nature'
  },
  {
    emoji: '🌼',
    names: ['blossom'],
    tags: [],
    description: 'blossom',
    category: 'Animals & Nature'
  },
  {
    emoji: '🌷',
    names: ['tulip'],
    tags: ['flower'],
    description: 'tulip',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🪻',
  //   names: ['hyacinth'],
  //   tags: [],
  //   description: 'hyacinth',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🌱',
    names: ['seedling'],
    tags: ['plant'],
    description: 'seedling',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🪴',
  //   names: ['potted_plant'],
  //   tags: [],
  //   description: 'potted plant',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🌲',
    names: ['evergreen_tree'],
    tags: ['wood'],
    description: 'evergreen tree',
    category: 'Animals & Nature'
  },
  {
    emoji: '🌳',
    names: ['deciduous_tree'],
    tags: ['wood'],
    description: 'deciduous tree',
    category: 'Animals & Nature'
  },
  {
    emoji: '🌴',
    names: ['palm_tree'],
    tags: [],
    description: 'palm tree',
    category: 'Animals & Nature'
  },
  {
    emoji: '🌵',
    names: ['cactus'],
    tags: [],
    description: 'cactus',
    category: 'Animals & Nature'
  },
  {
    emoji: '🌾',
    names: ['ear_of_rice'],
    tags: [],
    description: 'sheaf of rice',
    category: 'Animals & Nature'
  },
  {
    emoji: '🌿',
    names: ['herb'],
    tags: [],
    description: 'herb',
    category: 'Animals & Nature'
  },
  {
    emoji: '☘️',
    names: ['shamrock'],
    tags: [],
    description: 'shamrock',
    category: 'Animals & Nature'
  },
  {
    emoji: '🍀',
    names: ['four_leaf_clover'],
    tags: ['luck'],
    description: 'four leaf clover',
    category: 'Animals & Nature'
  },
  {
    emoji: '🍁',
    names: ['maple_leaf'],
    tags: ['canada'],
    description: 'maple leaf',
    category: 'Animals & Nature'
  },
  {
    emoji: '🍂',
    names: ['fallen_leaf'],
    tags: ['autumn'],
    description: 'fallen leaf',
    category: 'Animals & Nature'
  },
  {
    emoji: '🍃',
    names: ['leaves'],
    tags: ['leaf'],
    description: 'leaf fluttering in wind',
    category: 'Animals & Nature'
  },
  // {
  //   emoji: '🪹',
  //   names: ['empty_nest'],
  //   tags: [],
  //   description: 'empty nest',
  //   category: 'Animals & Nature'
  // },
  // {
  //   emoji: '🪺',
  //   names: ['nest_with_eggs'],
  //   tags: [],
  //   description: 'nest with eggs',
  //   category: 'Animals & Nature'
  // },
  {
    emoji: '🍄',
    names: ['mushroom'],
    tags: ['fungus'],
    description: 'mushroom',
    category: 'Animals & Nature'
  },
  {
    emoji: '🍇',
    names: ['grapes'],
    tags: [],
    description: 'grapes',
    category: 'Food & Drink'
  },
  {
    emoji: '🍈',
    names: ['melon'],
    tags: [],
    description: 'melon',
    category: 'Food & Drink'
  },
  {
    emoji: '🍉',
    names: ['watermelon'],
    tags: [],
    description: 'watermelon',
    category: 'Food & Drink'
  },
  {
    emoji: '🍊',
    names: ['tangerine', 'orange', 'mandarin'],
    tags: [],
    description: 'tangerine',
    category: 'Food & Drink'
  },
  {
    emoji: '🍋',
    names: ['lemon'],
    tags: [],
    description: 'lemon',
    category: 'Food & Drink'
  },
  {
    emoji: '🍌',
    names: ['banana'],
    tags: ['fruit'],
    description: 'banana',
    category: 'Food & Drink'
  },
  {
    emoji: '🍍',
    names: ['pineapple'],
    tags: [],
    description: 'pineapple',
    category: 'Food & Drink'
  },
  {
    emoji: '🥭',
    names: ['mango'],
    tags: [],
    description: 'mango',
    category: 'Food & Drink'
  },
  {
    emoji: '🍎',
    names: ['apple'],
    tags: [],
    description: 'red apple',
    category: 'Food & Drink'
  },
  {
    emoji: '🍏',
    names: ['green_apple'],
    tags: ['fruit'],
    description: 'green apple',
    category: 'Food & Drink'
  },
  {
    emoji: '🍐',
    names: ['pear'],
    tags: [],
    description: 'pear',
    category: 'Food & Drink'
  },
  {
    emoji: '🍑',
    names: ['peach'],
    tags: [],
    description: 'peach',
    category: 'Food & Drink'
  },
  {
    emoji: '🍒',
    names: ['cherries'],
    tags: ['fruit'],
    description: 'cherries',
    category: 'Food & Drink'
  },
  {
    emoji: '🍓',
    names: ['strawberry'],
    tags: ['fruit'],
    description: 'strawberry',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🫐',
  //   names: ['blueberries'],
  //   tags: [],
  //   description: 'blueberries',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🥝',
    names: ['kiwi_fruit'],
    tags: [],
    description: 'kiwi fruit',
    category: 'Food & Drink'
  },
  {
    emoji: '🍅',
    names: ['tomato'],
    tags: [],
    description: 'tomato',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🫒',
  //   names: ['olive'],
  //   tags: [],
  //   description: 'olive',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🥥',
    names: ['coconut'],
    tags: [],
    description: 'coconut',
    category: 'Food & Drink'
  },
  {
    emoji: '🥑',
    names: ['avocado'],
    tags: [],
    description: 'avocado',
    category: 'Food & Drink'
  },
  {
    emoji: '🍆',
    names: ['eggplant'],
    tags: ['aubergine'],
    description: 'eggplant',
    category: 'Food & Drink'
  },
  {
    emoji: '🥔',
    names: ['potato'],
    tags: [],
    description: 'potato',
    category: 'Food & Drink'
  },
  {
    emoji: '🥕',
    names: ['carrot'],
    tags: [],
    description: 'carrot',
    category: 'Food & Drink'
  },
  {
    emoji: '🌽',
    names: ['corn'],
    tags: [],
    description: 'ear of corn',
    category: 'Food & Drink'
  },
  {
    emoji: '🌶️',
    names: ['hot_pepper'],
    tags: ['spicy'],
    description: 'hot pepper',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🫑',
  //   names: ['bell_pepper'],
  //   tags: [],
  //   description: 'bell pepper',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🥒',
    names: ['cucumber'],
    tags: [],
    description: 'cucumber',
    category: 'Food & Drink'
  },
  {
    emoji: '🥬',
    names: ['leafy_green'],
    tags: [],
    description: 'leafy green',
    category: 'Food & Drink'
  },
  {
    emoji: '🥦',
    names: ['broccoli'],
    tags: [],
    description: 'broccoli',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🧄',
  //   names: ['garlic'],
  //   tags: [],
  //   description: 'garlic',
  //   category: 'Food & Drink'
  // },
  // {
  //   emoji: '🧅',
  //   names: ['onion'],
  //   tags: [],
  //   description: 'onion',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🥜',
    names: ['peanuts'],
    tags: [],
    description: 'peanuts',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🫘',
  //   names: ['beans'],
  //   tags: [],
  //   description: 'beans',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🌰',
    names: ['chestnut'],
    tags: [],
    description: 'chestnut',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🫚',
  //   names: ['ginger_root'],
  //   tags: [],
  //   description: 'ginger root',
  //   category: 'Food & Drink'
  // },
  // {
  //   emoji: '🫛',
  //   names: ['pea_pod'],
  //   tags: [],
  //   description: 'pea pod',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🍞',
    names: ['bread'],
    tags: ['toast'],
    description: 'bread',
    category: 'Food & Drink'
  },
  {
    emoji: '🥐',
    names: ['croissant'],
    tags: [],
    description: 'croissant',
    category: 'Food & Drink'
  },
  {
    emoji: '🥖',
    names: ['baguette_bread'],
    tags: [],
    description: 'baguette bread',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🫓',
  //   names: ['flatbread'],
  //   tags: [],
  //   description: 'flatbread',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🥨',
    names: ['pretzel'],
    tags: [],
    description: 'pretzel',
    category: 'Food & Drink'
  },
  {
    emoji: '🥯',
    names: ['bagel'],
    tags: [],
    description: 'bagel',
    category: 'Food & Drink'
  },
  {
    emoji: '🥞',
    names: ['pancakes'],
    tags: [],
    description: 'pancakes',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🧇',
  //   names: ['waffle'],
  //   tags: [],
  //   description: 'waffle',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🧀',
    names: ['cheese'],
    tags: [],
    description: 'cheese wedge',
    category: 'Food & Drink'
  },
  {
    emoji: '🍖',
    names: ['meat_on_bone'],
    tags: [],
    description: 'meat on bone',
    category: 'Food & Drink'
  },
  {
    emoji: '🍗',
    names: ['poultry_leg'],
    tags: ['meat', 'chicken'],
    description: 'poultry leg',
    category: 'Food & Drink'
  },
  {
    emoji: '🥩',
    names: ['cut_of_meat'],
    tags: [],
    description: 'cut of meat',
    category: 'Food & Drink'
  },
  {
    emoji: '🥓',
    names: ['bacon'],
    tags: [],
    description: 'bacon',
    category: 'Food & Drink'
  },
  {
    emoji: '🍔',
    names: ['hamburger'],
    tags: ['burger'],
    description: 'hamburger',
    category: 'Food & Drink'
  },
  {
    emoji: '🍟',
    names: ['fries'],
    tags: [],
    description: 'french fries',
    category: 'Food & Drink'
  },
  {
    emoji: '🍕',
    names: ['pizza'],
    tags: [],
    description: 'pizza',
    category: 'Food & Drink'
  },
  {
    emoji: '🌭',
    names: ['hotdog'],
    tags: [],
    description: 'hot dog',
    category: 'Food & Drink'
  },
  {
    emoji: '🥪',
    names: ['sandwich'],
    tags: [],
    description: 'sandwich',
    category: 'Food & Drink'
  },
  {
    emoji: '🌮',
    names: ['taco'],
    tags: [],
    description: 'taco',
    category: 'Food & Drink'
  },
  {
    emoji: '🌯',
    names: ['burrito'],
    tags: [],
    description: 'burrito',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🫔',
  //   names: ['tamale'],
  //   tags: [],
  //   description: 'tamale',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🥙',
    names: ['stuffed_flatbread'],
    tags: [],
    description: 'stuffed flatbread',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🧆',
  //   names: ['falafel'],
  //   tags: [],
  //   description: 'falafel',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🥚',
    names: ['egg'],
    tags: [],
    description: 'egg',
    category: 'Food & Drink'
  },
  {
    emoji: '🍳',
    names: ['fried_egg'],
    tags: ['breakfast'],
    description: 'cooking',
    category: 'Food & Drink'
  },
  {
    emoji: '🥘',
    names: ['shallow_pan_of_food'],
    tags: ['paella', 'curry'],
    description: 'shallow pan of food',
    category: 'Food & Drink'
  },
  {
    emoji: '🍲',
    names: ['stew'],
    tags: [],
    description: 'pot of food',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🫕',
  //   names: ['fondue'],
  //   tags: [],
  //   description: 'fondue',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🥣',
    names: ['bowl_with_spoon'],
    tags: [],
    description: 'bowl with spoon',
    category: 'Food & Drink'
  },
  {
    emoji: '🥗',
    names: ['green_salad'],
    tags: [],
    description: 'green salad',
    category: 'Food & Drink'
  },
  {
    emoji: '🍿',
    names: ['popcorn'],
    tags: [],
    description: 'popcorn',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🧈',
  //   names: ['butter'],
  //   tags: [],
  //   description: 'butter',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🧂',
    names: ['salt'],
    tags: [],
    description: 'salt',
    category: 'Food & Drink'
  },
  {
    emoji: '🥫',
    names: ['canned_food'],
    tags: [],
    description: 'canned food',
    category: 'Food & Drink'
  },
  {
    emoji: '🍱',
    names: ['bento'],
    tags: [],
    description: 'bento box',
    category: 'Food & Drink'
  },
  {
    emoji: '🍘',
    names: ['rice_cracker'],
    tags: [],
    description: 'rice cracker',
    category: 'Food & Drink'
  },
  {
    emoji: '🍙',
    names: ['rice_ball'],
    tags: [],
    description: 'rice ball',
    category: 'Food & Drink'
  },
  {
    emoji: '🍚',
    names: ['rice'],
    tags: [],
    description: 'cooked rice',
    category: 'Food & Drink'
  },
  {
    emoji: '🍛',
    names: ['curry'],
    tags: [],
    description: 'curry rice',
    category: 'Food & Drink'
  },
  {
    emoji: '🍜',
    names: ['ramen'],
    tags: ['noodle'],
    description: 'steaming bowl',
    category: 'Food & Drink'
  },
  {
    emoji: '🍝',
    names: ['spaghetti'],
    tags: ['pasta'],
    description: 'spaghetti',
    category: 'Food & Drink'
  },
  {
    emoji: '🍠',
    names: ['sweet_potato'],
    tags: [],
    description: 'roasted sweet potato',
    category: 'Food & Drink'
  },
  {
    emoji: '🍢',
    names: ['oden'],
    tags: [],
    description: 'oden',
    category: 'Food & Drink'
  },
  {
    emoji: '🍣',
    names: ['sushi'],
    tags: [],
    description: 'sushi',
    category: 'Food & Drink'
  },
  {
    emoji: '🍤',
    names: ['fried_shrimp'],
    tags: ['tempura'],
    description: 'fried shrimp',
    category: 'Food & Drink'
  },
  {
    emoji: '🍥',
    names: ['fish_cake'],
    tags: [],
    description: 'fish cake with swirl',
    category: 'Food & Drink'
  },
  {
    emoji: '🥮',
    names: ['moon_cake'],
    tags: [],
    description: 'moon cake',
    category: 'Food & Drink'
  },
  {
    emoji: '🍡',
    names: ['dango'],
    tags: [],
    description: 'dango',
    category: 'Food & Drink'
  },
  {
    emoji: '🥟',
    names: ['dumpling'],
    tags: [],
    description: 'dumpling',
    category: 'Food & Drink'
  },
  {
    emoji: '🥠',
    names: ['fortune_cookie'],
    tags: [],
    description: 'fortune cookie',
    category: 'Food & Drink'
  },
  {
    emoji: '🥡',
    names: ['takeout_box'],
    tags: [],
    description: 'takeout box',
    category: 'Food & Drink'
  },
  {
    emoji: '🦀',
    names: ['crab'],
    tags: [],
    description: 'crab',
    category: 'Food & Drink'
  },
  {
    emoji: '🦞',
    names: ['lobster'],
    tags: [],
    description: 'lobster',
    category: 'Food & Drink'
  },
  {
    emoji: '🦐',
    names: ['shrimp'],
    tags: [],
    description: 'shrimp',
    category: 'Food & Drink'
  },
  {
    emoji: '🦑',
    names: ['squid'],
    tags: [],
    description: 'squid',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🦪',
  //   names: ['oyster'],
  //   tags: [],
  //   description: 'oyster',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🍦',
    names: ['icecream'],
    tags: [],
    description: 'soft ice cream',
    category: 'Food & Drink'
  },
  {
    emoji: '🍧',
    names: ['shaved_ice'],
    tags: [],
    description: 'shaved ice',
    category: 'Food & Drink'
  },
  {
    emoji: '🍨',
    names: ['ice_cream'],
    tags: [],
    description: 'ice cream',
    category: 'Food & Drink'
  },
  {
    emoji: '🍩',
    names: ['doughnut'],
    tags: [],
    description: 'doughnut',
    category: 'Food & Drink'
  },
  {
    emoji: '🍪',
    names: ['cookie'],
    tags: [],
    description: 'cookie',
    category: 'Food & Drink'
  },
  {
    emoji: '🎂',
    names: ['birthday'],
    tags: ['party'],
    description: 'birthday cake',
    category: 'Food & Drink'
  },
  {
    emoji: '🍰',
    names: ['cake'],
    tags: ['dessert'],
    description: 'shortcake',
    category: 'Food & Drink'
  },
  {
    emoji: '🧁',
    names: ['cupcake'],
    tags: [],
    description: 'cupcake',
    category: 'Food & Drink'
  },
  {
    emoji: '🥧',
    names: ['pie'],
    tags: [],
    description: 'pie',
    category: 'Food & Drink'
  },
  {
    emoji: '🍫',
    names: ['chocolate_bar'],
    tags: [],
    description: 'chocolate bar',
    category: 'Food & Drink'
  },
  {
    emoji: '🍬',
    names: ['candy'],
    tags: ['sweet'],
    description: 'candy',
    category: 'Food & Drink'
  },
  {
    emoji: '🍭',
    names: ['lollipop'],
    tags: [],
    description: 'lollipop',
    category: 'Food & Drink'
  },
  {
    emoji: '🍮',
    names: ['custard'],
    tags: [],
    description: 'custard',
    category: 'Food & Drink'
  },
  {
    emoji: '🍯',
    names: ['honey_pot'],
    tags: [],
    description: 'honey pot',
    category: 'Food & Drink'
  },
  {
    emoji: '🍼',
    names: ['baby_bottle'],
    tags: ['milk'],
    description: 'baby bottle',
    category: 'Food & Drink'
  },
  {
    emoji: '🥛',
    names: ['milk_glass'],
    tags: [],
    description: 'glass of milk',
    category: 'Food & Drink'
  },
  {
    emoji: '☕',
    names: ['coffee'],
    tags: ['cafe', 'espresso'],
    description: 'hot beverage',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🫖',
  //   names: ['teapot'],
  //   tags: [],
  //   description: 'teapot',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🍵',
    names: ['tea'],
    tags: ['green', 'breakfast'],
    description: 'teacup without handle',
    category: 'Food & Drink'
  },
  {
    emoji: '🍶',
    names: ['sake'],
    tags: [],
    description: 'sake',
    category: 'Food & Drink'
  },
  {
    emoji: '🍾',
    names: ['champagne'],
    tags: ['bottle', 'bubbly', 'celebration'],
    description: 'bottle with popping cork',
    category: 'Food & Drink'
  },
  {
    emoji: '🍷',
    names: ['wine_glass'],
    tags: [],
    description: 'wine glass',
    category: 'Food & Drink'
  },
  {
    emoji: '🍸',
    names: ['cocktail'],
    tags: ['drink'],
    description: 'cocktail glass',
    category: 'Food & Drink'
  },
  {
    emoji: '🍹',
    names: ['tropical_drink'],
    tags: ['summer', 'vacation'],
    description: 'tropical drink',
    category: 'Food & Drink'
  },
  {
    emoji: '🍺',
    names: ['beer'],
    tags: ['drink'],
    description: 'beer mug',
    category: 'Food & Drink'
  },
  {
    emoji: '🍻',
    names: ['beers'],
    tags: ['drinks'],
    description: 'clinking beer mugs',
    category: 'Food & Drink'
  },
  {
    emoji: '🥂',
    names: ['clinking_glasses'],
    tags: ['cheers', 'toast'],
    description: 'clinking glasses',
    category: 'Food & Drink'
  },
  {
    emoji: '🥃',
    names: ['tumbler_glass'],
    tags: ['whisky'],
    description: 'tumbler glass',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🫗',
  //   names: ['pouring_liquid'],
  //   tags: [],
  //   description: 'pouring liquid',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🥤',
    names: ['cup_with_straw'],
    tags: [],
    description: 'cup with straw',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🧋',
  //   names: ['bubble_tea'],
  //   tags: [],
  //   description: 'bubble tea',
  //   category: 'Food & Drink'
  // },
  // {
  //   emoji: '🧃',
  //   names: ['beverage_box'],
  //   tags: [],
  //   description: 'beverage box',
  //   category: 'Food & Drink'
  // },
  // {
  //   emoji: '🧉',
  //   names: ['mate'],
  //   tags: [],
  //   description: 'mate',
  //   category: 'Food & Drink'
  // },
  // {
  //   emoji: '🧊',
  //   names: ['ice_cube'],
  //   tags: [],
  //   description: 'ice',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🥢',
    names: ['chopsticks'],
    tags: [],
    description: 'chopsticks',
    category: 'Food & Drink'
  },
  {
    emoji: '🍽️',
    names: ['plate_with_cutlery'],
    tags: ['dining', 'dinner'],
    description: 'fork and knife with plate',
    category: 'Food & Drink'
  },
  {
    emoji: '🍴',
    names: ['fork_and_knife'],
    tags: ['cutlery'],
    description: 'fork and knife',
    category: 'Food & Drink'
  },
  {
    emoji: '🥄',
    names: ['spoon'],
    tags: [],
    description: 'spoon',
    category: 'Food & Drink'
  },
  {
    emoji: '🔪',
    names: ['hocho', 'knife'],
    tags: ['cut', 'chop'],
    description: 'kitchen knife',
    category: 'Food & Drink'
  },
  // {
  //   emoji: '🫙',
  //   names: ['jar'],
  //   tags: [],
  //   description: 'jar',
  //   category: 'Food & Drink'
  // },
  {
    emoji: '🏺',
    names: ['amphora'],
    tags: [],
    description: 'amphora',
    category: 'Food & Drink'
  },
  {
    emoji: '🌍',
    names: ['earth_africa'],
    tags: ['globe', 'world', 'international'],
    description: 'globe showing Europe-Africa',
    category: 'Travel & Places'
  },
  {
    emoji: '🌎',
    names: ['earth_americas'],
    tags: ['globe', 'world', 'international'],
    description: 'globe showing Americas',
    category: 'Travel & Places'
  },
  {
    emoji: '🌏',
    names: ['earth_asia'],
    tags: ['globe', 'world', 'international'],
    description: 'globe showing Asia-Australia',
    category: 'Travel & Places'
  },
  {
    emoji: '🌐',
    names: ['globe_with_meridians'],
    tags: ['world', 'global', 'international'],
    description: 'globe with meridians',
    category: 'Travel & Places'
  },
  {
    emoji: '🗺️',
    names: ['world_map'],
    tags: ['travel'],
    description: 'world map',
    category: 'Travel & Places'
  },
  {
    emoji: '🗾',
    names: ['japan'],
    tags: [],
    description: 'map of Japan',
    category: 'Travel & Places'
  },
  {
    emoji: '🧭',
    names: ['compass'],
    tags: [],
    description: 'compass',
    category: 'Travel & Places'
  },
  {
    emoji: '🏔️',
    names: ['mountain_snow'],
    tags: [],
    description: 'snow-capped mountain',
    category: 'Travel & Places'
  },
  {
    emoji: '⛰️',
    names: ['mountain'],
    tags: [],
    description: 'mountain',
    category: 'Travel & Places'
  },
  {
    emoji: '🌋',
    names: ['volcano'],
    tags: [],
    description: 'volcano',
    category: 'Travel & Places'
  },
  {
    emoji: '🗻',
    names: ['mount_fuji'],
    tags: [],
    description: 'mount fuji',
    category: 'Travel & Places'
  },
  {
    emoji: '🏕️',
    names: ['camping'],
    tags: [],
    description: 'camping',
    category: 'Travel & Places'
  },
  {
    emoji: '🏖️',
    names: ['beach_umbrella'],
    tags: [],
    description: 'beach with umbrella',
    category: 'Travel & Places'
  },
  {
    emoji: '🏜️',
    names: ['desert'],
    tags: [],
    description: 'desert',
    category: 'Travel & Places'
  },
  {
    emoji: '🏝️',
    names: ['desert_island'],
    tags: [],
    description: 'desert island',
    category: 'Travel & Places'
  },
  {
    emoji: '🏞️',
    names: ['national_park'],
    tags: [],
    description: 'national park',
    category: 'Travel & Places'
  },
  {
    emoji: '🏟️',
    names: ['stadium'],
    tags: [],
    description: 'stadium',
    category: 'Travel & Places'
  },
  {
    emoji: '🏛️',
    names: ['classical_building'],
    tags: [],
    description: 'classical building',
    category: 'Travel & Places'
  },
  {
    emoji: '🏗️',
    names: ['building_construction'],
    tags: [],
    description: 'building construction',
    category: 'Travel & Places'
  },
  {
    emoji: '🧱',
    names: ['bricks'],
    tags: [],
    description: 'brick',
    category: 'Travel & Places'
  },
  // {
  //   emoji: '🪨',
  //   names: ['rock'],
  //   tags: [],
  //   description: 'rock',
  //   category: 'Travel & Places'
  // },
  // {
  //   emoji: '🪵',
  //   names: ['wood'],
  //   tags: [],
  //   description: 'wood',
  //   category: 'Travel & Places'
  // },
  // {
  //   emoji: '🛖',
  //   names: ['hut'],
  //   tags: [],
  //   description: 'hut',
  //   category: 'Travel & Places'
  // },
  {
    emoji: '🏘️',
    names: ['houses'],
    tags: [],
    description: 'houses',
    category: 'Travel & Places'
  },
  {
    emoji: '🏚️',
    names: ['derelict_house'],
    tags: [],
    description: 'derelict house',
    category: 'Travel & Places'
  },
  {
    emoji: '🏠',
    names: ['house'],
    tags: [],
    description: 'house',
    category: 'Travel & Places'
  },
  {
    emoji: '🏡',
    names: ['house_with_garden'],
    tags: [],
    description: 'house with garden',
    category: 'Travel & Places'
  },
  {
    emoji: '🏢',
    names: ['office'],
    tags: [],
    description: 'office building',
    category: 'Travel & Places'
  },
  {
    emoji: '🏣',
    names: ['post_office'],
    tags: [],
    description: 'Japanese post office',
    category: 'Travel & Places'
  },
  {
    emoji: '🏤',
    names: ['european_post_office'],
    tags: [],
    description: 'post office',
    category: 'Travel & Places'
  },
  {
    emoji: '🏥',
    names: ['hospital'],
    tags: [],
    description: 'hospital',
    category: 'Travel & Places'
  },
  {
    emoji: '🏦',
    names: ['bank'],
    tags: [],
    description: 'bank',
    category: 'Travel & Places'
  },
  {
    emoji: '🏨',
    names: ['hotel'],
    tags: [],
    description: 'hotel',
    category: 'Travel & Places'
  },
  {
    emoji: '🏩',
    names: ['love_hotel'],
    tags: [],
    description: 'love hotel',
    category: 'Travel & Places'
  },
  {
    emoji: '🏪',
    names: ['convenience_store'],
    tags: [],
    description: 'convenience store',
    category: 'Travel & Places'
  },
  {
    emoji: '🏫',
    names: ['school'],
    tags: [],
    description: 'school',
    category: 'Travel & Places'
  },
  {
    emoji: '🏬',
    names: ['department_store'],
    tags: [],
    description: 'department store',
    category: 'Travel & Places'
  },
  {
    emoji: '🏭',
    names: ['factory'],
    tags: [],
    description: 'factory',
    category: 'Travel & Places'
  },
  {
    emoji: '🏯',
    names: ['japanese_castle'],
    tags: [],
    description: 'Japanese castle',
    category: 'Travel & Places'
  },
  {
    emoji: '🏰',
    names: ['european_castle'],
    tags: [],
    description: 'castle',
    category: 'Travel & Places'
  },
  {
    emoji: '💒',
    names: ['wedding'],
    tags: ['marriage'],
    description: 'wedding',
    category: 'Travel & Places'
  },
  {
    emoji: '🗼',
    names: ['tokyo_tower'],
    tags: [],
    description: 'Tokyo tower',
    category: 'Travel & Places'
  },
  {
    emoji: '🗽',
    names: ['statue_of_liberty'],
    tags: [],
    description: 'Statue of Liberty',
    category: 'Travel & Places'
  },
  {
    emoji: '⛪',
    names: ['church'],
    tags: [],
    description: 'church',
    category: 'Travel & Places'
  },
  {
    emoji: '🕌',
    names: ['mosque'],
    tags: [],
    description: 'mosque',
    category: 'Travel & Places'
  },
  // {
  //   emoji: '🛕',
  //   names: ['hindu_temple'],
  //   tags: [],
  //   description: 'hindu temple',
  //   category: 'Travel & Places'
  // },
  {
    emoji: '🕍',
    names: ['synagogue'],
    tags: [],
    description: 'synagogue',
    category: 'Travel & Places'
  },
  {
    emoji: '⛩️',
    names: ['shinto_shrine'],
    tags: [],
    description: 'shinto shrine',
    category: 'Travel & Places'
  },
  {
    emoji: '🕋',
    names: ['kaaba'],
    tags: [],
    description: 'kaaba',
    category: 'Travel & Places'
  },
  {
    emoji: '⛲',
    names: ['fountain'],
    tags: [],
    description: 'fountain',
    category: 'Travel & Places'
  },
  {
    emoji: '⛺',
    names: ['tent'],
    tags: ['camping'],
    description: 'tent',
    category: 'Travel & Places'
  },
  {
    emoji: '🌁',
    names: ['foggy'],
    tags: ['karl'],
    description: 'foggy',
    category: 'Travel & Places'
  },
  {
    emoji: '🌃',
    names: ['night_with_stars'],
    tags: [],
    description: 'night with stars',
    category: 'Travel & Places'
  },
  {
    emoji: '🏙️',
    names: ['cityscape'],
    tags: ['skyline'],
    description: 'cityscape',
    category: 'Travel & Places'
  },
  {
    emoji: '🌄',
    names: ['sunrise_over_mountains'],
    tags: [],
    description: 'sunrise over mountains',
    category: 'Travel & Places'
  },
  {
    emoji: '🌅',
    names: ['sunrise'],
    tags: [],
    description: 'sunrise',
    category: 'Travel & Places'
  },
  {
    emoji: '🌆',
    names: ['city_sunset'],
    tags: [],
    description: 'cityscape at dusk',
    category: 'Travel & Places'
  },
  {
    emoji: '🌇',
    names: ['city_sunrise'],
    tags: [],
    description: 'sunset',
    category: 'Travel & Places'
  },
  {
    emoji: '🌉',
    names: ['bridge_at_night'],
    tags: [],
    description: 'bridge at night',
    category: 'Travel & Places'
  },
  {
    emoji: '♨️',
    names: ['hotsprings'],
    tags: [],
    description: 'hot springs',
    category: 'Travel & Places'
  },
  {
    emoji: '🎠',
    names: ['carousel_horse'],
    tags: [],
    description: 'carousel horse',
    category: 'Travel & Places'
  },
  // {
  //   emoji: '🛝',
  //   names: ['playground_slide'],
  //   tags: [],
  //   description: 'playground slide',
  //   category: 'Travel & Places'
  // },
  {
    emoji: '🎡',
    names: ['ferris_wheel'],
    tags: [],
    description: 'ferris wheel',
    category: 'Travel & Places'
  },
  {
    emoji: '🎢',
    names: ['roller_coaster'],
    tags: [],
    description: 'roller coaster',
    category: 'Travel & Places'
  },
  {
    emoji: '💈',
    names: ['barber'],
    tags: [],
    description: 'barber pole',
    category: 'Travel & Places'
  },
  {
    emoji: '🎪',
    names: ['circus_tent'],
    tags: [],
    description: 'circus tent',
    category: 'Travel & Places'
  },
  {
    emoji: '🚂',
    names: ['steam_locomotive'],
    tags: ['train'],
    description: 'locomotive',
    category: 'Travel & Places'
  },
  {
    emoji: '🚃',
    names: ['railway_car'],
    tags: [],
    description: 'railway car',
    category: 'Travel & Places'
  },
  {
    emoji: '🚄',
    names: ['bullettrain_side'],
    tags: ['train'],
    description: 'high-speed train',
    category: 'Travel & Places'
  },
  {
    emoji: '🚅',
    names: ['bullettrain_front'],
    tags: ['train'],
    description: 'bullet train',
    category: 'Travel & Places'
  },
  {
    emoji: '🚆',
    names: ['train2'],
    tags: [],
    description: 'train',
    category: 'Travel & Places'
  },
  {
    emoji: '🚇',
    names: ['metro'],
    tags: [],
    description: 'metro',
    category: 'Travel & Places'
  },
  {
    emoji: '🚈',
    names: ['light_rail'],
    tags: [],
    description: 'light rail',
    category: 'Travel & Places'
  },
  {
    emoji: '🚉',
    names: ['station'],
    tags: [],
    description: 'station',
    category: 'Travel & Places'
  },
  {
    emoji: '🚊',
    names: ['tram'],
    tags: [],
    description: 'tram',
    category: 'Travel & Places'
  },
  {
    emoji: '🚝',
    names: ['monorail'],
    tags: [],
    description: 'monorail',
    category: 'Travel & Places'
  },
  {
    emoji: '🚞',
    names: ['mountain_railway'],
    tags: [],
    description: 'mountain railway',
    category: 'Travel & Places'
  },
  {
    emoji: '🚋',
    names: ['train'],
    tags: [],
    description: 'tram car',
    category: 'Travel & Places'
  },
  {
    emoji: '🚌',
    names: ['bus'],
    tags: [],
    description: 'bus',
    category: 'Travel & Places'
  },
  {
    emoji: '🚍',
    names: ['oncoming_bus'],
    tags: [],
    description: 'oncoming bus',
    category: 'Travel & Places'
  },
  {
    emoji: '🚎',
    names: ['trolleybus'],
    tags: [],
    description: 'trolleybus',
    category: 'Travel & Places'
  },
  {
    emoji: '🚐',
    names: ['minibus'],
    tags: [],
    description: 'minibus',
    category: 'Travel & Places'
  },
  {
    emoji: '🚑',
    names: ['ambulance'],
    tags: [],
    description: 'ambulance',
    category: 'Travel & Places'
  },
  {
    emoji: '🚒',
    names: ['fire_engine'],
    tags: [],
    description: 'fire engine',
    category: 'Travel & Places'
  },
  {
    emoji: '🚓',
    names: ['police_car'],
    tags: [],
    description: 'police car',
    category: 'Travel & Places'
  },
  {
    emoji: '🚔',
    names: ['oncoming_police_car'],
    tags: [],
    description: 'oncoming police car',
    category: 'Travel & Places'
  },
  {
    emoji: '🚕',
    names: ['taxi'],
    tags: [],
    description: 'taxi',
    category: 'Travel & Places'
  },
  {
    emoji: '🚖',
    names: ['oncoming_taxi'],
    tags: [],
    description: 'oncoming taxi',
    category: 'Travel & Places'
  },
  {
    emoji: '🚗',
    names: ['car', 'red_car'],
    tags: [],
    description: 'automobile',
    category: 'Travel & Places'
  },
  {
    emoji: '🚘',
    names: ['oncoming_automobile'],
    tags: [],
    description: 'oncoming automobile',
    category: 'Travel & Places'
  },
  {
    emoji: '🚙',
    names: ['blue_car'],
    tags: [],
    description: 'sport utility vehicle',
    category: 'Travel & Places'
  },
  // {
  //   emoji: '🛻',
  //   names: ['pickup_truck'],
  //   tags: [],
  //   description: 'pickup truck',
  //   category: 'Travel & Places'
  // },
  {
    emoji: '🚚',
    names: ['truck'],
    tags: [],
    description: 'delivery truck',
    category: 'Travel & Places'
  },
  {
    emoji: '🚛',
    names: ['articulated_lorry'],
    tags: [],
    description: 'articulated lorry',
    category: 'Travel & Places'
  },
  {
    emoji: '🚜',
    names: ['tractor'],
    tags: [],
    description: 'tractor',
    category: 'Travel & Places'
  },
  {
    emoji: '🏎️',
    names: ['racing_car'],
    tags: [],
    description: 'racing car',
    category: 'Travel & Places'
  },
  {
    emoji: '🏍️',
    names: ['motorcycle'],
    tags: [],
    description: 'motorcycle',
    category: 'Travel & Places'
  },
  {
    emoji: '🛵',
    names: ['motor_scooter'],
    tags: [],
    description: 'motor scooter',
    category: 'Travel & Places'
  },
  // {
  //   emoji: '🦽',
  //   names: ['manual_wheelchair'],
  //   tags: [],
  //   description: 'manual wheelchair',
  //   category: 'Travel & Places'
  // },
  // {
  //   emoji: '🦼',
  //   names: ['motorized_wheelchair'],
  //   tags: [],
  //   description: 'motorized wheelchair',
  //   category: 'Travel & Places'
  // },
  // {
  //   emoji: '🛺',
  //   names: ['auto_rickshaw'],
  //   tags: [],
  //   description: 'auto rickshaw',
  //   category: 'Travel & Places'
  // },
  {
    emoji: '🚲',
    names: ['bike'],
    tags: ['bicycle'],
    description: 'bicycle',
    category: 'Travel & Places'
  },
  {
    emoji: '🛴',
    names: ['kick_scooter'],
    tags: [],
    description: 'kick scooter',
    category: 'Travel & Places'
  },
  {
    emoji: '🛹',
    names: ['skateboard'],
    tags: [],
    description: 'skateboard',
    category: 'Travel & Places'
  },
  // {
  //   emoji: '🛼',
  //   names: ['roller_skate'],
  //   tags: [],
  //   description: 'roller skate',
  //   category: 'Travel & Places'
  // },
  {
    emoji: '🚏',
    names: ['busstop'],
    tags: [],
    description: 'bus stop',
    category: 'Travel & Places'
  },
  {
    emoji: '🛣️',
    names: ['motorway'],
    tags: [],
    description: 'motorway',
    category: 'Travel & Places'
  },
  {
    emoji: '🛤️',
    names: ['railway_track'],
    tags: [],
    description: 'railway track',
    category: 'Travel & Places'
  },
  {
    emoji: '🛢️',
    names: ['oil_drum'],
    tags: [],
    description: 'oil drum',
    category: 'Travel & Places'
  },
  {
    emoji: '⛽',
    names: ['fuelpump'],
    tags: [],
    description: 'fuel pump',
    category: 'Travel & Places'
  },
  // {
  //   emoji: '🛞',
  //   names: ['wheel'],
  //   tags: [],
  //   description: 'wheel',
  //   category: 'Travel & Places'
  // },
  {
    emoji: '🚨',
    names: ['rotating_light'],
    tags: ['911', 'emergency'],
    description: 'police car light',
    category: 'Travel & Places'
  },
  {
    emoji: '🚥',
    names: ['traffic_light'],
    tags: [],
    description: 'horizontal traffic light',
    category: 'Travel & Places'
  },
  {
    emoji: '🚦',
    names: ['vertical_traffic_light'],
    tags: ['semaphore'],
    description: 'vertical traffic light',
    category: 'Travel & Places'
  },
  {
    emoji: '🛑',
    names: ['stop_sign'],
    tags: [],
    description: 'stop sign',
    category: 'Travel & Places'
  },
  {
    emoji: '🚧',
    names: ['construction'],
    tags: ['wip'],
    description: 'construction',
    category: 'Travel & Places'
  },
  {
    emoji: '⚓',
    names: ['anchor'],
    tags: ['ship'],
    description: 'anchor',
    category: 'Travel & Places'
  },
  // {
  //   emoji: '🛟',
  //   names: ['ring_buoy'],
  //   tags: ['life preserver'],
  //   description: 'ring buoy',
  //   category: 'Travel & Places'
  // },
  {
    emoji: '⛵',
    names: ['boat', 'sailboat'],
    tags: [],
    description: 'sailboat',
    category: 'Travel & Places'
  },
  {
    emoji: '🛶',
    names: ['canoe'],
    tags: [],
    description: 'canoe',
    category: 'Travel & Places'
  },
  {
    emoji: '🚤',
    names: ['speedboat'],
    tags: ['ship'],
    description: 'speedboat',
    category: 'Travel & Places'
  },
  {
    emoji: '🛳️',
    names: ['passenger_ship'],
    tags: ['cruise'],
    description: 'passenger ship',
    category: 'Travel & Places'
  },
  {
    emoji: '⛴️',
    names: ['ferry'],
    tags: [],
    description: 'ferry',
    category: 'Travel & Places'
  },
  {
    emoji: '🛥️',
    names: ['motor_boat'],
    tags: [],
    description: 'motor boat',
    category: 'Travel & Places'
  },
  {
    emoji: '🚢',
    names: ['ship'],
    tags: [],
    description: 'ship',
    category: 'Travel & Places'
  },
  {
    emoji: '✈️',
    names: ['airplane'],
    tags: ['flight'],
    description: 'airplane',
    category: 'Travel & Places'
  },
  {
    emoji: '🛩️',
    names: ['small_airplane'],
    tags: ['flight'],
    description: 'small airplane',
    category: 'Travel & Places'
  },
  {
    emoji: '🛫',
    names: ['flight_departure'],
    tags: [],
    description: 'airplane departure',
    category: 'Travel & Places'
  },
  {
    emoji: '🛬',
    names: ['flight_arrival'],
    tags: [],
    description: 'airplane arrival',
    category: 'Travel & Places'
  },
  // {
  //   emoji: '🪂',
  //   names: ['parachute'],
  //   tags: [],
  //   description: 'parachute',
  //   category: 'Travel & Places'
  // },
  {
    emoji: '💺',
    names: ['seat'],
    tags: [],
    description: 'seat',
    category: 'Travel & Places'
  },
  {
    emoji: '🚁',
    names: ['helicopter'],
    tags: [],
    description: 'helicopter',
    category: 'Travel & Places'
  },
  {
    emoji: '🚟',
    names: ['suspension_railway'],
    tags: [],
    description: 'suspension railway',
    category: 'Travel & Places'
  },
  {
    emoji: '🚠',
    names: ['mountain_cableway'],
    tags: [],
    description: 'mountain cableway',
    category: 'Travel & Places'
  },
  {
    emoji: '🚡',
    names: ['aerial_tramway'],
    tags: [],
    description: 'aerial tramway',
    category: 'Travel & Places'
  },
  {
    emoji: '🛰️',
    names: ['artificial_satellite'],
    tags: ['orbit', 'space'],
    description: 'satellite',
    category: 'Travel & Places'
  },
  {
    emoji: '🚀',
    names: ['rocket'],
    tags: ['ship', 'launch'],
    description: 'rocket',
    category: 'Travel & Places'
  },
  {
    emoji: '🛸',
    names: ['flying_saucer'],
    tags: ['ufo'],
    description: 'flying saucer',
    category: 'Travel & Places'
  },
  {
    emoji: '🛎️',
    names: ['bellhop_bell'],
    tags: [],
    description: 'bellhop bell',
    category: 'Travel & Places'
  },
  {
    emoji: '🧳',
    names: ['luggage'],
    tags: [],
    description: 'luggage',
    category: 'Travel & Places'
  },
  {
    emoji: '⌛',
    names: ['hourglass'],
    tags: ['time'],
    description: 'hourglass done',
    category: 'Travel & Places'
  },
  {
    emoji: '⏳',
    names: ['hourglass_flowing_sand'],
    tags: ['time'],
    description: 'hourglass not done',
    category: 'Travel & Places'
  },
  {
    emoji: '⌚',
    names: ['watch'],
    tags: ['time'],
    description: 'watch',
    category: 'Travel & Places'
  },
  {
    emoji: '⏰',
    names: ['alarm_clock'],
    tags: ['morning'],
    description: 'alarm clock',
    category: 'Travel & Places'
  },
  {
    emoji: '⏱️',
    names: ['stopwatch'],
    tags: [],
    description: 'stopwatch',
    category: 'Travel & Places'
  },
  {
    emoji: '⏲️',
    names: ['timer_clock'],
    tags: [],
    description: 'timer clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕰️',
    names: ['mantelpiece_clock'],
    tags: [],
    description: 'mantelpiece clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕛',
    names: ['clock12'],
    tags: [],
    description: 'twelve o’clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕧',
    names: ['clock1230'],
    tags: [],
    description: 'twelve-thirty',
    category: 'Travel & Places'
  },
  {
    emoji: '🕐',
    names: ['clock1'],
    tags: [],
    description: 'one o’clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕜',
    names: ['clock130'],
    tags: [],
    description: 'one-thirty',
    category: 'Travel & Places'
  },
  {
    emoji: '🕑',
    names: ['clock2'],
    tags: [],
    description: 'two o’clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕝',
    names: ['clock230'],
    tags: [],
    description: 'two-thirty',
    category: 'Travel & Places'
  },
  {
    emoji: '🕒',
    names: ['clock3'],
    tags: [],
    description: 'three o’clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕞',
    names: ['clock330'],
    tags: [],
    description: 'three-thirty',
    category: 'Travel & Places'
  },
  {
    emoji: '🕓',
    names: ['clock4'],
    tags: [],
    description: 'four o’clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕟',
    names: ['clock430'],
    tags: [],
    description: 'four-thirty',
    category: 'Travel & Places'
  },
  {
    emoji: '🕔',
    names: ['clock5'],
    tags: [],
    description: 'five o’clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕠',
    names: ['clock530'],
    tags: [],
    description: 'five-thirty',
    category: 'Travel & Places'
  },
  {
    emoji: '🕕',
    names: ['clock6'],
    tags: [],
    description: 'six o’clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕡',
    names: ['clock630'],
    tags: [],
    description: 'six-thirty',
    category: 'Travel & Places'
  },
  {
    emoji: '🕖',
    names: ['clock7'],
    tags: [],
    description: 'seven o’clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕢',
    names: ['clock730'],
    tags: [],
    description: 'seven-thirty',
    category: 'Travel & Places'
  },
  {
    emoji: '🕗',
    names: ['clock8'],
    tags: [],
    description: 'eight o’clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕣',
    names: ['clock830'],
    tags: [],
    description: 'eight-thirty',
    category: 'Travel & Places'
  },
  {
    emoji: '🕘',
    names: ['clock9'],
    tags: [],
    description: 'nine o’clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕤',
    names: ['clock930'],
    tags: [],
    description: 'nine-thirty',
    category: 'Travel & Places'
  },
  {
    emoji: '🕙',
    names: ['clock10'],
    tags: [],
    description: 'ten o’clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕥',
    names: ['clock1030'],
    tags: [],
    description: 'ten-thirty',
    category: 'Travel & Places'
  },
  {
    emoji: '🕚',
    names: ['clock11'],
    tags: [],
    description: 'eleven o’clock',
    category: 'Travel & Places'
  },
  {
    emoji: '🕦',
    names: ['clock1130'],
    tags: [],
    description: 'eleven-thirty',
    category: 'Travel & Places'
  },
  {
    emoji: '🌑',
    names: ['new_moon'],
    tags: [],
    description: 'new moon',
    category: 'Travel & Places'
  },
  {
    emoji: '🌒',
    names: ['waxing_crescent_moon'],
    tags: [],
    description: 'waxing crescent moon',
    category: 'Travel & Places'
  },
  {
    emoji: '🌓',
    names: ['first_quarter_moon'],
    tags: [],
    description: 'first quarter moon',
    category: 'Travel & Places'
  },
  {
    emoji: '🌔',
    names: ['moon', 'waxing_gibbous_moon'],
    tags: [],
    description: 'waxing gibbous moon',
    category: 'Travel & Places'
  },
  {
    emoji: '🌕',
    names: ['full_moon'],
    tags: [],
    description: 'full moon',
    category: 'Travel & Places'
  },
  {
    emoji: '🌖',
    names: ['waning_gibbous_moon'],
    tags: [],
    description: 'waning gibbous moon',
    category: 'Travel & Places'
  },
  {
    emoji: '🌗',
    names: ['last_quarter_moon'],
    tags: [],
    description: 'last quarter moon',
    category: 'Travel & Places'
  },
  {
    emoji: '🌘',
    names: ['waning_crescent_moon'],
    tags: [],
    description: 'waning crescent moon',
    category: 'Travel & Places'
  },
  {
    emoji: '🌙',
    names: ['crescent_moon'],
    tags: ['night'],
    description: 'crescent moon',
    category: 'Travel & Places'
  },
  {
    emoji: '🌚',
    names: ['new_moon_with_face'],
    tags: [],
    description: 'new moon face',
    category: 'Travel & Places'
  },
  {
    emoji: '🌛',
    names: ['first_quarter_moon_with_face'],
    tags: [],
    description: 'first quarter moon face',
    category: 'Travel & Places'
  },
  {
    emoji: '🌜',
    names: ['last_quarter_moon_with_face'],
    tags: [],
    description: 'last quarter moon face',
    category: 'Travel & Places'
  },
  {
    emoji: '🌡️',
    names: ['thermometer'],
    tags: [],
    description: 'thermometer',
    category: 'Travel & Places'
  },
  {
    emoji: '☀️',
    names: ['sunny'],
    tags: ['weather'],
    description: 'sun',
    category: 'Travel & Places'
  },
  {
    emoji: '🌝',
    names: ['full_moon_with_face'],
    tags: [],
    description: 'full moon face',
    category: 'Travel & Places'
  },
  {
    emoji: '🌞',
    names: ['sun_with_face'],
    tags: ['summer'],
    description: 'sun with face',
    category: 'Travel & Places'
  },
  // {
  //   emoji: '🪐',
  //   names: ['ringed_planet'],
  //   tags: [],
  //   description: 'ringed planet',
  //   category: 'Travel & Places'
  // },
  {
    emoji: '⭐',
    names: ['star'],
    tags: [],
    description: 'star',
    category: 'Travel & Places'
  },
  {
    emoji: '🌟',
    names: ['star2'],
    tags: [],
    description: 'glowing star',
    category: 'Travel & Places'
  },
  {
    emoji: '🌠',
    names: ['stars'],
    tags: [],
    description: 'shooting star',
    category: 'Travel & Places'
  },
  {
    emoji: '🌌',
    names: ['milky_way'],
    tags: [],
    description: 'milky way',
    category: 'Travel & Places'
  },
  {
    emoji: '☁️',
    names: ['cloud'],
    tags: [],
    description: 'cloud',
    category: 'Travel & Places'
  },
  {
    emoji: '⛅',
    names: ['partly_sunny'],
    tags: ['weather', 'cloud'],
    description: 'sun behind cloud',
    category: 'Travel & Places'
  },
  {
    emoji: '⛈️',
    names: ['cloud_with_lightning_and_rain'],
    tags: [],
    description: 'cloud with lightning and rain',
    category: 'Travel & Places'
  },
  {
    emoji: '🌤️',
    names: ['sun_behind_small_cloud'],
    tags: [],
    description: 'sun behind small cloud',
    category: 'Travel & Places'
  },
  {
    emoji: '🌥️',
    names: ['sun_behind_large_cloud'],
    tags: [],
    description: 'sun behind large cloud',
    category: 'Travel & Places'
  },
  {
    emoji: '🌦️',
    names: ['sun_behind_rain_cloud'],
    tags: [],
    description: 'sun behind rain cloud',
    category: 'Travel & Places'
  },
  {
    emoji: '🌧️',
    names: ['cloud_with_rain'],
    tags: [],
    description: 'cloud with rain',
    category: 'Travel & Places'
  },
  {
    emoji: '🌨️',
    names: ['cloud_with_snow'],
    tags: [],
    description: 'cloud with snow',
    category: 'Travel & Places'
  },
  {
    emoji: '🌩️',
    names: ['cloud_with_lightning'],
    tags: [],
    description: 'cloud with lightning',
    category: 'Travel & Places'
  },
  {
    emoji: '🌪️',
    names: ['tornado'],
    tags: [],
    description: 'tornado',
    category: 'Travel & Places'
  },
  {
    emoji: '🌫️',
    names: ['fog'],
    tags: [],
    description: 'fog',
    category: 'Travel & Places'
  },
  {
    emoji: '🌬️',
    names: ['wind_face'],
    tags: [],
    description: 'wind face',
    category: 'Travel & Places'
  },
  {
    emoji: '🌀',
    names: ['cyclone'],
    tags: ['swirl'],
    description: 'cyclone',
    category: 'Travel & Places'
  },
  {
    emoji: '🌈',
    names: ['rainbow'],
    tags: [],
    description: 'rainbow',
    category: 'Travel & Places'
  },
  {
    emoji: '🌂',
    names: ['closed_umbrella'],
    tags: ['weather', 'rain'],
    description: 'closed umbrella',
    category: 'Travel & Places'
  },
  {
    emoji: '☂️',
    names: ['open_umbrella'],
    tags: [],
    description: 'umbrella',
    category: 'Travel & Places'
  },
  {
    emoji: '☔',
    names: ['umbrella'],
    tags: ['rain', 'weather'],
    description: 'umbrella with rain drops',
    category: 'Travel & Places'
  },
  {
    emoji: '⛱️',
    names: ['parasol_on_ground'],
    tags: ['beach_umbrella'],
    description: 'umbrella on ground',
    category: 'Travel & Places'
  },
  {
    emoji: '⚡',
    names: ['zap'],
    tags: ['lightning', 'thunder'],
    description: 'high voltage',
    category: 'Travel & Places'
  },
  {
    emoji: '❄️',
    names: ['snowflake'],
    tags: ['winter', 'cold', 'weather'],
    description: 'snowflake',
    category: 'Travel & Places'
  },
  {
    emoji: '☃️',
    names: ['snowman_with_snow'],
    tags: ['winter', 'christmas'],
    description: 'snowman',
    category: 'Travel & Places'
  },
  {
    emoji: '⛄',
    names: ['snowman'],
    tags: ['winter'],
    description: 'snowman without snow',
    category: 'Travel & Places'
  },
  {
    emoji: '☄️',
    names: ['comet'],
    tags: [],
    description: 'comet',
    category: 'Travel & Places'
  },
  {
    emoji: '🔥',
    names: ['fire'],
    tags: ['burn'],
    description: 'fire',
    category: 'Travel & Places'
  },
  {
    emoji: '💧',
    names: ['droplet'],
    tags: ['water'],
    description: 'droplet',
    category: 'Travel & Places'
  },
  {
    emoji: '🌊',
    names: ['ocean'],
    tags: ['sea'],
    description: 'water wave',
    category: 'Travel & Places'
  },
  {
    emoji: '🎃',
    names: ['jack_o_lantern'],
    tags: ['halloween'],
    description: 'jack-o-lantern',
    category: 'Activities'
  },
  {
    emoji: '🎄',
    names: ['christmas_tree'],
    tags: [],
    description: 'Christmas tree',
    category: 'Activities'
  },
  {
    emoji: '🎆',
    names: ['fireworks'],
    tags: ['festival', 'celebration'],
    description: 'fireworks',
    category: 'Activities'
  },
  {
    emoji: '🎇',
    names: ['sparkler'],
    tags: [],
    description: 'sparkler',
    category: 'Activities'
  },
  {
    emoji: '🧨',
    names: ['firecracker'],
    tags: [],
    description: 'firecracker',
    category: 'Activities'
  },
  {
    emoji: '✨',
    names: ['sparkles'],
    tags: ['shiny'],
    description: 'sparkles',
    category: 'Activities'
  },
  {
    emoji: '🎈',
    names: ['balloon'],
    tags: ['party', 'birthday'],
    description: 'balloon',
    category: 'Activities'
  },
  {
    emoji: '🎉',
    names: ['tada'],
    tags: ['hooray', 'party'],
    description: 'party popper',
    category: 'Activities'
  },
  {
    emoji: '🎊',
    names: ['confetti_ball'],
    tags: [],
    description: 'confetti ball',
    category: 'Activities'
  },
  {
    emoji: '🎋',
    names: ['tanabata_tree'],
    tags: [],
    description: 'tanabata tree',
    category: 'Activities'
  },
  {
    emoji: '🎍',
    names: ['bamboo'],
    tags: [],
    description: 'pine decoration',
    category: 'Activities'
  },
  {
    emoji: '🎎',
    names: ['dolls'],
    tags: [],
    description: 'Japanese dolls',
    category: 'Activities'
  },
  {
    emoji: '🎏',
    names: ['flags'],
    tags: [],
    description: 'carp streamer',
    category: 'Activities'
  },
  {
    emoji: '🎐',
    names: ['wind_chime'],
    tags: [],
    description: 'wind chime',
    category: 'Activities'
  },
  {
    emoji: '🎑',
    names: ['rice_scene'],
    tags: [],
    description: 'moon viewing ceremony',
    category: 'Activities'
  },
  {
    emoji: '🧧',
    names: ['red_envelope'],
    tags: [],
    description: 'red envelope',
    category: 'Activities'
  },
  {
    emoji: '🎀',
    names: ['ribbon'],
    tags: [],
    description: 'ribbon',
    category: 'Activities'
  },
  {
    emoji: '🎁',
    names: ['gift'],
    tags: ['present', 'birthday', 'christmas'],
    description: 'wrapped gift',
    category: 'Activities'
  },
  {
    emoji: '🎗️',
    names: ['reminder_ribbon'],
    tags: [],
    description: 'reminder ribbon',
    category: 'Activities'
  },
  {
    emoji: '🎟️',
    names: ['tickets'],
    tags: [],
    description: 'admission tickets',
    category: 'Activities'
  },
  {
    emoji: '🎫',
    names: ['ticket'],
    tags: [],
    description: 'ticket',
    category: 'Activities'
  },
  {
    emoji: '🎖️',
    names: ['medal_military'],
    tags: [],
    description: 'military medal',
    category: 'Activities'
  },
  {
    emoji: '🏆',
    names: ['trophy'],
    tags: ['award', 'contest', 'winner'],
    description: 'trophy',
    category: 'Activities'
  },
  {
    emoji: '🏅',
    names: ['medal_sports'],
    tags: ['gold', 'winner'],
    description: 'sports medal',
    category: 'Activities'
  },
  {
    emoji: '🥇',
    names: ['1st_place_medal'],
    tags: ['gold'],
    description: '1st place medal',
    category: 'Activities'
  },
  {
    emoji: '🥈',
    names: ['2nd_place_medal'],
    tags: ['silver'],
    description: '2nd place medal',
    category: 'Activities'
  },
  {
    emoji: '🥉',
    names: ['3rd_place_medal'],
    tags: ['bronze'],
    description: '3rd place medal',
    category: 'Activities'
  },
  {
    emoji: '⚽',
    names: ['soccer'],
    tags: ['sports'],
    description: 'soccer ball',
    category: 'Activities'
  },
  {
    emoji: '⚾',
    names: ['baseball'],
    tags: ['sports'],
    description: 'baseball',
    category: 'Activities'
  },
  {
    emoji: '🥎',
    names: ['softball'],
    tags: [],
    description: 'softball',
    category: 'Activities'
  },
  {
    emoji: '🏀',
    names: ['basketball'],
    tags: ['sports'],
    description: 'basketball',
    category: 'Activities'
  },
  {
    emoji: '🏐',
    names: ['volleyball'],
    tags: [],
    description: 'volleyball',
    category: 'Activities'
  },
  {
    emoji: '🏈',
    names: ['football'],
    tags: ['sports'],
    description: 'american football',
    category: 'Activities'
  },
  {
    emoji: '🏉',
    names: ['rugby_football'],
    tags: [],
    description: 'rugby football',
    category: 'Activities'
  },
  {
    emoji: '🎾',
    names: ['tennis'],
    tags: ['sports'],
    description: 'tennis',
    category: 'Activities'
  },
  {
    emoji: '🥏',
    names: ['flying_disc'],
    tags: [],
    description: 'flying disc',
    category: 'Activities'
  },
  {
    emoji: '🎳',
    names: ['bowling'],
    tags: [],
    description: 'bowling',
    category: 'Activities'
  },
  {
    emoji: '🏏',
    names: ['cricket_game'],
    tags: [],
    description: 'cricket game',
    category: 'Activities'
  },
  {
    emoji: '🏑',
    names: ['field_hockey'],
    tags: [],
    description: 'field hockey',
    category: 'Activities'
  },
  {
    emoji: '🏒',
    names: ['ice_hockey'],
    tags: [],
    description: 'ice hockey',
    category: 'Activities'
  },
  {
    emoji: '🥍',
    names: ['lacrosse'],
    tags: [],
    description: 'lacrosse',
    category: 'Activities'
  },
  {
    emoji: '🏓',
    names: ['ping_pong'],
    tags: [],
    description: 'ping pong',
    category: 'Activities'
  },
  {
    emoji: '🏸',
    names: ['badminton'],
    tags: [],
    description: 'badminton',
    category: 'Activities'
  },
  {
    emoji: '🥊',
    names: ['boxing_glove'],
    tags: [],
    description: 'boxing glove',
    category: 'Activities'
  },
  {
    emoji: '🥋',
    names: ['martial_arts_uniform'],
    tags: [],
    description: 'martial arts uniform',
    category: 'Activities'
  },
  {
    emoji: '🥅',
    names: ['goal_net'],
    tags: [],
    description: 'goal net',
    category: 'Activities'
  },
  {
    emoji: '⛳',
    names: ['golf'],
    tags: [],
    description: 'flag in hole',
    category: 'Activities'
  },
  {
    emoji: '⛸️',
    names: ['ice_skate'],
    tags: ['skating'],
    description: 'ice skate',
    category: 'Activities'
  },
  {
    emoji: '🎣',
    names: ['fishing_pole_and_fish'],
    tags: [],
    description: 'fishing pole',
    category: 'Activities'
  },
  // {
  //   emoji: '🤿',
  //   names: ['diving_mask'],
  //   tags: [],
  //   description: 'diving mask',
  //   category: 'Activities'
  // },
  {
    emoji: '🎽',
    names: ['running_shirt_with_sash'],
    tags: ['marathon'],
    description: 'running shirt',
    category: 'Activities'
  },
  {
    emoji: '🎿',
    names: ['ski'],
    tags: [],
    description: 'skis',
    category: 'Activities'
  },
  {
    emoji: '🛷',
    names: ['sled'],
    tags: [],
    description: 'sled',
    category: 'Activities'
  },
  {
    emoji: '🥌',
    names: ['curling_stone'],
    tags: [],
    description: 'curling stone',
    category: 'Activities'
  },
  {
    emoji: '🎯',
    names: ['dart'],
    tags: ['target'],
    description: 'bullseye',
    category: 'Activities'
  },
  // {
  //   emoji: '🪀',
  //   names: ['yo_yo'],
  //   tags: [],
  //   description: 'yo-yo',
  //   category: 'Activities'
  // },
  // {
  //   emoji: '🪁',
  //   names: ['kite'],
  //   tags: [],
  //   description: 'kite',
  //   category: 'Activities'
  // },
  {
    emoji: '🔫',
    names: ['gun'],
    tags: ['shoot', 'weapon'],
    description: 'water pistol',
    category: 'Activities'
  },
  {
    emoji: '🎱',
    names: ['8ball'],
    tags: ['pool', 'billiards'],
    description: 'pool 8 ball',
    category: 'Activities'
  },
  {
    emoji: '🔮',
    names: ['crystal_ball'],
    tags: ['fortune'],
    description: 'crystal ball',
    category: 'Activities'
  },
  // {
  //   emoji: '🪄',
  //   names: ['magic_wand'],
  //   tags: [],
  //   description: 'magic wand',
  //   category: 'Activities'
  // },
  {
    emoji: '🎮',
    names: ['video_game'],
    tags: ['play', 'controller', 'console'],
    description: 'video game',
    category: 'Activities'
  },
  {
    emoji: '🕹️',
    names: ['joystick'],
    tags: [],
    description: 'joystick',
    category: 'Activities'
  },
  {
    emoji: '🎰',
    names: ['slot_machine'],
    tags: [],
    description: 'slot machine',
    category: 'Activities'
  },
  {
    emoji: '🎲',
    names: ['game_die'],
    tags: ['dice', 'gambling'],
    description: 'game die',
    category: 'Activities'
  },
  {
    emoji: '🧩',
    names: ['jigsaw'],
    tags: [],
    description: 'puzzle piece',
    category: 'Activities'
  },
  {
    emoji: '🧸',
    names: ['teddy_bear'],
    tags: [],
    description: 'teddy bear',
    category: 'Activities'
  },
  // {
  //   emoji: '🪅',
  //   names: ['pinata'],
  //   tags: [],
  //   description: 'piñata',
  //   category: 'Activities'
  // },
  // {
  //   emoji: '🪩',
  //   names: ['mirror_ball'],
  //   tags: ['disco', 'party'],
  //   description: 'mirror ball',
  //   category: 'Activities'
  // },
  // {
  //   emoji: '🪆',
  //   names: ['nesting_dolls'],
  //   tags: [],
  //   description: 'nesting dolls',
  //   category: 'Activities'
  // },
  {
    emoji: '♠️',
    names: ['spades'],
    tags: [],
    description: 'spade suit',
    category: 'Activities'
  },
  {
    emoji: '♥️',
    names: ['hearts'],
    tags: [],
    description: 'heart suit',
    category: 'Activities'
  },
  {
    emoji: '♦️',
    names: ['diamonds'],
    tags: [],
    description: 'diamond suit',
    category: 'Activities'
  },
  {
    emoji: '♣️',
    names: ['clubs'],
    tags: [],
    description: 'club suit',
    category: 'Activities'
  },
  {
    emoji: '♟️',
    names: ['chess_pawn'],
    tags: [],
    description: 'chess pawn',
    category: 'Activities'
  },
  {
    emoji: '🃏',
    names: ['black_joker'],
    tags: [],
    description: 'joker',
    category: 'Activities'
  },
  {
    emoji: '🀄',
    names: ['mahjong'],
    tags: [],
    description: 'mahjong red dragon',
    category: 'Activities'
  },
  {
    emoji: '🎴',
    names: ['flower_playing_cards'],
    tags: [],
    description: 'flower playing cards',
    category: 'Activities'
  },
  {
    emoji: '🎭',
    names: ['performing_arts'],
    tags: ['theater', 'drama'],
    description: 'performing arts',
    category: 'Activities'
  },
  {
    emoji: '🖼️',
    names: ['framed_picture'],
    tags: [],
    description: 'framed picture',
    category: 'Activities'
  },
  {
    emoji: '🎨',
    names: ['art'],
    tags: ['design', 'paint'],
    description: 'artist palette',
    category: 'Activities'
  },
  {
    emoji: '🧵',
    names: ['thread'],
    tags: [],
    description: 'thread',
    category: 'Activities'
  },
  // {
  //   emoji: '🪡',
  //   names: ['sewing_needle'],
  //   tags: [],
  //   description: 'sewing needle',
  //   category: 'Activities'
  // },
  {
    emoji: '🧶',
    names: ['yarn'],
    tags: [],
    description: 'yarn',
    category: 'Activities'
  },
  // {
  //   emoji: '🪢',
  //   names: ['knot'],
  //   tags: [],
  //   description: 'knot',
  //   category: 'Activities'
  // },
  {
    emoji: '👓',
    names: ['eyeglasses'],
    tags: ['glasses'],
    description: 'glasses',
    category: 'Objects'
  },
  {
    emoji: '🕶️',
    names: ['dark_sunglasses'],
    tags: [],
    description: 'sunglasses',
    category: 'Objects'
  },
  {
    emoji: '🥽',
    names: ['goggles'],
    tags: [],
    description: 'goggles',
    category: 'Objects'
  },
  {
    emoji: '🥼',
    names: ['lab_coat'],
    tags: [],
    description: 'lab coat',
    category: 'Objects'
  },
  // {
  //   emoji: '🦺',
  //   names: ['safety_vest'],
  //   tags: [],
  //   description: 'safety vest',
  //   category: 'Objects'
  // },
  {
    emoji: '👔',
    names: ['necktie'],
    tags: ['shirt', 'formal'],
    description: 'necktie',
    category: 'Objects'
  },
  {
    emoji: '👕',
    names: ['shirt', 'tshirt'],
    tags: [],
    description: 't-shirt',
    category: 'Objects'
  },
  {
    emoji: '👖',
    names: ['jeans'],
    tags: ['pants'],
    description: 'jeans',
    category: 'Objects'
  },
  {
    emoji: '🧣',
    names: ['scarf'],
    tags: [],
    description: 'scarf',
    category: 'Objects'
  },
  {
    emoji: '🧤',
    names: ['gloves'],
    tags: [],
    description: 'gloves',
    category: 'Objects'
  },
  {
    emoji: '🧥',
    names: ['coat'],
    tags: [],
    description: 'coat',
    category: 'Objects'
  },
  {
    emoji: '🧦',
    names: ['socks'],
    tags: [],
    description: 'socks',
    category: 'Objects'
  },
  {
    emoji: '👗',
    names: ['dress'],
    tags: [],
    description: 'dress',
    category: 'Objects'
  },
  {
    emoji: '👘',
    names: ['kimono'],
    tags: [],
    description: 'kimono',
    category: 'Objects'
  },
  // {
  //   emoji: '🥻',
  //   names: ['sari'],
  //   tags: [],
  //   description: 'sari',
  //   category: 'Objects'
  // },
  // {
  //   emoji: '🩱',
  //   names: ['one_piece_swimsuit'],
  //   tags: [],
  //   description: 'one-piece swimsuit',
  //   category: 'Objects'
  // },
  // {
  //   emoji: '🩲',
  //   names: ['swim_brief'],
  //   tags: [],
  //   description: 'briefs',
  //   category: 'Objects'
  // },
  // {
  //   emoji: '🩳',
  //   names: ['shorts'],
  //   tags: [],
  //   description: 'shorts',
  //   category: 'Objects'
  // },
  {
    emoji: '👙',
    names: ['bikini'],
    tags: ['beach'],
    description: 'bikini',
    category: 'Objects'
  },
  {
    emoji: '👚',
    names: ['womans_clothes'],
    tags: [],
    description: 'woman’s clothes',
    category: 'Objects'
  },
  {
    emoji: '🪭',
    names: ['folding_hand_fan'],
    tags: ['sensu'],
    description: 'folding hand fan',
    category: 'Objects'
  },
  {
    emoji: '👛',
    names: ['purse'],
    tags: [],
    description: 'purse',
    category: 'Objects'
  },
  {
    emoji: '👜',
    names: ['handbag'],
    tags: ['bag'],
    description: 'handbag',
    category: 'Objects'
  },
  {
    emoji: '👝',
    names: ['pouch'],
    tags: ['bag'],
    description: 'clutch bag',
    category: 'Objects'
  },
  {
    emoji: '🛍️',
    names: ['shopping'],
    tags: ['bags'],
    description: 'shopping bags',
    category: 'Objects'
  },
  {
    emoji: '🎒',
    names: ['school_satchel'],
    tags: [],
    description: 'backpack',
    category: 'Objects'
  },
  // {
  //   emoji: '🩴',
  //   names: ['thong_sandal'],
  //   tags: [],
  //   description: 'thong sandal',
  //   category: 'Objects'
  // },
  {
    emoji: '👞',
    names: ['mans_shoe', 'shoe'],
    tags: [],
    description: 'man’s shoe',
    category: 'Objects'
  },
  {
    emoji: '👟',
    names: ['athletic_shoe'],
    tags: ['sneaker', 'sport', 'running'],
    description: 'running shoe',
    category: 'Objects'
  },
  {
    emoji: '🥾',
    names: ['hiking_boot'],
    tags: [],
    description: 'hiking boot',
    category: 'Objects'
  },
  {
    emoji: '🥿',
    names: ['flat_shoe'],
    tags: [],
    description: 'flat shoe',
    category: 'Objects'
  },
  {
    emoji: '👠',
    names: ['high_heel'],
    tags: ['shoe'],
    description: 'high-heeled shoe',
    category: 'Objects'
  },
  {
    emoji: '👡',
    names: ['sandal'],
    tags: ['shoe'],
    description: 'woman’s sandal',
    category: 'Objects'
  },
  // {
  //   emoji: '🩰',
  //   names: ['ballet_shoes'],
  //   tags: [],
  //   description: 'ballet shoes',
  //   category: 'Objects'
  // },
  {
    emoji: '👢',
    names: ['boot'],
    tags: [],
    description: 'woman’s boot',
    category: 'Objects'
  },
  // {
  //   emoji: '🪮',
  //   names: ['hair_pick'],
  //   tags: [],
  //   description: 'hair pick',
  //   category: 'Objects'
  // },
  {
    emoji: '👑',
    names: ['crown'],
    tags: ['king', 'queen', 'royal'],
    description: 'crown',
    category: 'Objects'
  },
  {
    emoji: '👒',
    names: ['womans_hat'],
    tags: [],
    description: 'woman’s hat',
    category: 'Objects'
  },
  {
    emoji: '🎩',
    names: ['tophat'],
    tags: ['hat', 'classy'],
    description: 'top hat',
    category: 'Objects'
  },
  {
    emoji: '🎓',
    names: ['mortar_board'],
    tags: ['education', 'college', 'university', 'graduation'],
    description: 'graduation cap',
    category: 'Objects'
  },
  {
    emoji: '🧢',
    names: ['billed_cap'],
    tags: [],
    description: 'billed cap',
    category: 'Objects'
  },
  // {
  //   emoji: '🪖',
  //   names: ['military_helmet'],
  //   tags: [],
  //   description: 'military helmet',
  //   category: 'Objects'
  // },
  {
    emoji: '⛑️',
    names: ['rescue_worker_helmet'],
    tags: [],
    description: 'rescue worker’s helmet',
    category: 'Objects'
  },
  {
    emoji: '📿',
    names: ['prayer_beads'],
    tags: [],
    description: 'prayer beads',
    category: 'Objects'
  },
  {
    emoji: '💄',
    names: ['lipstick'],
    tags: ['makeup'],
    description: 'lipstick',
    category: 'Objects'
  },
  {
    emoji: '💍',
    names: ['ring'],
    tags: ['wedding', 'marriage', 'engaged'],
    description: 'ring',
    category: 'Objects'
  },
  {
    emoji: '💎',
    names: ['gem'],
    tags: ['diamond'],
    description: 'gem stone',
    category: 'Objects'
  },
  {
    emoji: '🔇',
    names: ['mute'],
    tags: ['sound', 'volume'],
    description: 'muted speaker',
    category: 'Objects'
  },
  {
    emoji: '🔈',
    names: ['speaker'],
    tags: [],
    description: 'speaker low volume',
    category: 'Objects'
  },
  {
    emoji: '🔉',
    names: ['sound'],
    tags: ['volume'],
    description: 'speaker medium volume',
    category: 'Objects'
  },
  {
    emoji: '🔊',
    names: ['loud_sound'],
    tags: ['volume'],
    description: 'speaker high volume',
    category: 'Objects'
  },
  {
    emoji: '📢',
    names: ['loudspeaker'],
    tags: ['announcement'],
    description: 'loudspeaker',
    category: 'Objects'
  },
  {
    emoji: '📣',
    names: ['mega'],
    tags: [],
    description: 'megaphone',
    category: 'Objects'
  },
  {
    emoji: '📯',
    names: ['postal_horn'],
    tags: [],
    description: 'postal horn',
    category: 'Objects'
  },
  {
    emoji: '🔔',
    names: ['bell'],
    tags: ['sound', 'notification'],
    description: 'bell',
    category: 'Objects'
  },
  {
    emoji: '🔕',
    names: ['no_bell'],
    tags: ['volume', 'off'],
    description: 'bell with slash',
    category: 'Objects'
  },
  {
    emoji: '🎼',
    names: ['musical_score'],
    tags: [],
    description: 'musical score',
    category: 'Objects'
  },
  {
    emoji: '🎵',
    names: ['musical_note'],
    tags: [],
    description: 'musical note',
    category: 'Objects'
  },
  {
    emoji: '🎶',
    names: ['notes'],
    tags: ['music'],
    description: 'musical notes',
    category: 'Objects'
  },
  {
    emoji: '🎙️',
    names: ['studio_microphone'],
    tags: ['podcast'],
    description: 'studio microphone',
    category: 'Objects'
  },
  {
    emoji: '🎚️',
    names: ['level_slider'],
    tags: [],
    description: 'level slider',
    category: 'Objects'
  },
  {
    emoji: '🎛️',
    names: ['control_knobs'],
    tags: [],
    description: 'control knobs',
    category: 'Objects'
  },
  {
    emoji: '🎤',
    names: ['microphone'],
    tags: ['sing'],
    description: 'microphone',
    category: 'Objects'
  },
  {
    emoji: '🎧',
    names: ['headphones'],
    tags: ['music', 'earphones'],
    description: 'headphone',
    category: 'Objects'
  },
  {
    emoji: '📻',
    names: ['radio'],
    tags: ['podcast'],
    description: 'radio',
    category: 'Objects'
  },
  {
    emoji: '🎷',
    names: ['saxophone'],
    tags: [],
    description: 'saxophone',
    category: 'Objects'
  },
  // {
  //   emoji: '🪗',
  //   names: ['accordion'],
  //   tags: [],
  //   description: 'accordion',
  //   category: 'Objects'
  // },
  {
    emoji: '🎸',
    names: ['guitar'],
    tags: ['rock'],
    description: 'guitar',
    category: 'Objects'
  },
  {
    emoji: '🎹',
    names: ['musical_keyboard'],
    tags: ['piano'],
    description: 'musical keyboard',
    category: 'Objects'
  },
  {
    emoji: '🎺',
    names: ['trumpet'],
    tags: [],
    description: 'trumpet',
    category: 'Objects'
  },
  {
    emoji: '🎻',
    names: ['violin'],
    tags: [],
    description: 'violin',
    category: 'Objects'
  },
  // {
  //   emoji: '🪕',
  //   names: ['banjo'],
  //   tags: [],
  //   description: 'banjo',
  //   category: 'Objects'
  // },
  {
    emoji: '🥁',
    names: ['drum'],
    tags: [],
    description: 'drum',
    category: 'Objects'
  },
  // {
  //   emoji: '🪘',
  //   names: ['long_drum'],
  //   tags: [],
  //   description: 'long drum',
  //   category: 'Objects'
  // },
  // {
  //   emoji: '🪇',
  //   names: ['maracas'],
  //   tags: ['shaker'],
  //   description: 'maracas',
  //   category: 'Objects'
  // },
  // {
  //   emoji: '🪈',
  //   names: ['flute'],
  //   tags: ['recorder'],
  //   description: 'flute',
  //   category: 'Objects'
  // },
  {
    emoji: '📱',
    names: ['iphone'],
    tags: ['smartphone', 'mobile'],
    description: 'mobile phone',
    category: 'Objects'
  },
  {
    emoji: '📲',
    names: ['calling'],
    tags: ['call', 'incoming'],
    description: 'mobile phone with arrow',
    category: 'Objects'
  },
  {
    emoji: '☎️',
    names: ['phone', 'telephone'],
    tags: [],
    description: 'telephone',
    category: 'Objects'
  },
  {
    emoji: '📞',
    names: ['telephone_receiver'],
    tags: ['phone', 'call'],
    description: 'telephone receiver',
    category: 'Objects'
  },
  {
    emoji: '📟',
    names: ['pager'],
    tags: [],
    description: 'pager',
    category: 'Objects'
  },
  {
    emoji: '📠',
    names: ['fax'],
    tags: [],
    description: 'fax machine',
    category: 'Objects'
  },
  {
    emoji: '🔋',
    names: ['battery'],
    tags: ['power'],
    description: 'battery',
    category: 'Objects'
  },
  // {
  //   emoji: '🪫',
  //   names: ['low_battery'],
  //   tags: [],
  //   description: 'low battery',
  //   category: 'Objects'
  // },
  {
    emoji: '🔌',
    names: ['electric_plug'],
    tags: [],
    description: 'electric plug',
    category: 'Objects'
  },
  {
    emoji: '💻',
    names: ['computer'],
    tags: ['desktop', 'screen'],
    description: 'laptop',
    category: 'Objects'
  },
  {
    emoji: '🖥️',
    names: ['desktop_computer'],
    tags: [],
    description: 'desktop computer',
    category: 'Objects'
  },
  {
    emoji: '🖨️',
    names: ['printer'],
    tags: [],
    description: 'printer',
    category: 'Objects'
  },
  {
    emoji: '⌨️',
    names: ['keyboard'],
    tags: [],
    description: 'keyboard',
    category: 'Objects'
  },
  {
    emoji: '🖱️',
    names: ['computer_mouse'],
    tags: [],
    description: 'computer mouse',
    category: 'Objects'
  },
  {
    emoji: '🖲️',
    names: ['trackball'],
    tags: [],
    description: 'trackball',
    category: 'Objects'
  },
  {
    emoji: '💽',
    names: ['minidisc'],
    tags: [],
    description: 'computer disk',
    category: 'Objects'
  },
  {
    emoji: '💾',
    names: ['floppy_disk'],
    tags: ['save'],
    description: 'floppy disk',
    category: 'Objects'
  },
  {
    emoji: '💿',
    names: ['cd'],
    tags: [],
    description: 'optical disk',
    category: 'Objects'
  },
  {
    emoji: '📀',
    names: ['dvd'],
    tags: [],
    description: 'dvd',
    category: 'Objects'
  },
  {
    emoji: '🧮',
    names: ['abacus'],
    tags: [],
    description: 'abacus',
    category: 'Objects'
  },
  {
    emoji: '🎥',
    names: ['movie_camera'],
    tags: ['film', 'video'],
    description: 'movie camera',
    category: 'Objects'
  },
  {
    emoji: '🎞️',
    names: ['film_strip'],
    tags: [],
    description: 'film frames',
    category: 'Objects'
  },
  {
    emoji: '📽️',
    names: ['film_projector'],
    tags: [],
    description: 'film projector',
    category: 'Objects'
  },
  {
    emoji: '🎬',
    names: ['clapper'],
    tags: ['film'],
    description: 'clapper board',
    category: 'Objects'
  },
  {
    emoji: '📺',
    names: ['tv'],
    tags: [],
    description: 'television',
    category: 'Objects'
  },
  {
    emoji: '📷',
    names: ['camera'],
    tags: ['photo'],
    description: 'camera',
    category: 'Objects'
  },
  {
    emoji: '📸',
    names: ['camera_flash'],
    tags: ['photo'],
    description: 'camera with flash',
    category: 'Objects'
  },
  {
    emoji: '📹',
    names: ['video_camera'],
    tags: [],
    description: 'video camera',
    category: 'Objects'
  },
  {
    emoji: '📼',
    names: ['vhs'],
    tags: [],
    description: 'videocassette',
    category: 'Objects'
  },
  {
    emoji: '🔍',
    names: ['mag'],
    tags: ['search', 'zoom'],
    description: 'magnifying glass tilted left',
    category: 'Objects'
  },
  {
    emoji: '🔎',
    names: ['mag_right'],
    tags: [],
    description: 'magnifying glass tilted right',
    category: 'Objects'
  },
  {
    emoji: '🕯️',
    names: ['candle'],
    tags: [],
    description: 'candle',
    category: 'Objects'
  },
  {
    emoji: '💡',
    names: ['bulb'],
    tags: ['idea', 'light'],
    description: 'light bulb',
    category: 'Objects'
  },
  {
    emoji: '🔦',
    names: ['flashlight'],
    tags: [],
    description: 'flashlight',
    category: 'Objects'
  },
  {
    emoji: '🏮',
    names: ['izakaya_lantern', 'lantern'],
    tags: [],
    description: 'red paper lantern',
    category: 'Objects'
  },
  // {
  //   emoji: '🪔',
  //   names: ['diya_lamp'],
  //   tags: [],
  //   description: 'diya lamp',
  //   category: 'Objects'
  // },
  {
    emoji: '📔',
    names: ['notebook_with_decorative_cover'],
    tags: [],
    description: 'notebook with decorative cover',
    category: 'Objects'
  },
  {
    emoji: '📕',
    names: ['closed_book'],
    tags: [],
    description: 'closed book',
    category: 'Objects'
  },
  {
    emoji: '📖',
    names: ['book', 'open_book'],
    tags: [],
    description: 'open book',
    category: 'Objects'
  },
  {
    emoji: '📗',
    names: ['green_book'],
    tags: [],
    description: 'green book',
    category: 'Objects'
  },
  {
    emoji: '📘',
    names: ['blue_book'],
    tags: [],
    description: 'blue book',
    category: 'Objects'
  },
  {
    emoji: '📙',
    names: ['orange_book'],
    tags: [],
    description: 'orange book',
    category: 'Objects'
  },
  {
    emoji: '📚',
    names: ['books'],
    tags: ['library'],
    description: 'books',
    category: 'Objects'
  },
  {
    emoji: '📓',
    names: ['notebook'],
    tags: [],
    description: 'notebook',
    category: 'Objects'
  },
  {
    emoji: '📒',
    names: ['ledger'],
    tags: [],
    description: 'ledger',
    category: 'Objects'
  },
  {
    emoji: '📃',
    names: ['page_with_curl'],
    tags: [],
    description: 'page with curl',
    category: 'Objects'
  },
  {
    emoji: '📜',
    names: ['scroll'],
    tags: ['document'],
    description: 'scroll',
    category: 'Objects'
  },
  {
    emoji: '📄',
    names: ['page_facing_up'],
    tags: ['document'],
    description: 'page facing up',
    category: 'Objects'
  },
  {
    emoji: '📰',
    names: ['newspaper'],
    tags: ['press'],
    description: 'newspaper',
    category: 'Objects'
  },
  {
    emoji: '🗞️',
    names: ['newspaper_roll'],
    tags: ['press'],
    description: 'rolled-up newspaper',
    category: 'Objects'
  },
  {
    emoji: '📑',
    names: ['bookmark_tabs'],
    tags: [],
    description: 'bookmark tabs',
    category: 'Objects'
  },
  {
    emoji: '🔖',
    names: ['bookmark'],
    tags: [],
    description: 'bookmark',
    category: 'Objects'
  },
  {
    emoji: '🏷️',
    names: ['label'],
    tags: ['tag'],
    description: 'label',
    category: 'Objects'
  },
  {
    emoji: '💰',
    names: ['moneybag'],
    tags: ['dollar', 'cream'],
    description: 'money bag',
    category: 'Objects'
  },
  // {
  //   emoji: '🪙',
  //   names: ['coin'],
  //   tags: [],
  //   description: 'coin',
  //   category: 'Objects'
  // },
  {
    emoji: '💴',
    names: ['yen'],
    tags: [],
    description: 'yen banknote',
    category: 'Objects'
  },
  {
    emoji: '💵',
    names: ['dollar'],
    tags: ['money'],
    description: 'dollar banknote',
    category: 'Objects'
  },
  {
    emoji: '💶',
    names: ['euro'],
    tags: [],
    description: 'euro banknote',
    category: 'Objects'
  },
  {
    emoji: '💷',
    names: ['pound'],
    tags: [],
    description: 'pound banknote',
    category: 'Objects'
  },
  {
    emoji: '💸',
    names: ['money_with_wings'],
    tags: ['dollar'],
    description: 'money with wings',
    category: 'Objects'
  },
  {
    emoji: '💳',
    names: ['credit_card'],
    tags: ['subscription'],
    description: 'credit card',
    category: 'Objects'
  },
  {
    emoji: '🧾',
    names: ['receipt'],
    tags: [],
    description: 'receipt',
    category: 'Objects'
  },
  {
    emoji: '💹',
    names: ['chart'],
    tags: [],
    description: 'chart increasing with yen',
    category: 'Objects'
  },
  {
    emoji: '✉️',
    names: ['envelope'],
    tags: ['letter', 'email'],
    description: 'envelope',
    category: 'Objects'
  },
  {
    emoji: '📧',
    names: ['email', 'e-mail'],
    tags: [],
    description: 'e-mail',
    category: 'Objects'
  },
  {
    emoji: '📨',
    names: ['incoming_envelope'],
    tags: [],
    description: 'incoming envelope',
    category: 'Objects'
  },
  {
    emoji: '📩',
    names: ['envelope_with_arrow'],
    tags: [],
    description: 'envelope with arrow',
    category: 'Objects'
  },
  {
    emoji: '📤',
    names: ['outbox_tray'],
    tags: [],
    description: 'outbox tray',
    category: 'Objects'
  },
  {
    emoji: '📥',
    names: ['inbox_tray'],
    tags: [],
    description: 'inbox tray',
    category: 'Objects'
  },
  {
    emoji: '📦',
    names: ['package'],
    tags: ['shipping'],
    description: 'package',
    category: 'Objects'
  },
  {
    emoji: '📫',
    names: ['mailbox'],
    tags: [],
    description: 'closed mailbox with raised flag',
    category: 'Objects'
  },
  {
    emoji: '📪',
    names: ['mailbox_closed'],
    tags: [],
    description: 'closed mailbox with lowered flag',
    category: 'Objects'
  },
  {
    emoji: '📬',
    names: ['mailbox_with_mail'],
    tags: [],
    description: 'open mailbox with raised flag',
    category: 'Objects'
  },
  {
    emoji: '📭',
    names: ['mailbox_with_no_mail'],
    tags: [],
    description: 'open mailbox with lowered flag',
    category: 'Objects'
  },
  {
    emoji: '📮',
    names: ['postbox'],
    tags: [],
    description: 'postbox',
    category: 'Objects'
  },
  {
    emoji: '🗳️',
    names: ['ballot_box'],
    tags: [],
    description: 'ballot box with ballot',
    category: 'Objects'
  },
  {
    emoji: '✏️',
    names: ['pencil2'],
    tags: [],
    description: 'pencil',
    category: 'Objects'
  },
  {
    emoji: '✒️',
    names: ['black_nib'],
    tags: [],
    description: 'black nib',
    category: 'Objects'
  },
  {
    emoji: '🖋️',
    names: ['fountain_pen'],
    tags: [],
    description: 'fountain pen',
    category: 'Objects'
  },
  {
    emoji: '🖊️',
    names: ['pen'],
    tags: [],
    description: 'pen',
    category: 'Objects'
  },
  {
    emoji: '🖌️',
    names: ['paintbrush'],
    tags: [],
    description: 'paintbrush',
    category: 'Objects'
  },
  {
    emoji: '🖍️',
    names: ['crayon'],
    tags: [],
    description: 'crayon',
    category: 'Objects'
  },
  {
    emoji: '📝',
    names: ['memo', 'pencil'],
    tags: ['document', 'note'],
    description: 'memo',
    category: 'Objects'
  },
  {
    emoji: '💼',
    names: ['briefcase'],
    tags: ['business'],
    description: 'briefcase',
    category: 'Objects'
  },
  {
    emoji: '📁',
    names: ['file_folder'],
    tags: ['directory'],
    description: 'file folder',
    category: 'Objects'
  },
  {
    emoji: '📂',
    names: ['open_file_folder'],
    tags: [],
    description: 'open file folder',
    category: 'Objects'
  },
  {
    emoji: '🗂️',
    names: ['card_index_dividers'],
    tags: [],
    description: 'card index dividers',
    category: 'Objects'
  },
  {
    emoji: '📅',
    names: ['date'],
    tags: ['calendar', 'schedule'],
    description: 'calendar',
    category: 'Objects'
  },
  {
    emoji: '📆',
    names: ['calendar'],
    tags: ['schedule'],
    description: 'tear-off calendar',
    category: 'Objects'
  },
  {
    emoji: '🗒️',
    names: ['spiral_notepad'],
    tags: [],
    description: 'spiral notepad',
    category: 'Objects'
  },
  {
    emoji: '🗓️',
    names: ['spiral_calendar'],
    tags: [],
    description: 'spiral calendar',
    category: 'Objects'
  },
  {
    emoji: '📇',
    names: ['card_index'],
    tags: [],
    description: 'card index',
    category: 'Objects'
  },
  {
    emoji: '📈',
    names: ['chart_with_upwards_trend'],
    tags: ['graph', 'metrics'],
    description: 'chart increasing',
    category: 'Objects'
  },
  {
    emoji: '📉',
    names: ['chart_with_downwards_trend'],
    tags: ['graph', 'metrics'],
    description: 'chart decreasing',
    category: 'Objects'
  },
  {
    emoji: '📊',
    names: ['bar_chart'],
    tags: ['stats', 'metrics'],
    description: 'bar chart',
    category: 'Objects'
  },
  {
    emoji: '📋',
    names: ['clipboard'],
    tags: [],
    description: 'clipboard',
    category: 'Objects'
  },
  {
    emoji: '📌',
    names: ['pushpin'],
    tags: ['location'],
    description: 'pushpin',
    category: 'Objects'
  },
  {
    emoji: '📍',
    names: ['round_pushpin'],
    tags: ['location'],
    description: 'round pushpin',
    category: 'Objects'
  },
  {
    emoji: '📎',
    names: ['paperclip'],
    tags: [],
    description: 'paperclip',
    category: 'Objects'
  },
  {
    emoji: '🖇️',
    names: ['paperclips'],
    tags: [],
    description: 'linked paperclips',
    category: 'Objects'
  },
  {
    emoji: '📏',
    names: ['straight_ruler'],
    tags: [],
    description: 'straight ruler',
    category: 'Objects'
  },
  {
    emoji: '📐',
    names: ['triangular_ruler'],
    tags: [],
    description: 'triangular ruler',
    category: 'Objects'
  },
  {
    emoji: '✂️',
    names: ['scissors'],
    tags: ['cut'],
    description: 'scissors',
    category: 'Objects'
  },
  {
    emoji: '🗃️',
    names: ['card_file_box'],
    tags: [],
    description: 'card file box',
    category: 'Objects'
  },
  {
    emoji: '🗄️',
    names: ['file_cabinet'],
    tags: [],
    description: 'file cabinet',
    category: 'Objects'
  },
  {
    emoji: '🗑️',
    names: ['wastebasket'],
    tags: ['trash'],
    description: 'wastebasket',
    category: 'Objects'
  },
  {
    emoji: '🔒',
    names: ['lock'],
    tags: ['security', 'private'],
    description: 'locked',
    category: 'Objects'
  },
  {
    emoji: '🔓',
    names: ['unlock'],
    tags: ['security'],
    description: 'unlocked',
    category: 'Objects'
  },
  {
    emoji: '🔏',
    names: ['lock_with_ink_pen'],
    tags: [],
    description: 'locked with pen',
    category: 'Objects'
  },
  {
    emoji: '🔐',
    names: ['closed_lock_with_key'],
    tags: ['security'],
    description: 'locked with key',
    category: 'Objects'
  },
  {
    emoji: '🔑',
    names: ['key'],
    tags: ['lock', 'password'],
    description: 'key',
    category: 'Objects'
  },
  {
    emoji: '🗝️',
    names: ['old_key'],
    tags: [],
    description: 'old key',
    category: 'Objects'
  },
  {
    emoji: '🔨',
    names: ['hammer'],
    tags: ['tool'],
    description: 'hammer',
    category: 'Objects'
  },
  // {
  //   emoji: '🪓',
  //   names: ['axe'],
  //   tags: [],
  //   description: 'axe',
  //   category: 'Objects'
  // },
  {
    emoji: '⛏️',
    names: ['pick'],
    tags: [],
    description: 'pick',
    category: 'Objects'
  },
  {
    emoji: '⚒️',
    names: ['hammer_and_pick'],
    tags: [],
    description: 'hammer and pick',
    category: 'Objects'
  },
  {
    emoji: '🛠️',
    names: ['hammer_and_wrench'],
    tags: [],
    description: 'hammer and wrench',
    category: 'Objects'
  },
  {
    emoji: '🗡️',
    names: ['dagger'],
    tags: [],
    description: 'dagger',
    category: 'Objects'
  },
  {
    emoji: '⚔️',
    names: ['crossed_swords'],
    tags: [],
    description: 'crossed swords',
    category: 'Objects'
  },
  {
    emoji: '💣',
    names: ['bomb'],
    tags: ['boom'],
    description: 'bomb',
    category: 'Objects'
  },
  // {
  //   emoji: '🪃',
  //   names: ['boomerang'],
  //   tags: [],
  //   description: 'boomerang',
  //   category: 'Objects'
  // },
  {
    emoji: '🏹',
    names: ['bow_and_arrow'],
    tags: ['archery'],
    description: 'bow and arrow',
    category: 'Objects'
  },
  {
    emoji: '🛡️',
    names: ['shield'],
    tags: [],
    description: 'shield',
    category: 'Objects'
  },
  // {
  //   emoji: '🪚',
  //   names: ['carpentry_saw'],
  //   tags: [],
  //   description: 'carpentry saw',
  //   category: 'Objects'
  // },
  {
    emoji: '🔧',
    names: ['wrench'],
    tags: ['tool'],
    description: 'wrench',
    category: 'Objects'
  },
  // {
  //   emoji: '🪛',
  //   names: ['screwdriver'],
  //   tags: [],
  //   description: 'screwdriver',
  //   category: 'Objects'
  // },
  {
    emoji: '🔩',
    names: ['nut_and_bolt'],
    tags: [],
    description: 'nut and bolt',
    category: 'Objects'
  },
  {
    emoji: '⚙️',
    names: ['gear'],
    tags: [],
    description: 'gear',
    category: 'Objects'
  },
  {
    emoji: '🗜️',
    names: ['clamp'],
    tags: [],
    description: 'clamp',
    category: 'Objects'
  },
  {
    emoji: '⚖️',
    names: ['balance_scale'],
    tags: [],
    description: 'balance scale',
    category: 'Objects'
  },
  // {
  //   emoji: '🦯',
  //   names: ['probing_cane'],
  //   tags: [],
  //   description: 'white cane',
  //   category: 'Objects'
  // },
  {
    emoji: '🔗',
    names: ['link'],
    tags: [],
    description: 'link',
    category: 'Objects'
  },
  {
    emoji: '⛓️',
    names: ['chains'],
    tags: [],
    description: 'chains',
    category: 'Objects'
  },
  // {
  //   emoji: '🪝',
  //   names: ['hook'],
  //   tags: [],
  //   description: 'hook',
  //   category: 'Objects'
  // },
  {
    emoji: '🧰',
    names: ['toolbox'],
    tags: [],
    description: 'toolbox',
    category: 'Objects'
  },
  {
    emoji: '🧲',
    names: ['magnet'],
    tags: [],
    description: 'magnet',
    category: 'Objects'
  },
  // {
  //   emoji: '🪜',
  //   names: ['ladder'],
  //   tags: [],
  //   description: 'ladder',
  //   category: 'Objects'
  // },
  {
    emoji: '⚗️',
    names: ['alembic'],
    tags: [],
    description: 'alembic',
    category: 'Objects'
  },
  {
    emoji: '🧪',
    names: ['test_tube'],
    tags: [],
    description: 'test tube',
    category: 'Objects'
  },
  {
    emoji: '🧫',
    names: ['petri_dish'],
    tags: [],
    description: 'petri dish',
    category: 'Objects'
  },
  {
    emoji: '🧬',
    names: ['dna'],
    tags: [],
    description: 'dna',
    category: 'Objects'
  },
  {
    emoji: '🔬',
    names: ['microscope'],
    tags: ['science', 'laboratory', 'investigate'],
    description: 'microscope',
    category: 'Objects'
  },
  {
    emoji: '🔭',
    names: ['telescope'],
    tags: [],
    description: 'telescope',
    category: 'Objects'
  },
  {
    emoji: '📡',
    names: ['satellite'],
    tags: ['signal'],
    description: 'satellite antenna',
    category: 'Objects'
  },
  {
    emoji: '💉',
    names: ['syringe'],
    tags: ['health', 'hospital', 'needle'],
    description: 'syringe',
    category: 'Objects'
  },
  // {
  //   emoji: '🩸',
  //   names: ['drop_of_blood'],
  //   tags: [],
  //   description: 'drop of blood',
  //   category: 'Objects'
  // },
  {
    emoji: '💊',
    names: ['pill'],
    tags: ['health', 'medicine'],
    description: 'pill',
    category: 'Objects'
  },
  // {
  //   emoji: '🩹',
  //   names: ['adhesive_bandage'],
  //   tags: [],
  //   description: 'adhesive bandage',
  //   category: 'Objects'
  // },
  // {
  //   emoji: '🩼',
  //   names: ['crutch'],
  //   tags: [],
  //   description: 'crutch',
  //   category: 'Objects'
  // },
  // {
  //   emoji: '🩺',
  //   names: ['stethoscope'],
  //   tags: [],
  //   description: 'stethoscope',
  //   category: 'Objects'
  // },
  // {
  //   emoji: '🩻',
  //   names: ['x_ray'],
  //   tags: [],
  //   description: 'x-ray',
  //   category: 'Objects'
  // },
  {
    emoji: '🚪',
    names: ['door'],
    tags: [],
    description: 'door',
    category: 'Objects'
  },
  // {
  //   emoji: '🛗',
  //   names: ['elevator'],
  //   tags: [],
  //   description: 'elevator',
  //   category: 'Objects'
  // },
  // {
  //   emoji: '🪞',
  //   names: ['mirror'],
  //   tags: [],
  //   description: 'mirror',
  //   category: 'Objects'
  // },
  // {
  //   emoji: '🪟',
  //   names: ['window'],
  //   tags: [],
  //   description: 'window',
  //   category: 'Objects'
  // },
  {
    emoji: '🛏️',
    names: ['bed'],
    tags: [],
    description: 'bed',
    category: 'Objects'
  },
  {
    emoji: '🛋️',
    names: ['couch_and_lamp'],
    tags: [],
    description: 'couch and lamp',
    category: 'Objects'
  },
  // {
  //   emoji: '🪑',
  //   names: ['chair'],
  //   tags: [],
  //   description: 'chair',
  //   category: 'Objects'
  // },
  {
    emoji: '🚽',
    names: ['toilet'],
    tags: ['wc'],
    description: 'toilet',
    category: 'Objects'
  },
  // {
  //   emoji: '🪠',
  //   names: ['plunger'],
  //   tags: [],
  //   description: 'plunger',
  //   category: 'Objects'
  // },
  {
    emoji: '🚿',
    names: ['shower'],
    tags: ['bath'],
    description: 'shower',
    category: 'Objects'
  },
  {
    emoji: '🛁',
    names: ['bathtub'],
    tags: [],
    description: 'bathtub',
    category: 'Objects'
  },
  // {
  //   emoji: '🪤',
  //   names: ['mouse_trap'],
  //   tags: [],
  //   description: 'mouse trap',
  //   category: 'Objects'
  // },
  // {
  //   emoji: '🪒',
  //   names: ['razor'],
  //   tags: [],
  //   description: 'razor',
  //   category: 'Objects'
  // },
  {
    emoji: '🧴',
    names: ['lotion_bottle'],
    tags: [],
    description: 'lotion bottle',
    category: 'Objects'
  },
  {
    emoji: '🧷',
    names: ['safety_pin'],
    tags: [],
    description: 'safety pin',
    category: 'Objects'
  },
  {
    emoji: '🧹',
    names: ['broom'],
    tags: [],
    description: 'broom',
    category: 'Objects'
  },
  {
    emoji: '🧺',
    names: ['basket'],
    tags: [],
    description: 'basket',
    category: 'Objects'
  },
  {
    emoji: '🧻',
    names: ['roll_of_paper'],
    tags: ['toilet'],
    description: 'roll of paper',
    category: 'Objects'
  },
  // {
  //   emoji: '🪣',
  //   names: ['bucket'],
  //   tags: [],
  //   description: 'bucket',
  //   category: 'Objects'
  // },
  {
    emoji: '🧼',
    names: ['soap'],
    tags: [],
    description: 'soap',
    category: 'Objects'
  },
  // {
  //   emoji: '🫧',
  //   names: ['bubbles'],
  //   tags: [],
  //   description: 'bubbles',
  //   category: 'Objects'
  // },
  // {
  //   emoji: '🪥',
  //   names: ['toothbrush'],
  //   tags: [],
  //   description: 'toothbrush',
  //   category: 'Objects'
  // },
  {
    emoji: '🧽',
    names: ['sponge'],
    tags: [],
    description: 'sponge',
    category: 'Objects'
  },
  {
    emoji: '🧯',
    names: ['fire_extinguisher'],
    tags: [],
    description: 'fire extinguisher',
    category: 'Objects'
  },
  {
    emoji: '🛒',
    names: ['shopping_cart'],
    tags: [],
    description: 'shopping cart',
    category: 'Objects'
  },
  {
    emoji: '🚬',
    names: ['smoking'],
    tags: ['cigarette'],
    description: 'cigarette',
    category: 'Objects'
  },
  {
    emoji: '⚰️',
    names: ['coffin'],
    tags: ['funeral'],
    description: 'coffin',
    category: 'Objects'
  },
  // {
  //   emoji: '🪦',
  //   names: ['headstone'],
  //   tags: [],
  //   description: 'headstone',
  //   category: 'Objects'
  // },
  {
    emoji: '⚱️',
    names: ['funeral_urn'],
    tags: [],
    description: 'funeral urn',
    category: 'Objects'
  },
  {
    emoji: '🧿',
    names: ['nazar_amulet'],
    tags: [],
    description: 'nazar amulet',
    category: 'Objects'
  },
  // {
  //   emoji: '🪬',
  //   names: ['hamsa'],
  //   tags: [],
  //   description: 'hamsa',
  //   category: 'Objects'
  // },
  {
    emoji: '🗿',
    names: ['moyai'],
    tags: ['stone'],
    description: 'moai',
    category: 'Objects'
  },
  // {
  //   emoji: '🪧',
  //   names: ['placard'],
  //   tags: [],
  //   description: 'placard',
  //   category: 'Objects'
  // },
  // {
  //   emoji: '🪪',
  //   names: ['identification_card'],
  //   tags: [],
  //   description: 'identification card',
  //   category: 'Objects'
  // },
  {
    emoji: '🏧',
    names: ['atm'],
    tags: [],
    description: 'ATM sign',
    category: 'Symbols'
  },
  {
    emoji: '🚮',
    names: ['put_litter_in_its_place'],
    tags: [],
    description: 'litter in bin sign',
    category: 'Symbols'
  },
  {
    emoji: '🚰',
    names: ['potable_water'],
    tags: [],
    description: 'potable water',
    category: 'Symbols'
  },
  {
    emoji: '♿',
    names: ['wheelchair'],
    tags: ['accessibility'],
    description: 'wheelchair symbol',
    category: 'Symbols'
  },
  {
    emoji: '🚹',
    names: ['mens'],
    tags: [],
    description: 'men’s room',
    category: 'Symbols'
  },
  {
    emoji: '🚺',
    names: ['womens'],
    tags: [],
    description: 'women’s room',
    category: 'Symbols'
  },
  {
    emoji: '🚻',
    names: ['restroom'],
    tags: ['toilet'],
    description: 'restroom',
    category: 'Symbols'
  },
  {
    emoji: '🚼',
    names: ['baby_symbol'],
    tags: [],
    description: 'baby symbol',
    category: 'Symbols'
  },
  {
    emoji: '🚾',
    names: ['wc'],
    tags: ['toilet', 'restroom'],
    description: 'water closet',
    category: 'Symbols'
  },
  {
    emoji: '🛂',
    names: ['passport_control'],
    tags: [],
    description: 'passport control',
    category: 'Symbols'
  },
  {
    emoji: '🛃',
    names: ['customs'],
    tags: [],
    description: 'customs',
    category: 'Symbols'
  },
  {
    emoji: '🛄',
    names: ['baggage_claim'],
    tags: ['airport'],
    description: 'baggage claim',
    category: 'Symbols'
  },
  {
    emoji: '🛅',
    names: ['left_luggage'],
    tags: [],
    description: 'left luggage',
    category: 'Symbols'
  },
  {
    emoji: '⚠️',
    names: ['warning'],
    tags: ['wip'],
    description: 'warning',
    category: 'Symbols'
  },
  {
    emoji: '🚸',
    names: ['children_crossing'],
    tags: [],
    description: 'children crossing',
    category: 'Symbols'
  },
  {
    emoji: '⛔',
    names: ['no_entry'],
    tags: ['limit'],
    description: 'no entry',
    category: 'Symbols'
  },
  {
    emoji: '🚫',
    names: ['no_entry_sign'],
    tags: ['block', 'forbidden'],
    description: 'prohibited',
    category: 'Symbols'
  },
  {
    emoji: '🚳',
    names: ['no_bicycles'],
    tags: [],
    description: 'no bicycles',
    category: 'Symbols'
  },
  {
    emoji: '🚭',
    names: ['no_smoking'],
    tags: [],
    description: 'no smoking',
    category: 'Symbols'
  },
  {
    emoji: '🚯',
    names: ['do_not_litter'],
    tags: [],
    description: 'no littering',
    category: 'Symbols'
  },
  {
    emoji: '🚱',
    names: ['non-potable_water'],
    tags: [],
    description: 'non-potable water',
    category: 'Symbols'
  },
  {
    emoji: '🚷',
    names: ['no_pedestrians'],
    tags: [],
    description: 'no pedestrians',
    category: 'Symbols'
  },
  {
    emoji: '📵',
    names: ['no_mobile_phones'],
    tags: [],
    description: 'no mobile phones',
    category: 'Symbols'
  },
  {
    emoji: '🔞',
    names: ['underage'],
    tags: [],
    description: 'no one under eighteen',
    category: 'Symbols'
  },
  {
    emoji: '☢️',
    names: ['radioactive'],
    tags: [],
    description: 'radioactive',
    category: 'Symbols'
  },
  {
    emoji: '☣️',
    names: ['biohazard'],
    tags: [],
    description: 'biohazard',
    category: 'Symbols'
  },
  {
    emoji: '⬆️',
    names: ['arrow_up'],
    tags: [],
    description: 'up arrow',
    category: 'Symbols'
  },
  {
    emoji: '↗️',
    names: ['arrow_upper_right'],
    tags: [],
    description: 'up-right arrow',
    category: 'Symbols'
  },
  {
    emoji: '➡️',
    names: ['arrow_right'],
    tags: [],
    description: 'right arrow',
    category: 'Symbols'
  },
  {
    emoji: '↘️',
    names: ['arrow_lower_right'],
    tags: [],
    description: 'down-right arrow',
    category: 'Symbols'
  },
  {
    emoji: '⬇️',
    names: ['arrow_down'],
    tags: [],
    description: 'down arrow',
    category: 'Symbols'
  },
  {
    emoji: '↙️',
    names: ['arrow_lower_left'],
    tags: [],
    description: 'down-left arrow',
    category: 'Symbols'
  },
  {
    emoji: '⬅️',
    names: ['arrow_left'],
    tags: [],
    description: 'left arrow',
    category: 'Symbols'
  },
  {
    emoji: '↖️',
    names: ['arrow_upper_left'],
    tags: [],
    description: 'up-left arrow',
    category: 'Symbols'
  },
  {
    emoji: '↕️',
    names: ['arrow_up_down'],
    tags: [],
    description: 'up-down arrow',
    category: 'Symbols'
  },
  {
    emoji: '↔️',
    names: ['left_right_arrow'],
    tags: [],
    description: 'left-right arrow',
    category: 'Symbols'
  },
  {
    emoji: '↩️',
    names: ['leftwards_arrow_with_hook'],
    tags: ['return'],
    description: 'right arrow curving left',
    category: 'Symbols'
  },
  {
    emoji: '↪️',
    names: ['arrow_right_hook'],
    tags: [],
    description: 'left arrow curving right',
    category: 'Symbols'
  },
  {
    emoji: '⤴️',
    names: ['arrow_heading_up'],
    tags: [],
    description: 'right arrow curving up',
    category: 'Symbols'
  },
  {
    emoji: '⤵️',
    names: ['arrow_heading_down'],
    tags: [],
    description: 'right arrow curving down',
    category: 'Symbols'
  },
  {
    emoji: '🔃',
    names: ['arrows_clockwise'],
    tags: [],
    description: 'clockwise vertical arrows',
    category: 'Symbols'
  },
  {
    emoji: '🔄',
    names: ['arrows_counterclockwise'],
    tags: ['sync'],
    description: 'counterclockwise arrows button',
    category: 'Symbols'
  },
  {
    emoji: '🔙',
    names: ['back'],
    tags: [],
    description: 'BACK arrow',
    category: 'Symbols'
  },
  {
    emoji: '🔚',
    names: ['end'],
    tags: [],
    description: 'END arrow',
    category: 'Symbols'
  },
  {
    emoji: '🔛',
    names: ['on'],
    tags: [],
    description: 'ON! arrow',
    category: 'Symbols'
  },
  {
    emoji: '🔜',
    names: ['soon'],
    tags: [],
    description: 'SOON arrow',
    category: 'Symbols'
  },
  {
    emoji: '🔝',
    names: ['top'],
    tags: [],
    description: 'TOP arrow',
    category: 'Symbols'
  },
  {
    emoji: '🛐',
    names: ['place_of_worship'],
    tags: [],
    description: 'place of worship',
    category: 'Symbols'
  },
  {
    emoji: '⚛️',
    names: ['atom_symbol'],
    tags: [],
    description: 'atom symbol',
    category: 'Symbols'
  },
  {
    emoji: '🕉️',
    names: ['om'],
    tags: [],
    description: 'om',
    category: 'Symbols'
  },
  {
    emoji: '✡️',
    names: ['star_of_david'],
    tags: [],
    description: 'star of David',
    category: 'Symbols'
  },
  {
    emoji: '☸️',
    names: ['wheel_of_dharma'],
    tags: [],
    description: 'wheel of dharma',
    category: 'Symbols'
  },
  {
    emoji: '☯️',
    names: ['yin_yang'],
    tags: [],
    description: 'yin yang',
    category: 'Symbols'
  },
  {
    emoji: '✝️',
    names: ['latin_cross'],
    tags: [],
    description: 'latin cross',
    category: 'Symbols'
  },
  {
    emoji: '☦️',
    names: ['orthodox_cross'],
    tags: [],
    description: 'orthodox cross',
    category: 'Symbols'
  },
  {
    emoji: '☪️',
    names: ['star_and_crescent'],
    tags: [],
    description: 'star and crescent',
    category: 'Symbols'
  },
  {
    emoji: '☮️',
    names: ['peace_symbol'],
    tags: [],
    description: 'peace symbol',
    category: 'Symbols'
  },
  {
    emoji: '🕎',
    names: ['menorah'],
    tags: [],
    description: 'menorah',
    category: 'Symbols'
  },
  {
    emoji: '🔯',
    names: ['six_pointed_star'],
    tags: [],
    description: 'dotted six-pointed star',
    category: 'Symbols'
  },
  // {
  //   emoji: '🪯',
  //   names: ['khanda'],
  //   tags: [],
  //   description: 'khanda',
  //   category: 'Symbols'
  // },
  {
    emoji: '♈',
    names: ['aries'],
    tags: [],
    description: 'Aries',
    category: 'Symbols'
  },
  {
    emoji: '♉',
    names: ['taurus'],
    tags: [],
    description: 'Taurus',
    category: 'Symbols'
  },
  {
    emoji: '♊',
    names: ['gemini'],
    tags: [],
    description: 'Gemini',
    category: 'Symbols'
  },
  {
    emoji: '♋',
    names: ['cancer'],
    tags: [],
    description: 'Cancer',
    category: 'Symbols'
  },
  {
    emoji: '♌',
    names: ['leo'],
    tags: [],
    description: 'Leo',
    category: 'Symbols'
  },
  {
    emoji: '♍',
    names: ['virgo'],
    tags: [],
    description: 'Virgo',
    category: 'Symbols'
  },
  {
    emoji: '♎',
    names: ['libra'],
    tags: [],
    description: 'Libra',
    category: 'Symbols'
  },
  {
    emoji: '♏',
    names: ['scorpius'],
    tags: [],
    description: 'Scorpio',
    category: 'Symbols'
  },
  {
    emoji: '♐',
    names: ['sagittarius'],
    tags: [],
    description: 'Sagittarius',
    category: 'Symbols'
  },
  {
    emoji: '♑',
    names: ['capricorn'],
    tags: [],
    description: 'Capricorn',
    category: 'Symbols'
  },
  {
    emoji: '♒',
    names: ['aquarius'],
    tags: [],
    description: 'Aquarius',
    category: 'Symbols'
  },
  {
    emoji: '♓',
    names: ['pisces'],
    tags: [],
    description: 'Pisces',
    category: 'Symbols'
  },
  {
    emoji: '⛎',
    names: ['ophiuchus'],
    tags: [],
    description: 'Ophiuchus',
    category: 'Symbols'
  },
  {
    emoji: '🔀',
    names: ['twisted_rightwards_arrows'],
    tags: ['shuffle'],
    description: 'shuffle tracks button',
    category: 'Symbols'
  },
  {
    emoji: '🔁',
    names: ['repeat'],
    tags: ['loop'],
    description: 'repeat button',
    category: 'Symbols'
  },
  {
    emoji: '🔂',
    names: ['repeat_one'],
    tags: [],
    description: 'repeat single button',
    category: 'Symbols'
  },
  {
    emoji: '▶️',
    names: ['arrow_forward'],
    tags: [],
    description: 'play button',
    category: 'Symbols'
  },
  {
    emoji: '⏩',
    names: ['fast_forward'],
    tags: [],
    description: 'fast-forward button',
    category: 'Symbols'
  },
  {
    emoji: '⏭️',
    names: ['next_track_button'],
    tags: [],
    description: 'next track button',
    category: 'Symbols'
  },
  {
    emoji: '⏯️',
    names: ['play_or_pause_button'],
    tags: [],
    description: 'play or pause button',
    category: 'Symbols'
  },
  {
    emoji: '◀️',
    names: ['arrow_backward'],
    tags: [],
    description: 'reverse button',
    category: 'Symbols'
  },
  {
    emoji: '⏪',
    names: ['rewind'],
    tags: [],
    description: 'fast reverse button',
    category: 'Symbols'
  },
  {
    emoji: '⏮️',
    names: ['previous_track_button'],
    tags: [],
    description: 'last track button',
    category: 'Symbols'
  },
  {
    emoji: '🔼',
    names: ['arrow_up_small'],
    tags: [],
    description: 'upwards button',
    category: 'Symbols'
  },
  {
    emoji: '⏫',
    names: ['arrow_double_up'],
    tags: [],
    description: 'fast up button',
    category: 'Symbols'
  },
  {
    emoji: '🔽',
    names: ['arrow_down_small'],
    tags: [],
    description: 'downwards button',
    category: 'Symbols'
  },
  {
    emoji: '⏬',
    names: ['arrow_double_down'],
    tags: [],
    description: 'fast down button',
    category: 'Symbols'
  },
  {
    emoji: '⏸️',
    names: ['pause_button'],
    tags: [],
    description: 'pause button',
    category: 'Symbols'
  },
  {
    emoji: '⏹️',
    names: ['stop_button'],
    tags: [],
    description: 'stop button',
    category: 'Symbols'
  },
  {
    emoji: '⏺️',
    names: ['record_button'],
    tags: [],
    description: 'record button',
    category: 'Symbols'
  },
  {
    emoji: '⏏️',
    names: ['eject_button'],
    tags: [],
    description: 'eject button',
    category: 'Symbols'
  },
  {
    emoji: '🎦',
    names: ['cinema'],
    tags: ['film', 'movie'],
    description: 'cinema',
    category: 'Symbols'
  },
  {
    emoji: '🔅',
    names: ['low_brightness'],
    tags: [],
    description: 'dim button',
    category: 'Symbols'
  },
  {
    emoji: '🔆',
    names: ['high_brightness'],
    tags: [],
    description: 'bright button',
    category: 'Symbols'
  },
  {
    emoji: '📶',
    names: ['signal_strength'],
    tags: ['wifi'],
    description: 'antenna bars',
    category: 'Symbols'
  },
  // {
  //   emoji: '🛜',
  //   names: ['wireless'],
  //   tags: ['wifi'],
  //   description: 'wireless',
  //   category: 'Symbols'
  // },
  {
    emoji: '📳',
    names: ['vibration_mode'],
    tags: [],
    description: 'vibration mode',
    category: 'Symbols'
  },
  {
    emoji: '📴',
    names: ['mobile_phone_off'],
    tags: ['mute', 'off'],
    description: 'mobile phone off',
    category: 'Symbols'
  },
  {
    emoji: '♀️',
    names: ['female_sign'],
    tags: [],
    description: 'female sign',
    category: 'Symbols'
  },
  {
    emoji: '♂️',
    names: ['male_sign'],
    tags: [],
    description: 'male sign',
    category: 'Symbols'
  },
  {
    emoji: '⚧️',
    names: ['transgender_symbol'],
    tags: [],
    description: 'transgender symbol',
    category: 'Symbols'
  },
  {
    emoji: '✖️',
    names: ['heavy_multiplication_x'],
    tags: [],
    description: 'multiply',
    category: 'Symbols'
  },
  {
    emoji: '➕',
    names: ['heavy_plus_sign'],
    tags: [],
    description: 'plus',
    category: 'Symbols'
  },
  {
    emoji: '➖',
    names: ['heavy_minus_sign'],
    tags: [],
    description: 'minus',
    category: 'Symbols'
  },
  {
    emoji: '➗',
    names: ['heavy_division_sign'],
    tags: [],
    description: 'divide',
    category: 'Symbols'
  },
  // {
  //   emoji: '🟰',
  //   names: ['heavy_equals_sign'],
  //   tags: [],
  //   description: 'heavy equals sign',
  //   category: 'Symbols'
  // },
  {
    emoji: '♾️',
    names: ['infinity'],
    tags: [],
    description: 'infinity',
    category: 'Symbols'
  },
  {
    emoji: '‼️',
    names: ['bangbang'],
    tags: [],
    description: 'double exclamation mark',
    category: 'Symbols'
  },
  {
    emoji: '⁉️',
    names: ['interrobang'],
    tags: [],
    description: 'exclamation question mark',
    category: 'Symbols'
  },
  {
    emoji: '❓',
    names: ['question'],
    tags: ['confused'],
    description: 'red question mark',
    category: 'Symbols'
  },
  {
    emoji: '❔',
    names: ['grey_question'],
    tags: [],
    description: 'white question mark',
    category: 'Symbols'
  },
  {
    emoji: '❕',
    names: ['grey_exclamation'],
    tags: [],
    description: 'white exclamation mark',
    category: 'Symbols'
  },
  {
    emoji: '❗',
    names: ['exclamation', 'heavy_exclamation_mark'],
    tags: ['bang'],
    description: 'red exclamation mark',
    category: 'Symbols'
  },
  {
    emoji: '〰️',
    names: ['wavy_dash'],
    tags: [],
    description: 'wavy dash',
    category: 'Symbols'
  },
  {
    emoji: '💱',
    names: ['currency_exchange'],
    tags: [],
    description: 'currency exchange',
    category: 'Symbols'
  },
  {
    emoji: '💲',
    names: ['heavy_dollar_sign'],
    tags: [],
    description: 'heavy dollar sign',
    category: 'Symbols'
  },
  {
    emoji: '⚕️',
    names: ['medical_symbol'],
    tags: [],
    description: 'medical symbol',
    category: 'Symbols'
  },
  {
    emoji: '♻️',
    names: ['recycle'],
    tags: ['environment', 'green'],
    description: 'recycling symbol',
    category: 'Symbols'
  },
  {
    emoji: '⚜️',
    names: ['fleur_de_lis'],
    tags: [],
    description: 'fleur-de-lis',
    category: 'Symbols'
  },
  {
    emoji: '🔱',
    names: ['trident'],
    tags: [],
    description: 'trident emblem',
    category: 'Symbols'
  },
  {
    emoji: '📛',
    names: ['name_badge'],
    tags: [],
    description: 'name badge',
    category: 'Symbols'
  },
  {
    emoji: '🔰',
    names: ['beginner'],
    tags: [],
    description: 'Japanese symbol for beginner',
    category: 'Symbols'
  },
  {
    emoji: '⭕',
    names: ['o'],
    tags: [],
    description: 'hollow red circle',
    category: 'Symbols'
  },
  {
    emoji: '✅',
    names: ['white_check_mark'],
    tags: [],
    description: 'check mark button',
    category: 'Symbols'
  },
  {
    emoji: '☑️',
    names: ['ballot_box_with_check'],
    tags: [],
    description: 'check box with check',
    category: 'Symbols'
  },
  {
    emoji: '✔️',
    names: ['heavy_check_mark'],
    tags: [],
    description: 'check mark',
    category: 'Symbols'
  },
  {
    emoji: '❌',
    names: ['x'],
    tags: [],
    description: 'cross mark',
    category: 'Symbols'
  },
  {
    emoji: '❎',
    names: ['negative_squared_cross_mark'],
    tags: [],
    description: 'cross mark button',
    category: 'Symbols'
  },
  {
    emoji: '➰',
    names: ['curly_loop'],
    tags: [],
    description: 'curly loop',
    category: 'Symbols'
  },
  {
    emoji: '➿',
    names: ['loop'],
    tags: [],
    description: 'double curly loop',
    category: 'Symbols'
  },
  {
    emoji: '〽️',
    names: ['part_alternation_mark'],
    tags: [],
    description: 'part alternation mark',
    category: 'Symbols'
  },
  {
    emoji: '✳️',
    names: ['eight_spoked_asterisk'],
    tags: [],
    description: 'eight-spoked asterisk',
    category: 'Symbols'
  },
  {
    emoji: '✴️',
    names: ['eight_pointed_black_star'],
    tags: [],
    description: 'eight-pointed star',
    category: 'Symbols'
  },
  {
    emoji: '❇️',
    names: ['sparkle'],
    tags: [],
    description: 'sparkle',
    category: 'Symbols'
  },
  {
    emoji: '©️',
    names: ['copyright'],
    tags: [],
    description: 'copyright',
    category: 'Symbols'
  },
  {
    emoji: '®️',
    names: ['registered'],
    tags: [],
    description: 'registered',
    category: 'Symbols'
  },
  {
    emoji: '™️',
    names: ['tm'],
    tags: ['trademark'],
    description: 'trade mark',
    category: 'Symbols'
  },
  {
    emoji: '#️⃣',
    names: ['hash'],
    tags: ['number'],
    description: 'keycap: #',
    category: 'Symbols'
  },
  {
    emoji: '*️⃣',
    names: ['asterisk'],
    tags: [],
    description: 'keycap: *',
    category: 'Symbols'
  },
  {
    emoji: '0️⃣',
    names: ['zero'],
    tags: [],
    description: 'keycap: 0',
    category: 'Symbols'
  },
  {
    emoji: '1️⃣',
    names: ['one'],
    tags: [],
    description: 'keycap: 1',
    category: 'Symbols'
  },
  {
    emoji: '2️⃣',
    names: ['two'],
    tags: [],
    description: 'keycap: 2',
    category: 'Symbols'
  },
  {
    emoji: '3️⃣',
    names: ['three'],
    tags: [],
    description: 'keycap: 3',
    category: 'Symbols'
  },
  {
    emoji: '4️⃣',
    names: ['four'],
    tags: [],
    description: 'keycap: 4',
    category: 'Symbols'
  },
  {
    emoji: '5️⃣',
    names: ['five'],
    tags: [],
    description: 'keycap: 5',
    category: 'Symbols'
  },
  {
    emoji: '6️⃣',
    names: ['six'],
    tags: [],
    description: 'keycap: 6',
    category: 'Symbols'
  },
  {
    emoji: '7️⃣',
    names: ['seven'],
    tags: [],
    description: 'keycap: 7',
    category: 'Symbols'
  },
  {
    emoji: '8️⃣',
    names: ['eight'],
    tags: [],
    description: 'keycap: 8',
    category: 'Symbols'
  },
  {
    emoji: '9️⃣',
    names: ['nine'],
    tags: [],
    description: 'keycap: 9',
    category: 'Symbols'
  },
  {
    emoji: '🔟',
    names: ['keycap_ten'],
    tags: [],
    description: 'keycap: 10',
    category: 'Symbols'
  },
  {
    emoji: '🔠',
    names: ['capital_abcd'],
    tags: ['letters'],
    description: 'input latin uppercase',
    category: 'Symbols'
  },
  {
    emoji: '🔡',
    names: ['abcd'],
    tags: [],
    description: 'input latin lowercase',
    category: 'Symbols'
  },
  {
    emoji: '🔢',
    names: ['1234'],
    tags: ['numbers'],
    description: 'input numbers',
    category: 'Symbols'
  },
  {
    emoji: '🔣',
    names: ['symbols'],
    tags: [],
    description: 'input symbols',
    category: 'Symbols'
  },
  {
    emoji: '🔤',
    names: ['abc'],
    tags: ['alphabet'],
    description: 'input latin letters',
    category: 'Symbols'
  },
  {
    emoji: '🅰️',
    names: ['a'],
    tags: [],
    description: 'A button (blood type)',
    category: 'Symbols'
  },
  {
    emoji: '🆎',
    names: ['ab'],
    tags: [],
    description: 'AB button (blood type)',
    category: 'Symbols'
  },
  {
    emoji: '🅱️',
    names: ['b'],
    tags: [],
    description: 'B button (blood type)',
    category: 'Symbols'
  },
  {
    emoji: '🆑',
    names: ['cl'],
    tags: [],
    description: 'CL button',
    category: 'Symbols'
  },
  {
    emoji: '🆒',
    names: ['cool'],
    tags: [],
    description: 'COOL button',
    category: 'Symbols'
  },
  {
    emoji: '🆓',
    names: ['free'],
    tags: [],
    description: 'FREE button',
    category: 'Symbols'
  },
  {
    emoji: 'ℹ️',
    names: ['information_source'],
    tags: [],
    description: 'information',
    category: 'Symbols'
  },
  {
    emoji: '🆔',
    names: ['id'],
    tags: [],
    description: 'ID button',
    category: 'Symbols'
  },
  {
    emoji: 'Ⓜ️',
    names: ['m'],
    tags: [],
    description: 'circled M',
    category: 'Symbols'
  },
  {
    emoji: '🆕',
    names: ['new'],
    tags: ['fresh'],
    description: 'NEW button',
    category: 'Symbols'
  },
  {
    emoji: '🆖',
    names: ['ng'],
    tags: [],
    description: 'NG button',
    category: 'Symbols'
  },
  {
    emoji: '🅾️',
    names: ['o2'],
    tags: [],
    description: 'O button (blood type)',
    category: 'Symbols'
  },
  {
    emoji: '🆗',
    names: ['ok'],
    tags: ['yes'],
    description: 'OK button',
    category: 'Symbols'
  },
  {
    emoji: '🅿️',
    names: ['parking'],
    tags: [],
    description: 'P button',
    category: 'Symbols'
  },
  {
    emoji: '🆘',
    names: ['sos'],
    tags: ['help', 'emergency'],
    description: 'SOS button',
    category: 'Symbols'
  },
  {
    emoji: '🆙',
    names: ['up'],
    tags: [],
    description: 'UP! button',
    category: 'Symbols'
  },
  {
    emoji: '🆚',
    names: ['vs'],
    tags: [],
    description: 'VS button',
    category: 'Symbols'
  },
  {
    emoji: '🈁',
    names: ['koko'],
    tags: [],
    description: 'Japanese “here” button',
    category: 'Symbols'
  },
  {
    emoji: '🈂️',
    names: ['sa'],
    tags: [],
    description: 'Japanese “service charge” button',
    category: 'Symbols'
  },
  {
    emoji: '🈷️',
    names: ['u6708'],
    tags: [],
    description: 'Japanese “monthly amount” button',
    category: 'Symbols'
  },
  {
    emoji: '🈶',
    names: ['u6709'],
    tags: [],
    description: 'Japanese “not free of charge” button',
    category: 'Symbols'
  },
  {
    emoji: '🈯',
    names: ['u6307'],
    tags: [],
    description: 'Japanese “reserved” button',
    category: 'Symbols'
  },
  {
    emoji: '🉐',
    names: ['ideograph_advantage'],
    tags: [],
    description: 'Japanese “bargain” button',
    category: 'Symbols'
  },
  {
    emoji: '🈹',
    names: ['u5272'],
    tags: [],
    description: 'Japanese “discount” button',
    category: 'Symbols'
  },
  {
    emoji: '🈚',
    names: ['u7121'],
    tags: [],
    description: 'Japanese “free of charge” button',
    category: 'Symbols'
  },
  {
    emoji: '🈲',
    names: ['u7981'],
    tags: [],
    description: 'Japanese “prohibited” button',
    category: 'Symbols'
  },
  {
    emoji: '🉑',
    names: ['accept'],
    tags: [],
    description: 'Japanese “acceptable” button',
    category: 'Symbols'
  },
  {
    emoji: '🈸',
    names: ['u7533'],
    tags: [],
    description: 'Japanese “application” button',
    category: 'Symbols'
  },
  {
    emoji: '🈴',
    names: ['u5408'],
    tags: [],
    description: 'Japanese “passing grade” button',
    category: 'Symbols'
  },
  {
    emoji: '🈳',
    names: ['u7a7a'],
    tags: [],
    description: 'Japanese “vacancy” button',
    category: 'Symbols'
  },
  {
    emoji: '㊗️',
    names: ['congratulations'],
    tags: [],
    description: 'Japanese “congratulations” button',
    category: 'Symbols'
  },
  {
    emoji: '㊙️',
    names: ['secret'],
    tags: [],
    description: 'Japanese “secret” button',
    category: 'Symbols'
  },
  {
    emoji: '🈺',
    names: ['u55b6'],
    tags: [],
    description: 'Japanese “open for business” button',
    category: 'Symbols'
  },
  {
    emoji: '🈵',
    names: ['u6e80'],
    tags: [],
    description: 'Japanese “no vacancy” button',
    category: 'Symbols'
  },
  {
    emoji: '🔴',
    names: ['red_circle'],
    tags: [],
    description: 'red circle',
    category: 'Symbols'
  },
  // {
  //   emoji: '🟠',
  //   names: ['orange_circle'],
  //   tags: [],
  //   description: 'orange circle',
  //   category: 'Symbols'
  // },
  // {
  //   emoji: '🟡',
  //   names: ['yellow_circle'],
  //   tags: [],
  //   description: 'yellow circle',
  //   category: 'Symbols'
  // },
  // {
  //   emoji: '🟢',
  //   names: ['green_circle'],
  //   tags: [],
  //   description: 'green circle',
  //   category: 'Symbols'
  // },
  {
    emoji: '🔵',
    names: ['large_blue_circle'],
    tags: [],
    description: 'blue circle',
    category: 'Symbols'
  },
  // {
  //   emoji: '🟣',
  //   names: ['purple_circle'],
  //   tags: [],
  //   description: 'purple circle',
  //   category: 'Symbols'
  // },
  // {
  //   emoji: '🟤',
  //   names: ['brown_circle'],
  //   tags: [],
  //   description: 'brown circle',
  //   category: 'Symbols'
  // },
  {
    emoji: '⚫',
    names: ['black_circle'],
    tags: [],
    description: 'black circle',
    category: 'Symbols'
  },
  {
    emoji: '⚪',
    names: ['white_circle'],
    tags: [],
    description: 'white circle',
    category: 'Symbols'
  },
  // {
  //   emoji: '🟥',
  //   names: ['red_square'],
  //   tags: [],
  //   description: 'red square',
  //   category: 'Symbols'
  // },
  // {
  //   emoji: '🟧',
  //   names: ['orange_square'],
  //   tags: [],
  //   description: 'orange square',
  //   category: 'Symbols'
  // },
  // {
  //   emoji: '🟨',
  //   names: ['yellow_square'],
  //   tags: [],
  //   description: 'yellow square',
  //   category: 'Symbols'
  // },
  // {
  //   emoji: '🟩',
  //   names: ['green_square'],
  //   tags: [],
  //   description: 'green square',
  //   category: 'Symbols'
  // },
  // {
  //   emoji: '🟦',
  //   names: ['blue_square'],
  //   tags: [],
  //   description: 'blue square',
  //   category: 'Symbols'
  // },
  // {
  //   emoji: '🟪',
  //   names: ['purple_square'],
  //   tags: [],
  //   description: 'purple square',
  //   category: 'Symbols'
  // },
  // {
  //   emoji: '🟫',
  //   names: ['brown_square'],
  //   tags: [],
  //   description: 'brown square',
  //   category: 'Symbols'
  // },
  {
    emoji: '⬛',
    names: ['black_large_square'],
    tags: [],
    description: 'black large square',
    category: 'Symbols'
  },
  {
    emoji: '⬜',
    names: ['white_large_square'],
    tags: [],
    description: 'white large square',
    category: 'Symbols'
  },
  {
    emoji: '◼️',
    names: ['black_medium_square'],
    tags: [],
    description: 'black medium square',
    category: 'Symbols'
  },
  {
    emoji: '◻️',
    names: ['white_medium_square'],
    tags: [],
    description: 'white medium square',
    category: 'Symbols'
  },
  {
    emoji: '◾',
    names: ['black_medium_small_square'],
    tags: [],
    description: 'black medium-small square',
    category: 'Symbols'
  },
  {
    emoji: '◽',
    names: ['white_medium_small_square'],
    tags: [],
    description: 'white medium-small square',
    category: 'Symbols'
  },
  {
    emoji: '▪️',
    names: ['black_small_square'],
    tags: [],
    description: 'black small square',
    category: 'Symbols'
  },
  {
    emoji: '▫️',
    names: ['white_small_square'],
    tags: [],
    description: 'white small square',
    category: 'Symbols'
  },
  {
    emoji: '🔶',
    names: ['large_orange_diamond'],
    tags: [],
    description: 'large orange diamond',
    category: 'Symbols'
  },
  {
    emoji: '🔷',
    names: ['large_blue_diamond'],
    tags: [],
    description: 'large blue diamond',
    category: 'Symbols'
  },
  {
    emoji: '🔸',
    names: ['small_orange_diamond'],
    tags: [],
    description: 'small orange diamond',
    category: 'Symbols'
  },
  {
    emoji: '🔹',
    names: ['small_blue_diamond'],
    tags: [],
    description: 'small blue diamond',
    category: 'Symbols'
  },
  {
    emoji: '🔺',
    names: ['small_red_triangle'],
    tags: [],
    description: 'red triangle pointed up',
    category: 'Symbols'
  },
  {
    emoji: '🔻',
    names: ['small_red_triangle_down'],
    tags: [],
    description: 'red triangle pointed down',
    category: 'Symbols'
  },
  {
    emoji: '💠',
    names: ['diamond_shape_with_a_dot_inside'],
    tags: [],
    description: 'diamond with a dot',
    category: 'Symbols'
  },
  {
    emoji: '🔘',
    names: ['radio_button'],
    tags: [],
    description: 'radio button',
    category: 'Symbols'
  },
  {
    emoji: '🔳',
    names: ['white_square_button'],
    tags: [],
    description: 'white square button',
    category: 'Symbols'
  },
  {
    emoji: '🔲',
    names: ['black_square_button'],
    tags: [],
    description: 'black square button',
    category: 'Symbols'
  },
  {
    emoji: '🏁',
    names: ['checkered_flag'],
    tags: ['milestone', 'finish'],
    description: 'chequered flag',
    category: 'Flags'
  },
  {
    emoji: '🚩',
    names: ['triangular_flag_on_post'],
    tags: [],
    description: 'triangular flag',
    category: 'Flags'
  },
  {
    emoji: '🎌',
    names: ['crossed_flags'],
    tags: [],
    description: 'crossed flags',
    category: 'Flags'
  },
  {
    emoji: '🏴',
    names: ['black_flag'],
    tags: [],
    description: 'black flag',
    category: 'Flags'
  },
  {
    emoji: '🏳️',
    names: ['white_flag'],
    tags: [],
    description: 'white flag',
    category: 'Flags'
  },
  {
    emoji: '🏳️‍🌈',
    names: ['rainbow_flag'],
    tags: ['pride'],
    description: 'rainbow flag',
    category: 'Flags'
  },
  // {
  //   emoji: '🏳️‍⚧️',
  //   names: ['transgender_flag'],
  //   tags: [],
  //   description: 'transgender flag',
  //   category: 'Flags'
  // },
  {
    emoji: '🏴‍☠️',
    names: ['pirate_flag'],
    tags: [],
    description: 'pirate flag',
    category: 'Flags'
  }
  // {
  //   emoji: '🇦🇨',
  //   names: ['ascension_island'],
  //   tags: [],
  //   description: 'flag: Ascension Island',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇩',
  //   names: ['andorra'],
  //   tags: [],
  //   description: 'flag: Andorra',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇪',
  //   names: ['united_arab_emirates'],
  //   tags: [],
  //   description: 'flag: United Arab Emirates',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇫',
  //   names: ['afghanistan'],
  //   tags: [],
  //   description: 'flag: Afghanistan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇬',
  //   names: ['antigua_barbuda'],
  //   tags: [],
  //   description: 'flag: Antigua & Barbuda',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇮',
  //   names: ['anguilla'],
  //   tags: [],
  //   description: 'flag: Anguilla',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇱',
  //   names: ['albania'],
  //   tags: [],
  //   description: 'flag: Albania',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇲',
  //   names: ['armenia'],
  //   tags: [],
  //   description: 'flag: Armenia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇴',
  //   names: ['angola'],
  //   tags: [],
  //   description: 'flag: Angola',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇶',
  //   names: ['antarctica'],
  //   tags: [],
  //   description: 'flag: Antarctica',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇷',
  //   names: ['argentina'],
  //   tags: [],
  //   description: 'flag: Argentina',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇸',
  //   names: ['american_samoa'],
  //   tags: [],
  //   description: 'flag: American Samoa',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇹',
  //   names: ['austria'],
  //   tags: [],
  //   description: 'flag: Austria',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇺',
  //   names: ['australia'],
  //   tags: [],
  //   description: 'flag: Australia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇼',
  //   names: ['aruba'],
  //   tags: [],
  //   description: 'flag: Aruba',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇽',
  //   names: ['aland_islands'],
  //   tags: [],
  //   description: 'flag: Åland Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇦🇿',
  //   names: ['azerbaijan'],
  //   tags: [],
  //   description: 'flag: Azerbaijan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇦',
  //   names: ['bosnia_herzegovina'],
  //   tags: [],
  //   description: 'flag: Bosnia & Herzegovina',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇧',
  //   names: ['barbados'],
  //   tags: [],
  //   description: 'flag: Barbados',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇩',
  //   names: ['bangladesh'],
  //   tags: [],
  //   description: 'flag: Bangladesh',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇪',
  //   names: ['belgium'],
  //   tags: [],
  //   description: 'flag: Belgium',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇫',
  //   names: ['burkina_faso'],
  //   tags: [],
  //   description: 'flag: Burkina Faso',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇬',
  //   names: ['bulgaria'],
  //   tags: [],
  //   description: 'flag: Bulgaria',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇭',
  //   names: ['bahrain'],
  //   tags: [],
  //   description: 'flag: Bahrain',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇮',
  //   names: ['burundi'],
  //   tags: [],
  //   description: 'flag: Burundi',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇯',
  //   names: ['benin'],
  //   tags: [],
  //   description: 'flag: Benin',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇱',
  //   names: ['st_barthelemy'],
  //   tags: [],
  //   description: 'flag: St. Barthélemy',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇲',
  //   names: ['bermuda'],
  //   tags: [],
  //   description: 'flag: Bermuda',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇳',
  //   names: ['brunei'],
  //   tags: [],
  //   description: 'flag: Brunei',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇴',
  //   names: ['bolivia'],
  //   tags: [],
  //   description: 'flag: Bolivia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇶',
  //   names: ['caribbean_netherlands'],
  //   tags: [],
  //   description: 'flag: Caribbean Netherlands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇷',
  //   names: ['brazil'],
  //   tags: [],
  //   description: 'flag: Brazil',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇸',
  //   names: ['bahamas'],
  //   tags: [],
  //   description: 'flag: Bahamas',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇹',
  //   names: ['bhutan'],
  //   tags: [],
  //   description: 'flag: Bhutan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇻',
  //   names: ['bouvet_island'],
  //   tags: [],
  //   description: 'flag: Bouvet Island',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇼',
  //   names: ['botswana'],
  //   tags: [],
  //   description: 'flag: Botswana',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇾',
  //   names: ['belarus'],
  //   tags: [],
  //   description: 'flag: Belarus',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇧🇿',
  //   names: ['belize'],
  //   tags: [],
  //   description: 'flag: Belize',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇦',
  //   names: ['canada'],
  //   tags: [],
  //   description: 'flag: Canada',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇨',
  //   names: ['cocos_islands'],
  //   tags: ['keeling'],
  //   description: 'flag: Cocos (Keeling) Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇩',
  //   names: ['congo_kinshasa'],
  //   tags: [],
  //   description: 'flag: Congo - Kinshasa',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇫',
  //   names: ['central_african_republic'],
  //   tags: [],
  //   description: 'flag: Central African Republic',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇬',
  //   names: ['congo_brazzaville'],
  //   tags: [],
  //   description: 'flag: Congo - Brazzaville',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇭',
  //   names: ['switzerland'],
  //   tags: [],
  //   description: 'flag: Switzerland',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇮',
  //   names: ['cote_divoire'],
  //   tags: ['ivory'],
  //   description: 'flag: Côte d’Ivoire',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇰',
  //   names: ['cook_islands'],
  //   tags: [],
  //   description: 'flag: Cook Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇱',
  //   names: ['chile'],
  //   tags: [],
  //   description: 'flag: Chile',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇲',
  //   names: ['cameroon'],
  //   tags: [],
  //   description: 'flag: Cameroon',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇳',
  //   names: ['cn'],
  //   tags: ['china'],
  //   description: 'flag: China',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇴',
  //   names: ['colombia'],
  //   tags: [],
  //   description: 'flag: Colombia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇵',
  //   names: ['clipperton_island'],
  //   tags: [],
  //   description: 'flag: Clipperton Island',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇷',
  //   names: ['costa_rica'],
  //   tags: [],
  //   description: 'flag: Costa Rica',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇺',
  //   names: ['cuba'],
  //   tags: [],
  //   description: 'flag: Cuba',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇻',
  //   names: ['cape_verde'],
  //   tags: [],
  //   description: 'flag: Cape Verde',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇼',
  //   names: ['curacao'],
  //   tags: [],
  //   description: 'flag: Curaçao',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇽',
  //   names: ['christmas_island'],
  //   tags: [],
  //   description: 'flag: Christmas Island',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇾',
  //   names: ['cyprus'],
  //   tags: [],
  //   description: 'flag: Cyprus',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇨🇿',
  //   names: ['czech_republic'],
  //   tags: [],
  //   description: 'flag: Czechia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇩🇪',
  //   names: ['de'],
  //   tags: ['flag', 'germany'],
  //   description: 'flag: Germany',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇩🇬',
  //   names: ['diego_garcia'],
  //   tags: [],
  //   description: 'flag: Diego Garcia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇩🇯',
  //   names: ['djibouti'],
  //   tags: [],
  //   description: 'flag: Djibouti',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇩🇰',
  //   names: ['denmark'],
  //   tags: [],
  //   description: 'flag: Denmark',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇩🇲',
  //   names: ['dominica'],
  //   tags: [],
  //   description: 'flag: Dominica',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇩🇴',
  //   names: ['dominican_republic'],
  //   tags: [],
  //   description: 'flag: Dominican Republic',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇩🇿',
  //   names: ['algeria'],
  //   tags: [],
  //   description: 'flag: Algeria',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇪🇦',
  //   names: ['ceuta_melilla'],
  //   tags: [],
  //   description: 'flag: Ceuta & Melilla',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇪🇨',
  //   names: ['ecuador'],
  //   tags: [],
  //   description: 'flag: Ecuador',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇪🇪',
  //   names: ['estonia'],
  //   tags: [],
  //   description: 'flag: Estonia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇪🇬',
  //   names: ['egypt'],
  //   tags: [],
  //   description: 'flag: Egypt',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇪🇭',
  //   names: ['western_sahara'],
  //   tags: [],
  //   description: 'flag: Western Sahara',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇪🇷',
  //   names: ['eritrea'],
  //   tags: [],
  //   description: 'flag: Eritrea',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇪🇸',
  //   names: ['es'],
  //   tags: ['spain'],
  //   description: 'flag: Spain',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇪🇹',
  //   names: ['ethiopia'],
  //   tags: [],
  //   description: 'flag: Ethiopia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇪🇺',
  //   names: ['eu', 'european_union'],
  //   tags: [],
  //   description: 'flag: European Union',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇫🇮',
  //   names: ['finland'],
  //   tags: [],
  //   description: 'flag: Finland',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇫🇯',
  //   names: ['fiji'],
  //   tags: [],
  //   description: 'flag: Fiji',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇫🇰',
  //   names: ['falkland_islands'],
  //   tags: [],
  //   description: 'flag: Falkland Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇫🇲',
  //   names: ['micronesia'],
  //   tags: [],
  //   description: 'flag: Micronesia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇫🇴',
  //   names: ['faroe_islands'],
  //   tags: [],
  //   description: 'flag: Faroe Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇫🇷',
  //   names: ['fr'],
  //   tags: ['france', 'french'],
  //   description: 'flag: France',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇦',
  //   names: ['gabon'],
  //   tags: [],
  //   description: 'flag: Gabon',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇧',
  //   names: ['gb', 'uk'],
  //   tags: ['flag', 'british'],
  //   description: 'flag: United Kingdom',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇩',
  //   names: ['grenada'],
  //   tags: [],
  //   description: 'flag: Grenada',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇪',
  //   names: ['georgia'],
  //   tags: [],
  //   description: 'flag: Georgia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇫',
  //   names: ['french_guiana'],
  //   tags: [],
  //   description: 'flag: French Guiana',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇬',
  //   names: ['guernsey'],
  //   tags: [],
  //   description: 'flag: Guernsey',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇭',
  //   names: ['ghana'],
  //   tags: [],
  //   description: 'flag: Ghana',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇮',
  //   names: ['gibraltar'],
  //   tags: [],
  //   description: 'flag: Gibraltar',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇱',
  //   names: ['greenland'],
  //   tags: [],
  //   description: 'flag: Greenland',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇲',
  //   names: ['gambia'],
  //   tags: [],
  //   description: 'flag: Gambia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇳',
  //   names: ['guinea'],
  //   tags: [],
  //   description: 'flag: Guinea',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇵',
  //   names: ['guadeloupe'],
  //   tags: [],
  //   description: 'flag: Guadeloupe',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇶',
  //   names: ['equatorial_guinea'],
  //   tags: [],
  //   description: 'flag: Equatorial Guinea',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇷',
  //   names: ['greece'],
  //   tags: [],
  //   description: 'flag: Greece',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇸',
  //   names: ['south_georgia_south_sandwich_islands'],
  //   tags: [],
  //   description: 'flag: South Georgia & South Sandwich Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇹',
  //   names: ['guatemala'],
  //   tags: [],
  //   description: 'flag: Guatemala',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇺',
  //   names: ['guam'],
  //   tags: [],
  //   description: 'flag: Guam',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇼',
  //   names: ['guinea_bissau'],
  //   tags: [],
  //   description: 'flag: Guinea-Bissau',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇬🇾',
  //   names: ['guyana'],
  //   tags: [],
  //   description: 'flag: Guyana',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇭🇰',
  //   names: ['hong_kong'],
  //   tags: [],
  //   description: 'flag: Hong Kong SAR China',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇭🇲',
  //   names: ['heard_mcdonald_islands'],
  //   tags: [],
  //   description: 'flag: Heard & McDonald Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇭🇳',
  //   names: ['honduras'],
  //   tags: [],
  //   description: 'flag: Honduras',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇭🇷',
  //   names: ['croatia'],
  //   tags: [],
  //   description: 'flag: Croatia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇭🇹',
  //   names: ['haiti'],
  //   tags: [],
  //   description: 'flag: Haiti',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇭🇺',
  //   names: ['hungary'],
  //   tags: [],
  //   description: 'flag: Hungary',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇮🇨',
  //   names: ['canary_islands'],
  //   tags: [],
  //   description: 'flag: Canary Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇮🇩',
  //   names: ['indonesia'],
  //   tags: [],
  //   description: 'flag: Indonesia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇮🇪',
  //   names: ['ireland'],
  //   tags: [],
  //   description: 'flag: Ireland',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇮🇱',
  //   names: ['israel'],
  //   tags: [],
  //   description: 'flag: Israel',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇮🇲',
  //   names: ['isle_of_man'],
  //   tags: [],
  //   description: 'flag: Isle of Man',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇮🇳',
  //   names: ['india'],
  //   tags: [],
  //   description: 'flag: India',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇮🇴',
  //   names: ['british_indian_ocean_territory'],
  //   tags: [],
  //   description: 'flag: British Indian Ocean Territory',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇮🇶',
  //   names: ['iraq'],
  //   tags: [],
  //   description: 'flag: Iraq',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇮🇷',
  //   names: ['iran'],
  //   tags: [],
  //   description: 'flag: Iran',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇮🇸',
  //   names: ['iceland'],
  //   tags: [],
  //   description: 'flag: Iceland',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇮🇹',
  //   names: ['it'],
  //   tags: ['italy'],
  //   description: 'flag: Italy',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇯🇪',
  //   names: ['jersey'],
  //   tags: [],
  //   description: 'flag: Jersey',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇯🇲',
  //   names: ['jamaica'],
  //   tags: [],
  //   description: 'flag: Jamaica',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇯🇴',
  //   names: ['jordan'],
  //   tags: [],
  //   description: 'flag: Jordan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇯🇵',
  //   names: ['jp'],
  //   tags: ['japan'],
  //   description: 'flag: Japan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇰🇪',
  //   names: ['kenya'],
  //   tags: [],
  //   description: 'flag: Kenya',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇰🇬',
  //   names: ['kyrgyzstan'],
  //   tags: [],
  //   description: 'flag: Kyrgyzstan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇰🇭',
  //   names: ['cambodia'],
  //   tags: [],
  //   description: 'flag: Cambodia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇰🇮',
  //   names: ['kiribati'],
  //   tags: [],
  //   description: 'flag: Kiribati',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇰🇲',
  //   names: ['comoros'],
  //   tags: [],
  //   description: 'flag: Comoros',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇰🇳',
  //   names: ['st_kitts_nevis'],
  //   tags: [],
  //   description: 'flag: St. Kitts & Nevis',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇰🇵',
  //   names: ['north_korea'],
  //   tags: [],
  //   description: 'flag: North Korea',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇰🇷',
  //   names: ['kr'],
  //   tags: ['korea'],
  //   description: 'flag: South Korea',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇰🇼',
  //   names: ['kuwait'],
  //   tags: [],
  //   description: 'flag: Kuwait',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇰🇾',
  //   names: ['cayman_islands'],
  //   tags: [],
  //   description: 'flag: Cayman Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇰🇿',
  //   names: ['kazakhstan'],
  //   tags: [],
  //   description: 'flag: Kazakhstan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇱🇦',
  //   names: ['laos'],
  //   tags: [],
  //   description: 'flag: Laos',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇱🇧',
  //   names: ['lebanon'],
  //   tags: [],
  //   description: 'flag: Lebanon',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇱🇨',
  //   names: ['st_lucia'],
  //   tags: [],
  //   description: 'flag: St. Lucia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇱🇮',
  //   names: ['liechtenstein'],
  //   tags: [],
  //   description: 'flag: Liechtenstein',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇱🇰',
  //   names: ['sri_lanka'],
  //   tags: [],
  //   description: 'flag: Sri Lanka',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇱🇷',
  //   names: ['liberia'],
  //   tags: [],
  //   description: 'flag: Liberia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇱🇸',
  //   names: ['lesotho'],
  //   tags: [],
  //   description: 'flag: Lesotho',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇱🇹',
  //   names: ['lithuania'],
  //   tags: [],
  //   description: 'flag: Lithuania',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇱🇺',
  //   names: ['luxembourg'],
  //   tags: [],
  //   description: 'flag: Luxembourg',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇱🇻',
  //   names: ['latvia'],
  //   tags: [],
  //   description: 'flag: Latvia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇱🇾',
  //   names: ['libya'],
  //   tags: [],
  //   description: 'flag: Libya',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇦',
  //   names: ['morocco'],
  //   tags: [],
  //   description: 'flag: Morocco',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇨',
  //   names: ['monaco'],
  //   tags: [],
  //   description: 'flag: Monaco',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇩',
  //   names: ['moldova'],
  //   tags: [],
  //   description: 'flag: Moldova',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇪',
  //   names: ['montenegro'],
  //   tags: [],
  //   description: 'flag: Montenegro',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇫',
  //   names: ['st_martin'],
  //   tags: [],
  //   description: 'flag: St. Martin',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇬',
  //   names: ['madagascar'],
  //   tags: [],
  //   description: 'flag: Madagascar',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇭',
  //   names: ['marshall_islands'],
  //   tags: [],
  //   description: 'flag: Marshall Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇰',
  //   names: ['macedonia'],
  //   tags: [],
  //   description: 'flag: North Macedonia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇱',
  //   names: ['mali'],
  //   tags: [],
  //   description: 'flag: Mali',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇲',
  //   names: ['myanmar'],
  //   tags: ['burma'],
  //   description: 'flag: Myanmar (Burma)',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇳',
  //   names: ['mongolia'],
  //   tags: [],
  //   description: 'flag: Mongolia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇴',
  //   names: ['macau'],
  //   tags: [],
  //   description: 'flag: Macao SAR China',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇵',
  //   names: ['northern_mariana_islands'],
  //   tags: [],
  //   description: 'flag: Northern Mariana Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇶',
  //   names: ['martinique'],
  //   tags: [],
  //   description: 'flag: Martinique',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇷',
  //   names: ['mauritania'],
  //   tags: [],
  //   description: 'flag: Mauritania',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇸',
  //   names: ['montserrat'],
  //   tags: [],
  //   description: 'flag: Montserrat',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇹',
  //   names: ['malta'],
  //   tags: [],
  //   description: 'flag: Malta',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇺',
  //   names: ['mauritius'],
  //   tags: [],
  //   description: 'flag: Mauritius',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇻',
  //   names: ['maldives'],
  //   tags: [],
  //   description: 'flag: Maldives',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇼',
  //   names: ['malawi'],
  //   tags: [],
  //   description: 'flag: Malawi',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇽',
  //   names: ['mexico'],
  //   tags: [],
  //   description: 'flag: Mexico',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇾',
  //   names: ['malaysia'],
  //   tags: [],
  //   description: 'flag: Malaysia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇲🇿',
  //   names: ['mozambique'],
  //   tags: [],
  //   description: 'flag: Mozambique',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇳🇦',
  //   names: ['namibia'],
  //   tags: [],
  //   description: 'flag: Namibia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇳🇨',
  //   names: ['new_caledonia'],
  //   tags: [],
  //   description: 'flag: New Caledonia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇳🇪',
  //   names: ['niger'],
  //   tags: [],
  //   description: 'flag: Niger',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇳🇫',
  //   names: ['norfolk_island'],
  //   tags: [],
  //   description: 'flag: Norfolk Island',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇳🇬',
  //   names: ['nigeria'],
  //   tags: [],
  //   description: 'flag: Nigeria',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇳🇮',
  //   names: ['nicaragua'],
  //   tags: [],
  //   description: 'flag: Nicaragua',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇳🇱',
  //   names: ['netherlands'],
  //   tags: [],
  //   description: 'flag: Netherlands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇳🇴',
  //   names: ['norway'],
  //   tags: [],
  //   description: 'flag: Norway',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇳🇵',
  //   names: ['nepal'],
  //   tags: [],
  //   description: 'flag: Nepal',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇳🇷',
  //   names: ['nauru'],
  //   tags: [],
  //   description: 'flag: Nauru',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇳🇺',
  //   names: ['niue'],
  //   tags: [],
  //   description: 'flag: Niue',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇳🇿',
  //   names: ['new_zealand'],
  //   tags: [],
  //   description: 'flag: New Zealand',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇴🇲',
  //   names: ['oman'],
  //   tags: [],
  //   description: 'flag: Oman',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇦',
  //   names: ['panama'],
  //   tags: [],
  //   description: 'flag: Panama',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇪',
  //   names: ['peru'],
  //   tags: [],
  //   description: 'flag: Peru',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇫',
  //   names: ['french_polynesia'],
  //   tags: [],
  //   description: 'flag: French Polynesia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇬',
  //   names: ['papua_new_guinea'],
  //   tags: [],
  //   description: 'flag: Papua New Guinea',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇭',
  //   names: ['philippines'],
  //   tags: [],
  //   description: 'flag: Philippines',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇰',
  //   names: ['pakistan'],
  //   tags: [],
  //   description: 'flag: Pakistan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇱',
  //   names: ['poland'],
  //   tags: [],
  //   description: 'flag: Poland',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇲',
  //   names: ['st_pierre_miquelon'],
  //   tags: [],
  //   description: 'flag: St. Pierre & Miquelon',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇳',
  //   names: ['pitcairn_islands'],
  //   tags: [],
  //   description: 'flag: Pitcairn Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇷',
  //   names: ['puerto_rico'],
  //   tags: [],
  //   description: 'flag: Puerto Rico',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇸',
  //   names: ['palestinian_territories'],
  //   tags: [],
  //   description: 'flag: Palestinian Territories',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇹',
  //   names: ['portugal'],
  //   tags: [],
  //   description: 'flag: Portugal',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇼',
  //   names: ['palau'],
  //   tags: [],
  //   description: 'flag: Palau',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇵🇾',
  //   names: ['paraguay'],
  //   tags: [],
  //   description: 'flag: Paraguay',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇶🇦',
  //   names: ['qatar'],
  //   tags: [],
  //   description: 'flag: Qatar',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇷🇪',
  //   names: ['reunion'],
  //   tags: [],
  //   description: 'flag: Réunion',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇷🇴',
  //   names: ['romania'],
  //   tags: [],
  //   description: 'flag: Romania',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇷🇸',
  //   names: ['serbia'],
  //   tags: [],
  //   description: 'flag: Serbia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇷🇺',
  //   names: ['ru'],
  //   tags: ['russia'],
  //   description: 'flag: Russia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇷🇼',
  //   names: ['rwanda'],
  //   tags: [],
  //   description: 'flag: Rwanda',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇦',
  //   names: ['saudi_arabia'],
  //   tags: [],
  //   description: 'flag: Saudi Arabia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇧',
  //   names: ['solomon_islands'],
  //   tags: [],
  //   description: 'flag: Solomon Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇨',
  //   names: ['seychelles'],
  //   tags: [],
  //   description: 'flag: Seychelles',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇩',
  //   names: ['sudan'],
  //   tags: [],
  //   description: 'flag: Sudan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇪',
  //   names: ['sweden'],
  //   tags: [],
  //   description: 'flag: Sweden',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇬',
  //   names: ['singapore'],
  //   tags: [],
  //   description: 'flag: Singapore',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇭',
  //   names: ['st_helena'],
  //   tags: [],
  //   description: 'flag: St. Helena',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇮',
  //   names: ['slovenia'],
  //   tags: [],
  //   description: 'flag: Slovenia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇯',
  //   names: ['svalbard_jan_mayen'],
  //   tags: [],
  //   description: 'flag: Svalbard & Jan Mayen',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇰',
  //   names: ['slovakia'],
  //   tags: [],
  //   description: 'flag: Slovakia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇱',
  //   names: ['sierra_leone'],
  //   tags: [],
  //   description: 'flag: Sierra Leone',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇲',
  //   names: ['san_marino'],
  //   tags: [],
  //   description: 'flag: San Marino',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇳',
  //   names: ['senegal'],
  //   tags: [],
  //   description: 'flag: Senegal',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇴',
  //   names: ['somalia'],
  //   tags: [],
  //   description: 'flag: Somalia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇷',
  //   names: ['suriname'],
  //   tags: [],
  //   description: 'flag: Suriname',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇸',
  //   names: ['south_sudan'],
  //   tags: [],
  //   description: 'flag: South Sudan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇹',
  //   names: ['sao_tome_principe'],
  //   tags: [],
  //   description: 'flag: São Tomé & Príncipe',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇻',
  //   names: ['el_salvador'],
  //   tags: [],
  //   description: 'flag: El Salvador',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇽',
  //   names: ['sint_maarten'],
  //   tags: [],
  //   description: 'flag: Sint Maarten',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇾',
  //   names: ['syria'],
  //   tags: [],
  //   description: 'flag: Syria',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇸🇿',
  //   names: ['swaziland'],
  //   tags: [],
  //   description: 'flag: Eswatini',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇦',
  //   names: ['tristan_da_cunha'],
  //   tags: [],
  //   description: 'flag: Tristan da Cunha',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇨',
  //   names: ['turks_caicos_islands'],
  //   tags: [],
  //   description: 'flag: Turks & Caicos Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇩',
  //   names: ['chad'],
  //   tags: [],
  //   description: 'flag: Chad',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇫',
  //   names: ['french_southern_territories'],
  //   tags: [],
  //   description: 'flag: French Southern Territories',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇬',
  //   names: ['togo'],
  //   tags: [],
  //   description: 'flag: Togo',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇭',
  //   names: ['thailand'],
  //   tags: [],
  //   description: 'flag: Thailand',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇯',
  //   names: ['tajikistan'],
  //   tags: [],
  //   description: 'flag: Tajikistan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇰',
  //   names: ['tokelau'],
  //   tags: [],
  //   description: 'flag: Tokelau',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇱',
  //   names: ['timor_leste'],
  //   tags: [],
  //   description: 'flag: Timor-Leste',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇲',
  //   names: ['turkmenistan'],
  //   tags: [],
  //   description: 'flag: Turkmenistan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇳',
  //   names: ['tunisia'],
  //   tags: [],
  //   description: 'flag: Tunisia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇴',
  //   names: ['tonga'],
  //   tags: [],
  //   description: 'flag: Tonga',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇷',
  //   names: ['tr'],
  //   tags: ['turkey'],
  //   description: 'flag: Turkey',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇹',
  //   names: ['trinidad_tobago'],
  //   tags: [],
  //   description: 'flag: Trinidad & Tobago',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇻',
  //   names: ['tuvalu'],
  //   tags: [],
  //   description: 'flag: Tuvalu',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇼',
  //   names: ['taiwan'],
  //   tags: [],
  //   description: 'flag: Taiwan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇹🇿',
  //   names: ['tanzania'],
  //   tags: [],
  //   description: 'flag: Tanzania',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇺🇦',
  //   names: ['ukraine'],
  //   tags: [],
  //   description: 'flag: Ukraine',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇺🇬',
  //   names: ['uganda'],
  //   tags: [],
  //   description: 'flag: Uganda',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇺🇲',
  //   names: ['us_outlying_islands'],
  //   tags: [],
  //   description: 'flag: U.S. Outlying Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇺🇳',
  //   names: ['united_nations'],
  //   tags: [],
  //   description: 'flag: United Nations',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇺🇸',
  //   names: ['us'],
  //   tags: ['flag', 'united', 'america'],
  //   description: 'flag: United States',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇺🇾',
  //   names: ['uruguay'],
  //   tags: [],
  //   description: 'flag: Uruguay',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇺🇿',
  //   names: ['uzbekistan'],
  //   tags: [],
  //   description: 'flag: Uzbekistan',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇻🇦',
  //   names: ['vatican_city'],
  //   tags: [],
  //   description: 'flag: Vatican City',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇻🇨',
  //   names: ['st_vincent_grenadines'],
  //   tags: [],
  //   description: 'flag: St. Vincent & Grenadines',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇻🇪',
  //   names: ['venezuela'],
  //   tags: [],
  //   description: 'flag: Venezuela',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇻🇬',
  //   names: ['british_virgin_islands'],
  //   tags: [],
  //   description: 'flag: British Virgin Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇻🇮',
  //   names: ['us_virgin_islands'],
  //   tags: [],
  //   description: 'flag: U.S. Virgin Islands',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇻🇳',
  //   names: ['vietnam'],
  //   tags: [],
  //   description: 'flag: Vietnam',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇻🇺',
  //   names: ['vanuatu'],
  //   tags: [],
  //   description: 'flag: Vanuatu',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇼🇫',
  //   names: ['wallis_futuna'],
  //   tags: [],
  //   description: 'flag: Wallis & Futuna',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇼🇸',
  //   names: ['samoa'],
  //   tags: [],
  //   description: 'flag: Samoa',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇽🇰',
  //   names: ['kosovo'],
  //   tags: [],
  //   description: 'flag: Kosovo',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇾🇪',
  //   names: ['yemen'],
  //   tags: [],
  //   description: 'flag: Yemen',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇾🇹',
  //   names: ['mayotte'],
  //   tags: [],
  //   description: 'flag: Mayotte',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇿🇦',
  //   names: ['south_africa'],
  //   tags: [],
  //   description: 'flag: South Africa',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇿🇲',
  //   names: ['zambia'],
  //   tags: [],
  //   description: 'flag: Zambia',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🇿🇼',
  //   names: ['zimbabwe'],
  //   tags: [],
  //   description: 'flag: Zimbabwe',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  //   names: ['england'],
  //   tags: [],
  //   description: 'flag: England',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  //   names: ['scotland'],
  //   tags: [],
  //   description: 'flag: Scotland',
  //   category: 'Flags'
  // },
  // {
  //   emoji: '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
  //   names: ['wales'],
  //   tags: [],
  //   description: 'flag: Wales',
  //   category: 'Flags'
  // }
]

/**
 * Map of names to emoji.
 *
 * @type {Record<string, string>}
 */
export const nameToEmoji = {
  100: '💯',
  1234: '🔢',
  grinning: '😀',
  smiley: '😃',
  smile: '😄',
  grin: '😁',
  laughing: '😆',
  satisfied: '😆',
  sweat_smile: '😅',
  rofl: '🤣',
  joy: '😂',
  slightly_smiling_face: '🙂',
  upside_down_face: '🙃',
  melting_face: '🫠',
  wink: '😉',
  blush: '😊',
  innocent: '😇',
  smiling_face_with_three_hearts: '🥰',
  heart_eyes: '😍',
  star_struck: '🤩',
  kissing_heart: '😘',
  kissing: '😗',
  relaxed: '☺️',
  kissing_closed_eyes: '😚',
  kissing_smiling_eyes: '😙',
  smiling_face_with_tear: '🥲',
  yum: '😋',
  stuck_out_tongue: '😛',
  stuck_out_tongue_winking_eye: '😜',
  zany_face: '🤪',
  stuck_out_tongue_closed_eyes: '😝',
  money_mouth_face: '🤑',
  hugs: '🤗',
  hand_over_mouth: '🤭',
  face_with_open_eyes_and_hand_over_mouth: '🫢',
  face_with_peeking_eye: '🫣',
  shushing_face: '🤫',
  thinking: '🤔',
  saluting_face: '🫡',
  zipper_mouth_face: '🤐',
  raised_eyebrow: '🤨',
  neutral_face: '😐',
  expressionless: '😑',
  no_mouth: '😶',
  dotted_line_face: '🫥',
  face_in_clouds: '😶‍🌫️',
  smirk: '😏',
  unamused: '😒',
  roll_eyes: '🙄',
  grimacing: '😬',
  face_exhaling: '😮‍💨',
  lying_face: '🤥',
  shaking_face: '🫨',
  relieved: '😌',
  pensive: '😔',
  sleepy: '😪',
  drooling_face: '🤤',
  sleeping: '😴',
  mask: '😷',
  face_with_thermometer: '🤒',
  face_with_head_bandage: '🤕',
  nauseated_face: '🤢',
  vomiting_face: '🤮',
  sneezing_face: '🤧',
  hot_face: '🥵',
  cold_face: '🥶',
  woozy_face: '🥴',
  dizzy_face: '😵',
  face_with_spiral_eyes: '😵‍💫',
  exploding_head: '🤯',
  cowboy_hat_face: '🤠',
  partying_face: '🥳',
  disguised_face: '🥸',
  sunglasses: '😎',
  nerd_face: '🤓',
  monocle_face: '🧐',
  confused: '😕',
  face_with_diagonal_mouth: '🫤',
  worried: '😟',
  slightly_frowning_face: '🙁',
  frowning_face: '☹️',
  open_mouth: '😮',
  hushed: '😯',
  astonished: '😲',
  flushed: '😳',
  pleading_face: '🥺',
  face_holding_back_tears: '🥹',
  frowning: '😦',
  anguished: '😧',
  fearful: '😨',
  cold_sweat: '😰',
  disappointed_relieved: '😥',
  cry: '😢',
  sob: '😭',
  scream: '😱',
  confounded: '😖',
  persevere: '😣',
  disappointed: '😞',
  sweat: '😓',
  weary: '😩',
  tired_face: '😫',
  yawning_face: '🥱',
  triumph: '😤',
  rage: '😡',
  pout: '😡',
  angry: '😠',
  cursing_face: '🤬',
  smiling_imp: '😈',
  imp: '👿',
  skull: '💀',
  skull_and_crossbones: '☠️',
  hankey: '💩',
  poop: '💩',
  shit: '💩',
  clown_face: '🤡',
  japanese_ogre: '👹',
  japanese_goblin: '👺',
  ghost: '👻',
  alien: '👽',
  space_invader: '👾',
  robot: '🤖',
  smiley_cat: '😺',
  smile_cat: '😸',
  joy_cat: '😹',
  heart_eyes_cat: '😻',
  smirk_cat: '😼',
  kissing_cat: '😽',
  scream_cat: '🙀',
  crying_cat_face: '😿',
  pouting_cat: '😾',
  see_no_evil: '🙈',
  hear_no_evil: '🙉',
  speak_no_evil: '🙊',
  love_letter: '💌',
  cupid: '💘',
  gift_heart: '💝',
  sparkling_heart: '💖',
  heartpulse: '💗',
  heartbeat: '💓',
  revolving_hearts: '💞',
  two_hearts: '💕',
  heart_decoration: '💟',
  heavy_heart_exclamation: '❣️',
  broken_heart: '💔',
  heart_on_fire: '❤️‍🔥',
  mending_heart: '❤️‍🩹',
  heart: '❤️',
  pink_heart: '🩷',
  orange_heart: '🧡',
  yellow_heart: '💛',
  green_heart: '💚',
  blue_heart: '💙',
  light_blue_heart: '🩵',
  purple_heart: '💜',
  brown_heart: '🤎',
  black_heart: '🖤',
  grey_heart: '🩶',
  white_heart: '🤍',
  kiss: '💋',
  anger: '💢',
  boom: '💥',
  collision: '💥',
  dizzy: '💫',
  sweat_drops: '💦',
  dash: '💨',
  hole: '🕳️',
  speech_balloon: '💬',
  eye_speech_bubble: '👁️‍🗨️',
  left_speech_bubble: '🗨️',
  right_anger_bubble: '🗯️',
  thought_balloon: '💭',
  zzz: '💤',
  wave: '👋',
  raised_back_of_hand: '🤚',
  raised_hand_with_fingers_splayed: '🖐️',
  hand: '✋',
  raised_hand: '✋',
  vulcan_salute: '🖖',
  rightwards_hand: '🫱',
  leftwards_hand: '🫲',
  palm_down_hand: '🫳',
  palm_up_hand: '🫴',
  leftwards_pushing_hand: '🫷',
  rightwards_pushing_hand: '🫸',
  ok_hand: '👌',
  pinched_fingers: '🤌',
  pinching_hand: '🤏',
  v: '✌️',
  crossed_fingers: '🤞',
  hand_with_index_finger_and_thumb_crossed: '🫰',
  love_you_gesture: '🤟',
  metal: '🤘',
  call_me_hand: '🤙',
  point_left: '👈',
  point_right: '👉',
  point_up_2: '👆',
  middle_finger: '🖕',
  fu: '🖕',
  point_down: '👇',
  point_up: '☝️',
  index_pointing_at_the_viewer: '🫵',
  '+1': '👍',
  thumbsup: '👍',
  '-1': '👎',
  thumbsdown: '👎',
  fist_raised: '✊',
  fist: '✊',
  fist_oncoming: '👊',
  facepunch: '👊',
  punch: '👊',
  fist_left: '🤛',
  fist_right: '🤜',
  clap: '👏',
  raised_hands: '🙌',
  heart_hands: '🫶',
  open_hands: '👐',
  palms_up_together: '🤲',
  handshake: '🤝',
  pray: '🙏',
  writing_hand: '✍️',
  nail_care: '💅',
  selfie: '🤳',
  muscle: '💪',
  mechanical_arm: '🦾',
  mechanical_leg: '🦿',
  leg: '🦵',
  foot: '🦶',
  ear: '👂',
  ear_with_hearing_aid: '🦻',
  nose: '👃',
  brain: '🧠',
  anatomical_heart: '🫀',
  lungs: '🫁',
  tooth: '🦷',
  bone: '🦴',
  eyes: '👀',
  eye: '👁️',
  tongue: '👅',
  lips: '👄',
  biting_lip: '🫦',
  baby: '👶',
  child: '🧒',
  boy: '👦',
  girl: '👧',
  adult: '🧑',
  blond_haired_person: '👱',
  man: '👨',
  bearded_person: '🧔',
  man_beard: '🧔‍♂️',
  woman_beard: '🧔‍♀️',
  red_haired_man: '👨‍🦰',
  curly_haired_man: '👨‍🦱',
  white_haired_man: '👨‍🦳',
  bald_man: '👨‍🦲',
  woman: '👩',
  red_haired_woman: '👩‍🦰',
  person_red_hair: '🧑‍🦰',
  curly_haired_woman: '👩‍🦱',
  person_curly_hair: '🧑‍🦱',
  white_haired_woman: '👩‍🦳',
  person_white_hair: '🧑‍🦳',
  bald_woman: '👩‍🦲',
  person_bald: '🧑‍🦲',
  blond_haired_woman: '👱‍♀️',
  blonde_woman: '👱‍♀️',
  blond_haired_man: '👱‍♂️',
  older_adult: '🧓',
  older_man: '👴',
  older_woman: '👵',
  frowning_person: '🙍',
  frowning_man: '🙍‍♂️',
  frowning_woman: '🙍‍♀️',
  pouting_face: '🙎',
  pouting_man: '🙎‍♂️',
  pouting_woman: '🙎‍♀️',
  no_good: '🙅',
  no_good_man: '🙅‍♂️',
  ng_man: '🙅‍♂️',
  no_good_woman: '🙅‍♀️',
  ng_woman: '🙅‍♀️',
  ok_person: '🙆',
  ok_man: '🙆‍♂️',
  ok_woman: '🙆‍♀️',
  tipping_hand_person: '💁',
  information_desk_person: '💁',
  tipping_hand_man: '💁‍♂️',
  sassy_man: '💁‍♂️',
  tipping_hand_woman: '💁‍♀️',
  sassy_woman: '💁‍♀️',
  raising_hand: '🙋',
  raising_hand_man: '🙋‍♂️',
  raising_hand_woman: '🙋‍♀️',
  deaf_person: '🧏',
  deaf_man: '🧏‍♂️',
  deaf_woman: '🧏‍♀️',
  bow: '🙇',
  bowing_man: '🙇‍♂️',
  bowing_woman: '🙇‍♀️',
  facepalm: '🤦',
  man_facepalming: '🤦‍♂️',
  woman_facepalming: '🤦‍♀️',
  shrug: '🤷',
  man_shrugging: '🤷‍♂️',
  woman_shrugging: '🤷‍♀️',
  health_worker: '🧑‍⚕️',
  man_health_worker: '👨‍⚕️',
  woman_health_worker: '👩‍⚕️',
  student: '🧑‍🎓',
  man_student: '👨‍🎓',
  woman_student: '👩‍🎓',
  teacher: '🧑‍🏫',
  man_teacher: '👨‍🏫',
  woman_teacher: '👩‍🏫',
  judge: '🧑‍⚖️',
  man_judge: '👨‍⚖️',
  woman_judge: '👩‍⚖️',
  farmer: '🧑‍🌾',
  man_farmer: '👨‍🌾',
  woman_farmer: '👩‍🌾',
  cook: '🧑‍🍳',
  man_cook: '👨‍🍳',
  woman_cook: '👩‍🍳',
  mechanic: '🧑‍🔧',
  man_mechanic: '👨‍🔧',
  woman_mechanic: '👩‍🔧',
  factory_worker: '🧑‍🏭',
  man_factory_worker: '👨‍🏭',
  woman_factory_worker: '👩‍🏭',
  office_worker: '🧑‍💼',
  man_office_worker: '👨‍💼',
  woman_office_worker: '👩‍💼',
  scientist: '🧑‍🔬',
  man_scientist: '👨‍🔬',
  woman_scientist: '👩‍🔬',
  technologist: '🧑‍💻',
  man_technologist: '👨‍💻',
  woman_technologist: '👩‍💻',
  singer: '🧑‍🎤',
  man_singer: '👨‍🎤',
  woman_singer: '👩‍🎤',
  artist: '🧑‍🎨',
  man_artist: '👨‍🎨',
  woman_artist: '👩‍🎨',
  pilot: '🧑‍✈️',
  man_pilot: '👨‍✈️',
  woman_pilot: '👩‍✈️',
  astronaut: '🧑‍🚀',
  man_astronaut: '👨‍🚀',
  woman_astronaut: '👩‍🚀',
  firefighter: '🧑‍🚒',
  man_firefighter: '👨‍🚒',
  woman_firefighter: '👩‍🚒',
  police_officer: '👮',
  cop: '👮',
  policeman: '👮‍♂️',
  policewoman: '👮‍♀️',
  detective: '🕵️',
  male_detective: '🕵️‍♂️',
  female_detective: '🕵️‍♀️',
  guard: '💂',
  guardsman: '💂‍♂️',
  guardswoman: '💂‍♀️',
  ninja: '🥷',
  construction_worker: '👷',
  construction_worker_man: '👷‍♂️',
  construction_worker_woman: '👷‍♀️',
  person_with_crown: '🫅',
  prince: '🤴',
  princess: '👸',
  person_with_turban: '👳',
  man_with_turban: '👳‍♂️',
  woman_with_turban: '👳‍♀️',
  man_with_gua_pi_mao: '👲',
  woman_with_headscarf: '🧕',
  person_in_tuxedo: '🤵',
  man_in_tuxedo: '🤵‍♂️',
  woman_in_tuxedo: '🤵‍♀️',
  person_with_veil: '👰',
  man_with_veil: '👰‍♂️',
  woman_with_veil: '👰‍♀️',
  bride_with_veil: '👰‍♀️',
  pregnant_woman: '🤰',
  pregnant_man: '🫃',
  pregnant_person: '🫄',
  breast_feeding: '🤱',
  woman_feeding_baby: '👩‍🍼',
  man_feeding_baby: '👨‍🍼',
  person_feeding_baby: '🧑‍🍼',
  angel: '👼',
  santa: '🎅',
  mrs_claus: '🤶',
  mx_claus: '🧑‍🎄',
  superhero: '🦸',
  superhero_man: '🦸‍♂️',
  superhero_woman: '🦸‍♀️',
  supervillain: '🦹',
  supervillain_man: '🦹‍♂️',
  supervillain_woman: '🦹‍♀️',
  mage: '🧙',
  mage_man: '🧙‍♂️',
  mage_woman: '🧙‍♀️',
  fairy: '🧚',
  fairy_man: '🧚‍♂️',
  fairy_woman: '🧚‍♀️',
  vampire: '🧛',
  vampire_man: '🧛‍♂️',
  vampire_woman: '🧛‍♀️',
  merperson: '🧜',
  merman: '🧜‍♂️',
  mermaid: '🧜‍♀️',
  elf: '🧝',
  elf_man: '🧝‍♂️',
  elf_woman: '🧝‍♀️',
  genie: '🧞',
  genie_man: '🧞‍♂️',
  genie_woman: '🧞‍♀️',
  zombie: '🧟',
  zombie_man: '🧟‍♂️',
  zombie_woman: '🧟‍♀️',
  troll: '🧌',
  massage: '💆',
  massage_man: '💆‍♂️',
  massage_woman: '💆‍♀️',
  haircut: '💇',
  haircut_man: '💇‍♂️',
  haircut_woman: '💇‍♀️',
  walking: '🚶',
  walking_man: '🚶‍♂️',
  walking_woman: '🚶‍♀️',
  standing_person: '🧍',
  standing_man: '🧍‍♂️',
  standing_woman: '🧍‍♀️',
  kneeling_person: '🧎',
  kneeling_man: '🧎‍♂️',
  kneeling_woman: '🧎‍♀️',
  person_with_probing_cane: '🧑‍🦯',
  man_with_probing_cane: '👨‍🦯',
  woman_with_probing_cane: '👩‍🦯',
  person_in_motorized_wheelchair: '🧑‍🦼',
  man_in_motorized_wheelchair: '👨‍🦼',
  woman_in_motorized_wheelchair: '👩‍🦼',
  person_in_manual_wheelchair: '🧑‍🦽',
  man_in_manual_wheelchair: '👨‍🦽',
  woman_in_manual_wheelchair: '👩‍🦽',
  runner: '🏃',
  running: '🏃',
  running_man: '🏃‍♂️',
  running_woman: '🏃‍♀️',
  woman_dancing: '💃',
  dancer: '💃',
  man_dancing: '🕺',
  business_suit_levitating: '🕴️',
  dancers: '👯',
  dancing_men: '👯‍♂️',
  dancing_women: '👯‍♀️',
  sauna_person: '🧖',
  sauna_man: '🧖‍♂️',
  sauna_woman: '🧖‍♀️',
  climbing: '🧗',
  climbing_man: '🧗‍♂️',
  climbing_woman: '🧗‍♀️',
  person_fencing: '🤺',
  horse_racing: '🏇',
  skier: '⛷️',
  snowboarder: '🏂',
  golfing: '🏌️',
  golfing_man: '🏌️‍♂️',
  golfing_woman: '🏌️‍♀️',
  surfer: '🏄',
  surfing_man: '🏄‍♂️',
  surfing_woman: '🏄‍♀️',
  rowboat: '🚣',
  rowing_man: '🚣‍♂️',
  rowing_woman: '🚣‍♀️',
  swimmer: '🏊',
  swimming_man: '🏊‍♂️',
  swimming_woman: '🏊‍♀️',
  bouncing_ball_person: '⛹️',
  bouncing_ball_man: '⛹️‍♂️',
  basketball_man: '⛹️‍♂️',
  bouncing_ball_woman: '⛹️‍♀️',
  basketball_woman: '⛹️‍♀️',
  weight_lifting: '🏋️',
  weight_lifting_man: '🏋️‍♂️',
  weight_lifting_woman: '🏋️‍♀️',
  bicyclist: '🚴',
  biking_man: '🚴‍♂️',
  biking_woman: '🚴‍♀️',
  mountain_bicyclist: '🚵',
  mountain_biking_man: '🚵‍♂️',
  mountain_biking_woman: '🚵‍♀️',
  cartwheeling: '🤸',
  man_cartwheeling: '🤸‍♂️',
  woman_cartwheeling: '🤸‍♀️',
  wrestling: '🤼',
  men_wrestling: '🤼‍♂️',
  women_wrestling: '🤼‍♀️',
  water_polo: '🤽',
  man_playing_water_polo: '🤽‍♂️',
  woman_playing_water_polo: '🤽‍♀️',
  handball_person: '🤾',
  man_playing_handball: '🤾‍♂️',
  woman_playing_handball: '🤾‍♀️',
  juggling_person: '🤹',
  man_juggling: '🤹‍♂️',
  woman_juggling: '🤹‍♀️',
  lotus_position: '🧘',
  lotus_position_man: '🧘‍♂️',
  lotus_position_woman: '🧘‍♀️',
  bath: '🛀',
  sleeping_bed: '🛌',
  people_holding_hands: '🧑‍🤝‍🧑',
  two_women_holding_hands: '👭',
  couple: '👫',
  two_men_holding_hands: '👬',
  couplekiss: '💏',
  couplekiss_man_woman: '👩‍❤️‍💋‍👨',
  couplekiss_man_man: '👨‍❤️‍💋‍👨',
  couplekiss_woman_woman: '👩‍❤️‍💋‍👩',
  couple_with_heart: '💑',
  couple_with_heart_woman_man: '👩‍❤️‍👨',
  couple_with_heart_man_man: '👨‍❤️‍👨',
  couple_with_heart_woman_woman: '👩‍❤️‍👩',
  family: '👪',
  family_man_woman_boy: '👨‍👩‍👦',
  family_man_woman_girl: '👨‍👩‍👧',
  family_man_woman_girl_boy: '👨‍👩‍👧‍👦',
  family_man_woman_boy_boy: '👨‍👩‍👦‍👦',
  family_man_woman_girl_girl: '👨‍👩‍👧‍👧',
  family_man_man_boy: '👨‍👨‍👦',
  family_man_man_girl: '👨‍👨‍👧',
  family_man_man_girl_boy: '👨‍👨‍👧‍👦',
  family_man_man_boy_boy: '👨‍👨‍👦‍👦',
  family_man_man_girl_girl: '👨‍👨‍👧‍👧',
  family_woman_woman_boy: '👩‍👩‍👦',
  family_woman_woman_girl: '👩‍👩‍👧',
  family_woman_woman_girl_boy: '👩‍👩‍👧‍👦',
  family_woman_woman_boy_boy: '👩‍👩‍👦‍👦',
  family_woman_woman_girl_girl: '👩‍👩‍👧‍👧',
  family_man_boy: '👨‍👦',
  family_man_boy_boy: '👨‍👦‍👦',
  family_man_girl: '👨‍👧',
  family_man_girl_boy: '👨‍👧‍👦',
  family_man_girl_girl: '👨‍👧‍👧',
  family_woman_boy: '👩‍👦',
  family_woman_boy_boy: '👩‍👦‍👦',
  family_woman_girl: '👩‍👧',
  family_woman_girl_boy: '👩‍👧‍👦',
  family_woman_girl_girl: '👩‍👧‍👧',
  speaking_head: '🗣️',
  bust_in_silhouette: '👤',
  busts_in_silhouette: '👥',
  people_hugging: '🫂',
  footprints: '👣',
  monkey_face: '🐵',
  monkey: '🐒',
  gorilla: '🦍',
  orangutan: '🦧',
  dog: '🐶',
  dog2: '🐕',
  guide_dog: '🦮',
  service_dog: '🐕‍🦺',
  poodle: '🐩',
  wolf: '🐺',
  fox_face: '🦊',
  raccoon: '🦝',
  cat: '🐱',
  cat2: '🐈',
  black_cat: '🐈‍⬛',
  lion: '🦁',
  tiger: '🐯',
  tiger2: '🐅',
  leopard: '🐆',
  horse: '🐴',
  moose: '🫎',
  donkey: '🫏',
  racehorse: '🐎',
  unicorn: '🦄',
  zebra: '🦓',
  deer: '🦌',
  bison: '🦬',
  cow: '🐮',
  ox: '🐂',
  water_buffalo: '🐃',
  cow2: '🐄',
  pig: '🐷',
  pig2: '🐖',
  boar: '🐗',
  pig_nose: '🐽',
  ram: '🐏',
  sheep: '🐑',
  goat: '🐐',
  dromedary_camel: '🐪',
  camel: '🐫',
  llama: '🦙',
  giraffe: '🦒',
  elephant: '🐘',
  mammoth: '🦣',
  rhinoceros: '🦏',
  hippopotamus: '🦛',
  mouse: '🐭',
  mouse2: '🐁',
  rat: '🐀',
  hamster: '🐹',
  rabbit: '🐰',
  rabbit2: '🐇',
  chipmunk: '🐿️',
  beaver: '🦫',
  hedgehog: '🦔',
  bat: '🦇',
  bear: '🐻',
  polar_bear: '🐻‍❄️',
  koala: '🐨',
  panda_face: '🐼',
  sloth: '🦥',
  otter: '🦦',
  skunk: '🦨',
  kangaroo: '🦘',
  badger: '🦡',
  feet: '🐾',
  paw_prints: '🐾',
  turkey: '🦃',
  chicken: '🐔',
  rooster: '🐓',
  hatching_chick: '🐣',
  baby_chick: '🐤',
  hatched_chick: '🐥',
  bird: '🐦',
  penguin: '🐧',
  dove: '🕊️',
  eagle: '🦅',
  duck: '🦆',
  swan: '🦢',
  owl: '🦉',
  dodo: '🦤',
  feather: '🪶',
  flamingo: '🦩',
  peacock: '🦚',
  parrot: '🦜',
  wing: '🪽',
  black_bird: '🐦‍⬛',
  goose: '🪿',
  frog: '🐸',
  crocodile: '🐊',
  turtle: '🐢',
  lizard: '🦎',
  snake: '🐍',
  dragon_face: '🐲',
  dragon: '🐉',
  sauropod: '🦕',
  't-rex': '🦖',
  whale: '🐳',
  whale2: '🐋',
  dolphin: '🐬',
  flipper: '🐬',
  seal: '🦭',
  fish: '🐟',
  tropical_fish: '🐠',
  blowfish: '🐡',
  shark: '🦈',
  octopus: '🐙',
  shell: '🐚',
  coral: '🪸',
  jellyfish: '🪼',
  snail: '🐌',
  butterfly: '🦋',
  bug: '🐛',
  ant: '🐜',
  bee: '🐝',
  honeybee: '🐝',
  beetle: '🪲',
  lady_beetle: '🐞',
  cricket: '🦗',
  cockroach: '🪳',
  spider: '🕷️',
  spider_web: '🕸️',
  scorpion: '🦂',
  mosquito: '🦟',
  fly: '🪰',
  worm: '🪱',
  microbe: '🦠',
  bouquet: '💐',
  cherry_blossom: '🌸',
  white_flower: '💮',
  lotus: '🪷',
  rosette: '🏵️',
  rose: '🌹',
  wilted_flower: '🥀',
  hibiscus: '🌺',
  sunflower: '🌻',
  blossom: '🌼',
  tulip: '🌷',
  hyacinth: '🪻',
  seedling: '🌱',
  potted_plant: '🪴',
  evergreen_tree: '🌲',
  deciduous_tree: '🌳',
  palm_tree: '🌴',
  cactus: '🌵',
  ear_of_rice: '🌾',
  herb: '🌿',
  shamrock: '☘️',
  four_leaf_clover: '🍀',
  maple_leaf: '🍁',
  fallen_leaf: '🍂',
  leaves: '🍃',
  empty_nest: '🪹',
  nest_with_eggs: '🪺',
  mushroom: '🍄',
  grapes: '🍇',
  melon: '🍈',
  watermelon: '🍉',
  tangerine: '🍊',
  orange: '🍊',
  mandarin: '🍊',
  lemon: '🍋',
  banana: '🍌',
  pineapple: '🍍',
  mango: '🥭',
  apple: '🍎',
  green_apple: '🍏',
  pear: '🍐',
  peach: '🍑',
  cherries: '🍒',
  strawberry: '🍓',
  blueberries: '🫐',
  kiwi_fruit: '🥝',
  tomato: '🍅',
  olive: '🫒',
  coconut: '🥥',
  avocado: '🥑',
  eggplant: '🍆',
  potato: '🥔',
  carrot: '🥕',
  corn: '🌽',
  hot_pepper: '🌶️',
  bell_pepper: '🫑',
  cucumber: '🥒',
  leafy_green: '🥬',
  broccoli: '🥦',
  garlic: '🧄',
  onion: '🧅',
  peanuts: '🥜',
  beans: '🫘',
  chestnut: '🌰',
  ginger_root: '🫚',
  pea_pod: '🫛',
  bread: '🍞',
  croissant: '🥐',
  baguette_bread: '🥖',
  flatbread: '🫓',
  pretzel: '🥨',
  bagel: '🥯',
  pancakes: '🥞',
  waffle: '🧇',
  cheese: '🧀',
  meat_on_bone: '🍖',
  poultry_leg: '🍗',
  cut_of_meat: '🥩',
  bacon: '🥓',
  hamburger: '🍔',
  fries: '🍟',
  pizza: '🍕',
  hotdog: '🌭',
  sandwich: '🥪',
  taco: '🌮',
  burrito: '🌯',
  tamale: '🫔',
  stuffed_flatbread: '🥙',
  falafel: '🧆',
  egg: '🥚',
  fried_egg: '🍳',
  shallow_pan_of_food: '🥘',
  stew: '🍲',
  fondue: '🫕',
  bowl_with_spoon: '🥣',
  green_salad: '🥗',
  popcorn: '🍿',
  butter: '🧈',
  salt: '🧂',
  canned_food: '🥫',
  bento: '🍱',
  rice_cracker: '🍘',
  rice_ball: '🍙',
  rice: '🍚',
  curry: '🍛',
  ramen: '🍜',
  spaghetti: '🍝',
  sweet_potato: '🍠',
  oden: '🍢',
  sushi: '🍣',
  fried_shrimp: '🍤',
  fish_cake: '🍥',
  moon_cake: '🥮',
  dango: '🍡',
  dumpling: '🥟',
  fortune_cookie: '🥠',
  takeout_box: '🥡',
  crab: '🦀',
  lobster: '🦞',
  shrimp: '🦐',
  squid: '🦑',
  oyster: '🦪',
  icecream: '🍦',
  shaved_ice: '🍧',
  ice_cream: '🍨',
  doughnut: '🍩',
  cookie: '🍪',
  birthday: '🎂',
  cake: '🍰',
  cupcake: '🧁',
  pie: '🥧',
  chocolate_bar: '🍫',
  candy: '🍬',
  lollipop: '🍭',
  custard: '🍮',
  honey_pot: '🍯',
  baby_bottle: '🍼',
  milk_glass: '🥛',
  coffee: '☕',
  teapot: '🫖',
  tea: '🍵',
  sake: '🍶',
  champagne: '🍾',
  wine_glass: '🍷',
  cocktail: '🍸',
  tropical_drink: '🍹',
  beer: '🍺',
  beers: '🍻',
  clinking_glasses: '🥂',
  tumbler_glass: '🥃',
  pouring_liquid: '🫗',
  cup_with_straw: '🥤',
  bubble_tea: '🧋',
  beverage_box: '🧃',
  mate: '🧉',
  ice_cube: '🧊',
  chopsticks: '🥢',
  plate_with_cutlery: '🍽️',
  fork_and_knife: '🍴',
  spoon: '🥄',
  hocho: '🔪',
  knife: '🔪',
  jar: '🫙',
  amphora: '🏺',
  earth_africa: '🌍',
  earth_americas: '🌎',
  earth_asia: '🌏',
  globe_with_meridians: '🌐',
  world_map: '🗺️',
  japan: '🗾',
  compass: '🧭',
  mountain_snow: '🏔️',
  mountain: '⛰️',
  volcano: '🌋',
  mount_fuji: '🗻',
  camping: '🏕️',
  beach_umbrella: '🏖️',
  desert: '🏜️',
  desert_island: '🏝️',
  national_park: '🏞️',
  stadium: '🏟️',
  classical_building: '🏛️',
  building_construction: '🏗️',
  bricks: '🧱',
  rock: '🪨',
  wood: '🪵',
  hut: '🛖',
  houses: '🏘️',
  derelict_house: '🏚️',
  house: '🏠',
  house_with_garden: '🏡',
  office: '🏢',
  post_office: '🏣',
  european_post_office: '🏤',
  hospital: '🏥',
  bank: '🏦',
  hotel: '🏨',
  love_hotel: '🏩',
  convenience_store: '🏪',
  school: '🏫',
  department_store: '🏬',
  factory: '🏭',
  japanese_castle: '🏯',
  european_castle: '🏰',
  wedding: '💒',
  tokyo_tower: '🗼',
  statue_of_liberty: '🗽',
  church: '⛪',
  mosque: '🕌',
  hindu_temple: '🛕',
  synagogue: '🕍',
  shinto_shrine: '⛩️',
  kaaba: '🕋',
  fountain: '⛲',
  tent: '⛺',
  foggy: '🌁',
  night_with_stars: '🌃',
  cityscape: '🏙️',
  sunrise_over_mountains: '🌄',
  sunrise: '🌅',
  city_sunset: '🌆',
  city_sunrise: '🌇',
  bridge_at_night: '🌉',
  hotsprings: '♨️',
  carousel_horse: '🎠',
  playground_slide: '🛝',
  ferris_wheel: '🎡',
  roller_coaster: '🎢',
  barber: '💈',
  circus_tent: '🎪',
  steam_locomotive: '🚂',
  railway_car: '🚃',
  bullettrain_side: '🚄',
  bullettrain_front: '🚅',
  train2: '🚆',
  metro: '🚇',
  light_rail: '🚈',
  station: '🚉',
  tram: '🚊',
  monorail: '🚝',
  mountain_railway: '🚞',
  train: '🚋',
  bus: '🚌',
  oncoming_bus: '🚍',
  trolleybus: '🚎',
  minibus: '🚐',
  ambulance: '🚑',
  fire_engine: '🚒',
  police_car: '🚓',
  oncoming_police_car: '🚔',
  taxi: '🚕',
  oncoming_taxi: '🚖',
  car: '🚗',
  red_car: '🚗',
  oncoming_automobile: '🚘',
  blue_car: '🚙',
  pickup_truck: '🛻',
  truck: '🚚',
  articulated_lorry: '🚛',
  tractor: '🚜',
  racing_car: '🏎️',
  motorcycle: '🏍️',
  motor_scooter: '🛵',
  manual_wheelchair: '🦽',
  motorized_wheelchair: '🦼',
  auto_rickshaw: '🛺',
  bike: '🚲',
  kick_scooter: '🛴',
  skateboard: '🛹',
  roller_skate: '🛼',
  busstop: '🚏',
  motorway: '🛣️',
  railway_track: '🛤️',
  oil_drum: '🛢️',
  fuelpump: '⛽',
  wheel: '🛞',
  rotating_light: '🚨',
  traffic_light: '🚥',
  vertical_traffic_light: '🚦',
  stop_sign: '🛑',
  construction: '🚧',
  anchor: '⚓',
  ring_buoy: '🛟',
  boat: '⛵',
  sailboat: '⛵',
  canoe: '🛶',
  speedboat: '🚤',
  passenger_ship: '🛳️',
  ferry: '⛴️',
  motor_boat: '🛥️',
  ship: '🚢',
  airplane: '✈️',
  small_airplane: '🛩️',
  flight_departure: '🛫',
  flight_arrival: '🛬',
  parachute: '🪂',
  seat: '💺',
  helicopter: '🚁',
  suspension_railway: '🚟',
  mountain_cableway: '🚠',
  aerial_tramway: '🚡',
  artificial_satellite: '🛰️',
  rocket: '🚀',
  flying_saucer: '🛸',
  bellhop_bell: '🛎️',
  luggage: '🧳',
  hourglass: '⌛',
  hourglass_flowing_sand: '⏳',
  watch: '⌚',
  alarm_clock: '⏰',
  stopwatch: '⏱️',
  timer_clock: '⏲️',
  mantelpiece_clock: '🕰️',
  clock12: '🕛',
  clock1230: '🕧',
  clock1: '🕐',
  clock130: '🕜',
  clock2: '🕑',
  clock230: '🕝',
  clock3: '🕒',
  clock330: '🕞',
  clock4: '🕓',
  clock430: '🕟',
  clock5: '🕔',
  clock530: '🕠',
  clock6: '🕕',
  clock630: '🕡',
  clock7: '🕖',
  clock730: '🕢',
  clock8: '🕗',
  clock830: '🕣',
  clock9: '🕘',
  clock930: '🕤',
  clock10: '🕙',
  clock1030: '🕥',
  clock11: '🕚',
  clock1130: '🕦',
  new_moon: '🌑',
  waxing_crescent_moon: '🌒',
  first_quarter_moon: '🌓',
  moon: '🌔',
  waxing_gibbous_moon: '🌔',
  full_moon: '🌕',
  waning_gibbous_moon: '🌖',
  last_quarter_moon: '🌗',
  waning_crescent_moon: '🌘',
  crescent_moon: '🌙',
  new_moon_with_face: '🌚',
  first_quarter_moon_with_face: '🌛',
  last_quarter_moon_with_face: '🌜',
  thermometer: '🌡️',
  sunny: '☀️',
  full_moon_with_face: '🌝',
  sun_with_face: '🌞',
  ringed_planet: '🪐',
  star: '⭐',
  star2: '🌟',
  stars: '🌠',
  milky_way: '🌌',
  cloud: '☁️',
  partly_sunny: '⛅',
  cloud_with_lightning_and_rain: '⛈️',
  sun_behind_small_cloud: '🌤️',
  sun_behind_large_cloud: '🌥️',
  sun_behind_rain_cloud: '🌦️',
  cloud_with_rain: '🌧️',
  cloud_with_snow: '🌨️',
  cloud_with_lightning: '🌩️',
  tornado: '🌪️',
  fog: '🌫️',
  wind_face: '🌬️',
  cyclone: '🌀',
  rainbow: '🌈',
  closed_umbrella: '🌂',
  open_umbrella: '☂️',
  umbrella: '☔',
  parasol_on_ground: '⛱️',
  zap: '⚡',
  snowflake: '❄️',
  snowman_with_snow: '☃️',
  snowman: '⛄',
  comet: '☄️',
  fire: '🔥',
  droplet: '💧',
  ocean: '🌊',
  jack_o_lantern: '🎃',
  christmas_tree: '🎄',
  fireworks: '🎆',
  sparkler: '🎇',
  firecracker: '🧨',
  sparkles: '✨',
  balloon: '🎈',
  tada: '🎉',
  confetti_ball: '🎊',
  tanabata_tree: '🎋',
  bamboo: '🎍',
  dolls: '🎎',
  flags: '🎏',
  wind_chime: '🎐',
  rice_scene: '🎑',
  red_envelope: '🧧',
  ribbon: '🎀',
  gift: '🎁',
  reminder_ribbon: '🎗️',
  tickets: '🎟️',
  ticket: '🎫',
  medal_military: '🎖️',
  trophy: '🏆',
  medal_sports: '🏅',
  '1st_place_medal': '🥇',
  '2nd_place_medal': '🥈',
  '3rd_place_medal': '🥉',
  soccer: '⚽',
  baseball: '⚾',
  softball: '🥎',
  basketball: '🏀',
  volleyball: '🏐',
  football: '🏈',
  rugby_football: '🏉',
  tennis: '🎾',
  flying_disc: '🥏',
  bowling: '🎳',
  cricket_game: '🏏',
  field_hockey: '🏑',
  ice_hockey: '🏒',
  lacrosse: '🥍',
  ping_pong: '🏓',
  badminton: '🏸',
  boxing_glove: '🥊',
  martial_arts_uniform: '🥋',
  goal_net: '🥅',
  golf: '⛳',
  ice_skate: '⛸️',
  fishing_pole_and_fish: '🎣',
  diving_mask: '🤿',
  running_shirt_with_sash: '🎽',
  ski: '🎿',
  sled: '🛷',
  curling_stone: '🥌',
  dart: '🎯',
  yo_yo: '🪀',
  kite: '🪁',
  gun: '🔫',
  '8ball': '🎱',
  crystal_ball: '🔮',
  magic_wand: '🪄',
  video_game: '🎮',
  joystick: '🕹️',
  slot_machine: '🎰',
  game_die: '🎲',
  jigsaw: '🧩',
  teddy_bear: '🧸',
  pinata: '🪅',
  mirror_ball: '🪩',
  nesting_dolls: '🪆',
  spades: '♠️',
  hearts: '♥️',
  diamonds: '♦️',
  clubs: '♣️',
  chess_pawn: '♟️',
  black_joker: '🃏',
  mahjong: '🀄',
  flower_playing_cards: '🎴',
  performing_arts: '🎭',
  framed_picture: '🖼️',
  art: '🎨',
  thread: '🧵',
  sewing_needle: '🪡',
  yarn: '🧶',
  knot: '🪢',
  eyeglasses: '👓',
  dark_sunglasses: '🕶️',
  goggles: '🥽',
  lab_coat: '🥼',
  safety_vest: '🦺',
  necktie: '👔',
  shirt: '👕',
  tshirt: '👕',
  jeans: '👖',
  scarf: '🧣',
  gloves: '🧤',
  coat: '🧥',
  socks: '🧦',
  dress: '👗',
  kimono: '👘',
  sari: '🥻',
  one_piece_swimsuit: '🩱',
  swim_brief: '🩲',
  shorts: '🩳',
  bikini: '👙',
  womans_clothes: '👚',
  folding_hand_fan: '🪭',
  purse: '👛',
  handbag: '👜',
  pouch: '👝',
  shopping: '🛍️',
  school_satchel: '🎒',
  thong_sandal: '🩴',
  mans_shoe: '👞',
  shoe: '👞',
  athletic_shoe: '👟',
  hiking_boot: '🥾',
  flat_shoe: '🥿',
  high_heel: '👠',
  sandal: '👡',
  ballet_shoes: '🩰',
  boot: '👢',
  hair_pick: '🪮',
  crown: '👑',
  womans_hat: '👒',
  tophat: '🎩',
  mortar_board: '🎓',
  billed_cap: '🧢',
  military_helmet: '🪖',
  rescue_worker_helmet: '⛑️',
  prayer_beads: '📿',
  lipstick: '💄',
  ring: '💍',
  gem: '💎',
  mute: '🔇',
  speaker: '🔈',
  sound: '🔉',
  loud_sound: '🔊',
  loudspeaker: '📢',
  mega: '📣',
  postal_horn: '📯',
  bell: '🔔',
  no_bell: '🔕',
  musical_score: '🎼',
  musical_note: '🎵',
  notes: '🎶',
  studio_microphone: '🎙️',
  level_slider: '🎚️',
  control_knobs: '🎛️',
  microphone: '🎤',
  headphones: '🎧',
  radio: '📻',
  saxophone: '🎷',
  accordion: '🪗',
  guitar: '🎸',
  musical_keyboard: '🎹',
  trumpet: '🎺',
  violin: '🎻',
  banjo: '🪕',
  drum: '🥁',
  long_drum: '🪘',
  maracas: '🪇',
  flute: '🪈',
  iphone: '📱',
  calling: '📲',
  phone: '☎️',
  telephone: '☎️',
  telephone_receiver: '📞',
  pager: '📟',
  fax: '📠',
  battery: '🔋',
  low_battery: '🪫',
  electric_plug: '🔌',
  computer: '💻',
  desktop_computer: '🖥️',
  printer: '🖨️',
  keyboard: '⌨️',
  computer_mouse: '🖱️',
  trackball: '🖲️',
  minidisc: '💽',
  floppy_disk: '💾',
  cd: '💿',
  dvd: '📀',
  abacus: '🧮',
  movie_camera: '🎥',
  film_strip: '🎞️',
  film_projector: '📽️',
  clapper: '🎬',
  tv: '📺',
  camera: '📷',
  camera_flash: '📸',
  video_camera: '📹',
  vhs: '📼',
  mag: '🔍',
  mag_right: '🔎',
  candle: '🕯️',
  bulb: '💡',
  flashlight: '🔦',
  izakaya_lantern: '🏮',
  lantern: '🏮',
  diya_lamp: '🪔',
  notebook_with_decorative_cover: '📔',
  closed_book: '📕',
  book: '📖',
  open_book: '📖',
  green_book: '📗',
  blue_book: '📘',
  orange_book: '📙',
  books: '📚',
  notebook: '📓',
  ledger: '📒',
  page_with_curl: '📃',
  scroll: '📜',
  page_facing_up: '📄',
  newspaper: '📰',
  newspaper_roll: '🗞️',
  bookmark_tabs: '📑',
  bookmark: '🔖',
  label: '🏷️',
  moneybag: '💰',
  coin: '🪙',
  yen: '💴',
  dollar: '💵',
  euro: '💶',
  pound: '💷',
  money_with_wings: '💸',
  credit_card: '💳',
  receipt: '🧾',
  chart: '💹',
  envelope: '✉️',
  email: '📧',
  'e-mail': '📧',
  incoming_envelope: '📨',
  envelope_with_arrow: '📩',
  outbox_tray: '📤',
  inbox_tray: '📥',
  package: '📦',
  mailbox: '📫',
  mailbox_closed: '📪',
  mailbox_with_mail: '📬',
  mailbox_with_no_mail: '📭',
  postbox: '📮',
  ballot_box: '🗳️',
  pencil2: '✏️',
  black_nib: '✒️',
  fountain_pen: '🖋️',
  pen: '🖊️',
  paintbrush: '🖌️',
  crayon: '🖍️',
  memo: '📝',
  pencil: '📝',
  briefcase: '💼',
  file_folder: '📁',
  open_file_folder: '📂',
  card_index_dividers: '🗂️',
  date: '📅',
  calendar: '📆',
  spiral_notepad: '🗒️',
  spiral_calendar: '🗓️',
  card_index: '📇',
  chart_with_upwards_trend: '📈',
  chart_with_downwards_trend: '📉',
  bar_chart: '📊',
  clipboard: '📋',
  pushpin: '📌',
  round_pushpin: '📍',
  paperclip: '📎',
  paperclips: '🖇️',
  straight_ruler: '📏',
  triangular_ruler: '📐',
  scissors: '✂️',
  card_file_box: '🗃️',
  file_cabinet: '🗄️',
  wastebasket: '🗑️',
  lock: '🔒',
  unlock: '🔓',
  lock_with_ink_pen: '🔏',
  closed_lock_with_key: '🔐',
  key: '🔑',
  old_key: '🗝️',
  hammer: '🔨',
  axe: '🪓',
  pick: '⛏️',
  hammer_and_pick: '⚒️',
  hammer_and_wrench: '🛠️',
  dagger: '🗡️',
  crossed_swords: '⚔️',
  bomb: '💣',
  boomerang: '🪃',
  bow_and_arrow: '🏹',
  shield: '🛡️',
  carpentry_saw: '🪚',
  wrench: '🔧',
  screwdriver: '🪛',
  nut_and_bolt: '🔩',
  gear: '⚙️',
  clamp: '🗜️',
  balance_scale: '⚖️',
  probing_cane: '🦯',
  link: '🔗',
  chains: '⛓️',
  hook: '🪝',
  toolbox: '🧰',
  magnet: '🧲',
  ladder: '🪜',
  alembic: '⚗️',
  test_tube: '🧪',
  petri_dish: '🧫',
  dna: '🧬',
  microscope: '🔬',
  telescope: '🔭',
  satellite: '📡',
  syringe: '💉',
  drop_of_blood: '🩸',
  pill: '💊',
  adhesive_bandage: '🩹',
  crutch: '🩼',
  stethoscope: '🩺',
  x_ray: '🩻',
  door: '🚪',
  elevator: '🛗',
  mirror: '🪞',
  window: '🪟',
  bed: '🛏️',
  couch_and_lamp: '🛋️',
  chair: '🪑',
  toilet: '🚽',
  plunger: '🪠',
  shower: '🚿',
  bathtub: '🛁',
  mouse_trap: '🪤',
  razor: '🪒',
  lotion_bottle: '🧴',
  safety_pin: '🧷',
  broom: '🧹',
  basket: '🧺',
  roll_of_paper: '🧻',
  bucket: '🪣',
  soap: '🧼',
  bubbles: '🫧',
  toothbrush: '🪥',
  sponge: '🧽',
  fire_extinguisher: '🧯',
  shopping_cart: '🛒',
  smoking: '🚬',
  coffin: '⚰️',
  headstone: '🪦',
  funeral_urn: '⚱️',
  nazar_amulet: '🧿',
  hamsa: '🪬',
  moyai: '🗿',
  placard: '🪧',
  identification_card: '🪪',
  atm: '🏧',
  put_litter_in_its_place: '🚮',
  potable_water: '🚰',
  wheelchair: '♿',
  mens: '🚹',
  womens: '🚺',
  restroom: '🚻',
  baby_symbol: '🚼',
  wc: '🚾',
  passport_control: '🛂',
  customs: '🛃',
  baggage_claim: '🛄',
  left_luggage: '🛅',
  warning: '⚠️',
  children_crossing: '🚸',
  no_entry: '⛔',
  no_entry_sign: '🚫',
  no_bicycles: '🚳',
  no_smoking: '🚭',
  do_not_litter: '🚯',
  'non-potable_water': '🚱',
  no_pedestrians: '🚷',
  no_mobile_phones: '📵',
  underage: '🔞',
  radioactive: '☢️',
  biohazard: '☣️',
  arrow_up: '⬆️',
  arrow_upper_right: '↗️',
  arrow_right: '➡️',
  arrow_lower_right: '↘️',
  arrow_down: '⬇️',
  arrow_lower_left: '↙️',
  arrow_left: '⬅️',
  arrow_upper_left: '↖️',
  arrow_up_down: '↕️',
  left_right_arrow: '↔️',
  leftwards_arrow_with_hook: '↩️',
  arrow_right_hook: '↪️',
  arrow_heading_up: '⤴️',
  arrow_heading_down: '⤵️',
  arrows_clockwise: '🔃',
  arrows_counterclockwise: '🔄',
  back: '🔙',
  end: '🔚',
  on: '🔛',
  soon: '🔜',
  top: '🔝',
  place_of_worship: '🛐',
  atom_symbol: '⚛️',
  om: '🕉️',
  star_of_david: '✡️',
  wheel_of_dharma: '☸️',
  yin_yang: '☯️',
  latin_cross: '✝️',
  orthodox_cross: '☦️',
  star_and_crescent: '☪️',
  peace_symbol: '☮️',
  menorah: '🕎',
  six_pointed_star: '🔯',
  khanda: '🪯',
  aries: '♈',
  taurus: '♉',
  gemini: '♊',
  cancer: '♋',
  leo: '♌',
  virgo: '♍',
  libra: '♎',
  scorpius: '♏',
  sagittarius: '♐',
  capricorn: '♑',
  aquarius: '♒',
  pisces: '♓',
  ophiuchus: '⛎',
  twisted_rightwards_arrows: '🔀',
  repeat: '🔁',
  repeat_one: '🔂',
  arrow_forward: '▶️',
  fast_forward: '⏩',
  next_track_button: '⏭️',
  play_or_pause_button: '⏯️',
  arrow_backward: '◀️',
  rewind: '⏪',
  previous_track_button: '⏮️',
  arrow_up_small: '🔼',
  arrow_double_up: '⏫',
  arrow_down_small: '🔽',
  arrow_double_down: '⏬',
  pause_button: '⏸️',
  stop_button: '⏹️',
  record_button: '⏺️',
  eject_button: '⏏️',
  cinema: '🎦',
  low_brightness: '🔅',
  high_brightness: '🔆',
  signal_strength: '📶',
  wireless: '🛜',
  vibration_mode: '📳',
  mobile_phone_off: '📴',
  female_sign: '♀️',
  male_sign: '♂️',
  transgender_symbol: '⚧️',
  heavy_multiplication_x: '✖️',
  heavy_plus_sign: '➕',
  heavy_minus_sign: '➖',
  heavy_division_sign: '➗',
  heavy_equals_sign: '🟰',
  infinity: '♾️',
  bangbang: '‼️',
  interrobang: '⁉️',
  question: '❓',
  grey_question: '❔',
  grey_exclamation: '❕',
  exclamation: '❗',
  heavy_exclamation_mark: '❗',
  wavy_dash: '〰️',
  currency_exchange: '💱',
  heavy_dollar_sign: '💲',
  medical_symbol: '⚕️',
  recycle: '♻️',
  fleur_de_lis: '⚜️',
  trident: '🔱',
  name_badge: '📛',
  beginner: '🔰',
  o: '⭕',
  white_check_mark: '✅',
  ballot_box_with_check: '☑️',
  heavy_check_mark: '✔️',
  x: '❌',
  negative_squared_cross_mark: '❎',
  curly_loop: '➰',
  loop: '➿',
  part_alternation_mark: '〽️',
  eight_spoked_asterisk: '✳️',
  eight_pointed_black_star: '✴️',
  sparkle: '❇️',
  copyright: '©️',
  registered: '®️',
  tm: '™️',
  hash: '#️⃣',
  asterisk: '*️⃣',
  zero: '0️⃣',
  one: '1️⃣',
  two: '2️⃣',
  three: '3️⃣',
  four: '4️⃣',
  five: '5️⃣',
  six: '6️⃣',
  seven: '7️⃣',
  eight: '8️⃣',
  nine: '9️⃣',
  keycap_ten: '🔟',
  capital_abcd: '🔠',
  abcd: '🔡',
  symbols: '🔣',
  abc: '🔤',
  a: '🅰️',
  ab: '🆎',
  b: '🅱️',
  cl: '🆑',
  cool: '🆒',
  free: '🆓',
  information_source: 'ℹ️',
  id: '🆔',
  m: 'Ⓜ️',
  new: '🆕',
  ng: '🆖',
  o2: '🅾️',
  ok: '🆗',
  parking: '🅿️',
  sos: '🆘',
  up: '🆙',
  vs: '🆚',
  koko: '🈁',
  sa: '🈂️',
  u6708: '🈷️',
  u6709: '🈶',
  u6307: '🈯',
  ideograph_advantage: '🉐',
  u5272: '🈹',
  u7121: '🈚',
  u7981: '🈲',
  accept: '🉑',
  u7533: '🈸',
  u5408: '🈴',
  u7a7a: '🈳',
  congratulations: '㊗️',
  secret: '㊙️',
  u55b6: '🈺',
  u6e80: '🈵',
  red_circle: '🔴',
  orange_circle: '🟠',
  yellow_circle: '🟡',
  green_circle: '🟢',
  large_blue_circle: '🔵',
  purple_circle: '🟣',
  brown_circle: '🟤',
  black_circle: '⚫',
  white_circle: '⚪',
  red_square: '🟥',
  orange_square: '🟧',
  yellow_square: '🟨',
  green_square: '🟩',
  blue_square: '🟦',
  purple_square: '🟪',
  brown_square: '🟫',
  black_large_square: '⬛',
  white_large_square: '⬜',
  black_medium_square: '◼️',
  white_medium_square: '◻️',
  black_medium_small_square: '◾',
  white_medium_small_square: '◽',
  black_small_square: '▪️',
  white_small_square: '▫️',
  large_orange_diamond: '🔶',
  large_blue_diamond: '🔷',
  small_orange_diamond: '🔸',
  small_blue_diamond: '🔹',
  small_red_triangle: '🔺',
  small_red_triangle_down: '🔻',
  diamond_shape_with_a_dot_inside: '💠',
  radio_button: '🔘',
  white_square_button: '🔳',
  black_square_button: '🔲',
  checkered_flag: '🏁',
  triangular_flag_on_post: '🚩',
  crossed_flags: '🎌',
  black_flag: '🏴',
  white_flag: '🏳️',
  rainbow_flag: '🏳️‍🌈',
  transgender_flag: '🏳️‍⚧️',
  pirate_flag: '🏴‍☠️',
  ascension_island: '🇦🇨',
  andorra: '🇦🇩',
  united_arab_emirates: '🇦🇪',
  afghanistan: '🇦🇫',
  antigua_barbuda: '🇦🇬',
  anguilla: '🇦🇮',
  albania: '🇦🇱',
  armenia: '🇦🇲',
  angola: '🇦🇴',
  antarctica: '🇦🇶',
  argentina: '🇦🇷',
  american_samoa: '🇦🇸',
  austria: '🇦🇹',
  australia: '🇦🇺',
  aruba: '🇦🇼',
  aland_islands: '🇦🇽',
  azerbaijan: '🇦🇿',
  bosnia_herzegovina: '🇧🇦',
  barbados: '🇧🇧',
  bangladesh: '🇧🇩',
  belgium: '🇧🇪',
  burkina_faso: '🇧🇫',
  bulgaria: '🇧🇬',
  bahrain: '🇧🇭',
  burundi: '🇧🇮',
  benin: '🇧🇯',
  st_barthelemy: '🇧🇱',
  bermuda: '🇧🇲',
  brunei: '🇧🇳',
  bolivia: '🇧🇴',
  caribbean_netherlands: '🇧🇶',
  brazil: '🇧🇷',
  bahamas: '🇧🇸',
  bhutan: '🇧🇹',
  bouvet_island: '🇧🇻',
  botswana: '🇧🇼',
  belarus: '🇧🇾',
  belize: '🇧🇿',
  canada: '🇨🇦',
  cocos_islands: '🇨🇨',
  congo_kinshasa: '🇨🇩',
  central_african_republic: '🇨🇫',
  congo_brazzaville: '🇨🇬',
  switzerland: '🇨🇭',
  cote_divoire: '🇨🇮',
  cook_islands: '🇨🇰',
  chile: '🇨🇱',
  cameroon: '🇨🇲',
  cn: '🇨🇳',
  colombia: '🇨🇴',
  clipperton_island: '🇨🇵',
  costa_rica: '🇨🇷',
  cuba: '🇨🇺',
  cape_verde: '🇨🇻',
  curacao: '🇨🇼',
  christmas_island: '🇨🇽',
  cyprus: '🇨🇾',
  czech_republic: '🇨🇿',
  de: '🇩🇪',
  diego_garcia: '🇩🇬',
  djibouti: '🇩🇯',
  denmark: '🇩🇰',
  dominica: '🇩🇲',
  dominican_republic: '🇩🇴',
  algeria: '🇩🇿',
  ceuta_melilla: '🇪🇦',
  ecuador: '🇪🇨',
  estonia: '🇪🇪',
  egypt: '🇪🇬',
  western_sahara: '🇪🇭',
  eritrea: '🇪🇷',
  es: '🇪🇸',
  ethiopia: '🇪🇹',
  eu: '🇪🇺',
  european_union: '🇪🇺',
  finland: '🇫🇮',
  fiji: '🇫🇯',
  falkland_islands: '🇫🇰',
  micronesia: '🇫🇲',
  faroe_islands: '🇫🇴',
  fr: '🇫🇷',
  gabon: '🇬🇦',
  gb: '🇬🇧',
  uk: '🇬🇧',
  grenada: '🇬🇩',
  georgia: '🇬🇪',
  french_guiana: '🇬🇫',
  guernsey: '🇬🇬',
  ghana: '🇬🇭',
  gibraltar: '🇬🇮',
  greenland: '🇬🇱',
  gambia: '🇬🇲',
  guinea: '🇬🇳',
  guadeloupe: '🇬🇵',
  equatorial_guinea: '🇬🇶',
  greece: '🇬🇷',
  south_georgia_south_sandwich_islands: '🇬🇸',
  guatemala: '🇬🇹',
  guam: '🇬🇺',
  guinea_bissau: '🇬🇼',
  guyana: '🇬🇾',
  hong_kong: '🇭🇰',
  heard_mcdonald_islands: '🇭🇲',
  honduras: '🇭🇳',
  croatia: '🇭🇷',
  haiti: '🇭🇹',
  hungary: '🇭🇺',
  canary_islands: '🇮🇨',
  indonesia: '🇮🇩',
  ireland: '🇮🇪',
  israel: '🇮🇱',
  isle_of_man: '🇮🇲',
  india: '🇮🇳',
  british_indian_ocean_territory: '🇮🇴',
  iraq: '🇮🇶',
  iran: '🇮🇷',
  iceland: '🇮🇸',
  it: '🇮🇹',
  jersey: '🇯🇪',
  jamaica: '🇯🇲',
  jordan: '🇯🇴',
  jp: '🇯🇵',
  kenya: '🇰🇪',
  kyrgyzstan: '🇰🇬',
  cambodia: '🇰🇭',
  kiribati: '🇰🇮',
  comoros: '🇰🇲',
  st_kitts_nevis: '🇰🇳',
  north_korea: '🇰🇵',
  kr: '🇰🇷',
  kuwait: '🇰🇼',
  cayman_islands: '🇰🇾',
  kazakhstan: '🇰🇿',
  laos: '🇱🇦',
  lebanon: '🇱🇧',
  st_lucia: '🇱🇨',
  liechtenstein: '🇱🇮',
  sri_lanka: '🇱🇰',
  liberia: '🇱🇷',
  lesotho: '🇱🇸',
  lithuania: '🇱🇹',
  luxembourg: '🇱🇺',
  latvia: '🇱🇻',
  libya: '🇱🇾',
  morocco: '🇲🇦',
  monaco: '🇲🇨',
  moldova: '🇲🇩',
  montenegro: '🇲🇪',
  st_martin: '🇲🇫',
  madagascar: '🇲🇬',
  marshall_islands: '🇲🇭',
  macedonia: '🇲🇰',
  mali: '🇲🇱',
  myanmar: '🇲🇲',
  mongolia: '🇲🇳',
  macau: '🇲🇴',
  northern_mariana_islands: '🇲🇵',
  martinique: '🇲🇶',
  mauritania: '🇲🇷',
  montserrat: '🇲🇸',
  malta: '🇲🇹',
  mauritius: '🇲🇺',
  maldives: '🇲🇻',
  malawi: '🇲🇼',
  mexico: '🇲🇽',
  malaysia: '🇲🇾',
  mozambique: '🇲🇿',
  namibia: '🇳🇦',
  new_caledonia: '🇳🇨',
  niger: '🇳🇪',
  norfolk_island: '🇳🇫',
  nigeria: '🇳🇬',
  nicaragua: '🇳🇮',
  netherlands: '🇳🇱',
  norway: '🇳🇴',
  nepal: '🇳🇵',
  nauru: '🇳🇷',
  niue: '🇳🇺',
  new_zealand: '🇳🇿',
  oman: '🇴🇲',
  panama: '🇵🇦',
  peru: '🇵🇪',
  french_polynesia: '🇵🇫',
  papua_new_guinea: '🇵🇬',
  philippines: '🇵🇭',
  pakistan: '🇵🇰',
  poland: '🇵🇱',
  st_pierre_miquelon: '🇵🇲',
  pitcairn_islands: '🇵🇳',
  puerto_rico: '🇵🇷',
  palestinian_territories: '🇵🇸',
  portugal: '🇵🇹',
  palau: '🇵🇼',
  paraguay: '🇵🇾',
  qatar: '🇶🇦',
  reunion: '🇷🇪',
  romania: '🇷🇴',
  serbia: '🇷🇸',
  ru: '🇷🇺',
  rwanda: '🇷🇼',
  saudi_arabia: '🇸🇦',
  solomon_islands: '🇸🇧',
  seychelles: '🇸🇨',
  sudan: '🇸🇩',
  sweden: '🇸🇪',
  singapore: '🇸🇬',
  st_helena: '🇸🇭',
  slovenia: '🇸🇮',
  svalbard_jan_mayen: '🇸🇯',
  slovakia: '🇸🇰',
  sierra_leone: '🇸🇱',
  san_marino: '🇸🇲',
  senegal: '🇸🇳',
  somalia: '🇸🇴',
  suriname: '🇸🇷',
  south_sudan: '🇸🇸',
  sao_tome_principe: '🇸🇹',
  el_salvador: '🇸🇻',
  sint_maarten: '🇸🇽',
  syria: '🇸🇾',
  swaziland: '🇸🇿',
  tristan_da_cunha: '🇹🇦',
  turks_caicos_islands: '🇹🇨',
  chad: '🇹🇩',
  french_southern_territories: '🇹🇫',
  togo: '🇹🇬',
  thailand: '🇹🇭',
  tajikistan: '🇹🇯',
  tokelau: '🇹🇰',
  timor_leste: '🇹🇱',
  turkmenistan: '🇹🇲',
  tunisia: '🇹🇳',
  tonga: '🇹🇴',
  tr: '🇹🇷',
  trinidad_tobago: '🇹🇹',
  tuvalu: '🇹🇻',
  taiwan: '🇹🇼',
  tanzania: '🇹🇿',
  ukraine: '🇺🇦',
  uganda: '🇺🇬',
  us_outlying_islands: '🇺🇲',
  united_nations: '🇺🇳',
  us: '🇺🇸',
  uruguay: '🇺🇾',
  uzbekistan: '🇺🇿',
  vatican_city: '🇻🇦',
  st_vincent_grenadines: '🇻🇨',
  venezuela: '🇻🇪',
  british_virgin_islands: '🇻🇬',
  us_virgin_islands: '🇻🇮',
  vietnam: '🇻🇳',
  vanuatu: '🇻🇺',
  wallis_futuna: '🇼🇫',
  samoa: '🇼🇸',
  kosovo: '🇽🇰',
  yemen: '🇾🇪',
  mayotte: '🇾🇹',
  south_africa: '🇿🇦',
  zambia: '🇿🇲',
  zimbabwe: '🇿🇼',
  england: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  scotland: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  wales: '🏴󠁧󠁢󠁷󠁬󠁳󠁿'
}

/**
 * Map of emoji to primary name.
 *
 * @type {Record<string, string>}
 */
export const emojiToName = {
  '😀': 'grinning',
  '😃': 'smiley',
  '😄': 'smile',
  '😁': 'grin',
  '😆': 'laughing',
  '😅': 'sweat_smile',
  '🤣': 'rofl',
  '😂': 'joy',
  '🙂': 'slightly_smiling_face',
  '🙃': 'upside_down_face',
  '🫠': 'melting_face',
  '😉': 'wink',
  '😊': 'blush',
  '😇': 'innocent',
  '🥰': 'smiling_face_with_three_hearts',
  '😍': 'heart_eyes',
  '🤩': 'star_struck',
  '😘': 'kissing_heart',
  '😗': 'kissing',
  '☺️': 'relaxed',
  '😚': 'kissing_closed_eyes',
  '😙': 'kissing_smiling_eyes',
  '🥲': 'smiling_face_with_tear',
  '😋': 'yum',
  '😛': 'stuck_out_tongue',
  '😜': 'stuck_out_tongue_winking_eye',
  '🤪': 'zany_face',
  '😝': 'stuck_out_tongue_closed_eyes',
  '🤑': 'money_mouth_face',
  '🤗': 'hugs',
  '🤭': 'hand_over_mouth',
  '🫢': 'face_with_open_eyes_and_hand_over_mouth',
  '🫣': 'face_with_peeking_eye',
  '🤫': 'shushing_face',
  '🤔': 'thinking',
  '🫡': 'saluting_face',
  '🤐': 'zipper_mouth_face',
  '🤨': 'raised_eyebrow',
  '😐': 'neutral_face',
  '😑': 'expressionless',
  '😶': 'no_mouth',
  '🫥': 'dotted_line_face',
  '😶‍🌫️': 'face_in_clouds',
  '😏': 'smirk',
  '😒': 'unamused',
  '🙄': 'roll_eyes',
  '😬': 'grimacing',
  '😮‍💨': 'face_exhaling',
  '🤥': 'lying_face',
  '🫨': 'shaking_face',
  '😌': 'relieved',
  '😔': 'pensive',
  '😪': 'sleepy',
  '🤤': 'drooling_face',
  '😴': 'sleeping',
  '😷': 'mask',
  '🤒': 'face_with_thermometer',
  '🤕': 'face_with_head_bandage',
  '🤢': 'nauseated_face',
  '🤮': 'vomiting_face',
  '🤧': 'sneezing_face',
  '🥵': 'hot_face',
  '🥶': 'cold_face',
  '🥴': 'woozy_face',
  '😵': 'dizzy_face',
  '😵‍💫': 'face_with_spiral_eyes',
  '🤯': 'exploding_head',
  '🤠': 'cowboy_hat_face',
  '🥳': 'partying_face',
  '🥸': 'disguised_face',
  '😎': 'sunglasses',
  '🤓': 'nerd_face',
  '🧐': 'monocle_face',
  '😕': 'confused',
  '🫤': 'face_with_diagonal_mouth',
  '😟': 'worried',
  '🙁': 'slightly_frowning_face',
  '☹️': 'frowning_face',
  '😮': 'open_mouth',
  '😯': 'hushed',
  '😲': 'astonished',
  '😳': 'flushed',
  '🥺': 'pleading_face',
  '🥹': 'face_holding_back_tears',
  '😦': 'frowning',
  '😧': 'anguished',
  '😨': 'fearful',
  '😰': 'cold_sweat',
  '😥': 'disappointed_relieved',
  '😢': 'cry',
  '😭': 'sob',
  '😱': 'scream',
  '😖': 'confounded',
  '😣': 'persevere',
  '😞': 'disappointed',
  '😓': 'sweat',
  '😩': 'weary',
  '😫': 'tired_face',
  '🥱': 'yawning_face',
  '😤': 'triumph',
  '😡': 'rage',
  '😠': 'angry',
  '🤬': 'cursing_face',
  '😈': 'smiling_imp',
  '👿': 'imp',
  '💀': 'skull',
  '☠️': 'skull_and_crossbones',
  '💩': 'hankey',
  '🤡': 'clown_face',
  '👹': 'japanese_ogre',
  '👺': 'japanese_goblin',
  '👻': 'ghost',
  '👽': 'alien',
  '👾': 'space_invader',
  '🤖': 'robot',
  '😺': 'smiley_cat',
  '😸': 'smile_cat',
  '😹': 'joy_cat',
  '😻': 'heart_eyes_cat',
  '😼': 'smirk_cat',
  '😽': 'kissing_cat',
  '🙀': 'scream_cat',
  '😿': 'crying_cat_face',
  '😾': 'pouting_cat',
  '🙈': 'see_no_evil',
  '🙉': 'hear_no_evil',
  '🙊': 'speak_no_evil',
  '💌': 'love_letter',
  '💘': 'cupid',
  '💝': 'gift_heart',
  '💖': 'sparkling_heart',
  '💗': 'heartpulse',
  '💓': 'heartbeat',
  '💞': 'revolving_hearts',
  '💕': 'two_hearts',
  '💟': 'heart_decoration',
  '❣️': 'heavy_heart_exclamation',
  '💔': 'broken_heart',
  '❤️‍🔥': 'heart_on_fire',
  '❤️‍🩹': 'mending_heart',
  '❤️': 'heart',
  '🩷': 'pink_heart',
  '🧡': 'orange_heart',
  '💛': 'yellow_heart',
  '💚': 'green_heart',
  '💙': 'blue_heart',
  '🩵': 'light_blue_heart',
  '💜': 'purple_heart',
  '🤎': 'brown_heart',
  '🖤': 'black_heart',
  '🩶': 'grey_heart',
  '🤍': 'white_heart',
  '💋': 'kiss',
  '💯': '100',
  '💢': 'anger',
  '💥': 'boom',
  '💫': 'dizzy',
  '💦': 'sweat_drops',
  '💨': 'dash',
  '🕳️': 'hole',
  '💬': 'speech_balloon',
  '👁️‍🗨️': 'eye_speech_bubble',
  '🗨️': 'left_speech_bubble',
  '🗯️': 'right_anger_bubble',
  '💭': 'thought_balloon',
  '💤': 'zzz',
  '👋': 'wave',
  '🤚': 'raised_back_of_hand',
  '🖐️': 'raised_hand_with_fingers_splayed',
  '✋': 'hand',
  '🖖': 'vulcan_salute',
  '🫱': 'rightwards_hand',
  '🫲': 'leftwards_hand',
  '🫳': 'palm_down_hand',
  '🫴': 'palm_up_hand',
  '🫷': 'leftwards_pushing_hand',
  '🫸': 'rightwards_pushing_hand',
  '👌': 'ok_hand',
  '🤌': 'pinched_fingers',
  '🤏': 'pinching_hand',
  '✌️': 'v',
  '🤞': 'crossed_fingers',
  '🫰': 'hand_with_index_finger_and_thumb_crossed',
  '🤟': 'love_you_gesture',
  '🤘': 'metal',
  '🤙': 'call_me_hand',
  '👈': 'point_left',
  '👉': 'point_right',
  '👆': 'point_up_2',
  '🖕': 'middle_finger',
  '👇': 'point_down',
  '☝️': 'point_up',
  '🫵': 'index_pointing_at_the_viewer',
  '👍': '+1',
  '👎': '-1',
  '✊': 'fist_raised',
  '👊': 'fist_oncoming',
  '🤛': 'fist_left',
  '🤜': 'fist_right',
  '👏': 'clap',
  '🙌': 'raised_hands',
  '🫶': 'heart_hands',
  '👐': 'open_hands',
  '🤲': 'palms_up_together',
  '🤝': 'handshake',
  '🙏': 'pray',
  '✍️': 'writing_hand',
  '💅': 'nail_care',
  '🤳': 'selfie',
  '💪': 'muscle',
  '🦾': 'mechanical_arm',
  '🦿': 'mechanical_leg',
  '🦵': 'leg',
  '🦶': 'foot',
  '👂': 'ear',
  '🦻': 'ear_with_hearing_aid',
  '👃': 'nose',
  '🧠': 'brain',
  '🫀': 'anatomical_heart',
  '🫁': 'lungs',
  '🦷': 'tooth',
  '🦴': 'bone',
  '👀': 'eyes',
  '👁️': 'eye',
  '👅': 'tongue',
  '👄': 'lips',
  '🫦': 'biting_lip',
  '👶': 'baby',
  '🧒': 'child',
  '👦': 'boy',
  '👧': 'girl',
  '🧑': 'adult',
  '👱': 'blond_haired_person',
  '👨': 'man',
  '🧔': 'bearded_person',
  '🧔‍♂️': 'man_beard',
  '🧔‍♀️': 'woman_beard',
  '👨‍🦰': 'red_haired_man',
  '👨‍🦱': 'curly_haired_man',
  '👨‍🦳': 'white_haired_man',
  '👨‍🦲': 'bald_man',
  '👩': 'woman',
  '👩‍🦰': 'red_haired_woman',
  '🧑‍🦰': 'person_red_hair',
  '👩‍🦱': 'curly_haired_woman',
  '🧑‍🦱': 'person_curly_hair',
  '👩‍🦳': 'white_haired_woman',
  '🧑‍🦳': 'person_white_hair',
  '👩‍🦲': 'bald_woman',
  '🧑‍🦲': 'person_bald',
  '👱‍♀️': 'blond_haired_woman',
  '👱‍♂️': 'blond_haired_man',
  '🧓': 'older_adult',
  '👴': 'older_man',
  '👵': 'older_woman',
  '🙍': 'frowning_person',
  '🙍‍♂️': 'frowning_man',
  '🙍‍♀️': 'frowning_woman',
  '🙎': 'pouting_face',
  '🙎‍♂️': 'pouting_man',
  '🙎‍♀️': 'pouting_woman',
  '🙅': 'no_good',
  '🙅‍♂️': 'no_good_man',
  '🙅‍♀️': 'no_good_woman',
  '🙆': 'ok_person',
  '🙆‍♂️': 'ok_man',
  '🙆‍♀️': 'ok_woman',
  '💁': 'tipping_hand_person',
  '💁‍♂️': 'tipping_hand_man',
  '💁‍♀️': 'tipping_hand_woman',
  '🙋': 'raising_hand',
  '🙋‍♂️': 'raising_hand_man',
  '🙋‍♀️': 'raising_hand_woman',
  '🧏': 'deaf_person',
  '🧏‍♂️': 'deaf_man',
  '🧏‍♀️': 'deaf_woman',
  '🙇': 'bow',
  '🙇‍♂️': 'bowing_man',
  '🙇‍♀️': 'bowing_woman',
  '🤦': 'facepalm',
  '🤦‍♂️': 'man_facepalming',
  '🤦‍♀️': 'woman_facepalming',
  '🤷': 'shrug',
  '🤷‍♂️': 'man_shrugging',
  '🤷‍♀️': 'woman_shrugging',
  '🧑‍⚕️': 'health_worker',
  '👨‍⚕️': 'man_health_worker',
  '👩‍⚕️': 'woman_health_worker',
  '🧑‍🎓': 'student',
  '👨‍🎓': 'man_student',
  '👩‍🎓': 'woman_student',
  '🧑‍🏫': 'teacher',
  '👨‍🏫': 'man_teacher',
  '👩‍🏫': 'woman_teacher',
  '🧑‍⚖️': 'judge',
  '👨‍⚖️': 'man_judge',
  '👩‍⚖️': 'woman_judge',
  '🧑‍🌾': 'farmer',
  '👨‍🌾': 'man_farmer',
  '👩‍🌾': 'woman_farmer',
  '🧑‍🍳': 'cook',
  '👨‍🍳': 'man_cook',
  '👩‍🍳': 'woman_cook',
  '🧑‍🔧': 'mechanic',
  '👨‍🔧': 'man_mechanic',
  '👩‍🔧': 'woman_mechanic',
  '🧑‍🏭': 'factory_worker',
  '👨‍🏭': 'man_factory_worker',
  '👩‍🏭': 'woman_factory_worker',
  '🧑‍💼': 'office_worker',
  '👨‍💼': 'man_office_worker',
  '👩‍💼': 'woman_office_worker',
  '🧑‍🔬': 'scientist',
  '👨‍🔬': 'man_scientist',
  '👩‍🔬': 'woman_scientist',
  '🧑‍💻': 'technologist',
  '👨‍💻': 'man_technologist',
  '👩‍💻': 'woman_technologist',
  '🧑‍🎤': 'singer',
  '👨‍🎤': 'man_singer',
  '👩‍🎤': 'woman_singer',
  '🧑‍🎨': 'artist',
  '👨‍🎨': 'man_artist',
  '👩‍🎨': 'woman_artist',
  '🧑‍✈️': 'pilot',
  '👨‍✈️': 'man_pilot',
  '👩‍✈️': 'woman_pilot',
  '🧑‍🚀': 'astronaut',
  '👨‍🚀': 'man_astronaut',
  '👩‍🚀': 'woman_astronaut',
  '🧑‍🚒': 'firefighter',
  '👨‍🚒': 'man_firefighter',
  '👩‍🚒': 'woman_firefighter',
  '👮': 'police_officer',
  '👮‍♂️': 'policeman',
  '👮‍♀️': 'policewoman',
  '🕵️': 'detective',
  '🕵️‍♂️': 'male_detective',
  '🕵️‍♀️': 'female_detective',
  '💂': 'guard',
  '💂‍♂️': 'guardsman',
  '💂‍♀️': 'guardswoman',
  '🥷': 'ninja',
  '👷': 'construction_worker',
  '👷‍♂️': 'construction_worker_man',
  '👷‍♀️': 'construction_worker_woman',
  '🫅': 'person_with_crown',
  '🤴': 'prince',
  '👸': 'princess',
  '👳': 'person_with_turban',
  '👳‍♂️': 'man_with_turban',
  '👳‍♀️': 'woman_with_turban',
  '👲': 'man_with_gua_pi_mao',
  '🧕': 'woman_with_headscarf',
  '🤵': 'person_in_tuxedo',
  '🤵‍♂️': 'man_in_tuxedo',
  '🤵‍♀️': 'woman_in_tuxedo',
  '👰': 'person_with_veil',
  '👰‍♂️': 'man_with_veil',
  '👰‍♀️': 'woman_with_veil',
  '🤰': 'pregnant_woman',
  '🫃': 'pregnant_man',
  '🫄': 'pregnant_person',
  '🤱': 'breast_feeding',
  '👩‍🍼': 'woman_feeding_baby',
  '👨‍🍼': 'man_feeding_baby',
  '🧑‍🍼': 'person_feeding_baby',
  '👼': 'angel',
  '🎅': 'santa',
  '🤶': 'mrs_claus',
  '🧑‍🎄': 'mx_claus',
  '🦸': 'superhero',
  '🦸‍♂️': 'superhero_man',
  '🦸‍♀️': 'superhero_woman',
  '🦹': 'supervillain',
  '🦹‍♂️': 'supervillain_man',
  '🦹‍♀️': 'supervillain_woman',
  '🧙': 'mage',
  '🧙‍♂️': 'mage_man',
  '🧙‍♀️': 'mage_woman',
  '🧚': 'fairy',
  '🧚‍♂️': 'fairy_man',
  '🧚‍♀️': 'fairy_woman',
  '🧛': 'vampire',
  '🧛‍♂️': 'vampire_man',
  '🧛‍♀️': 'vampire_woman',
  '🧜': 'merperson',
  '🧜‍♂️': 'merman',
  '🧜‍♀️': 'mermaid',
  '🧝': 'elf',
  '🧝‍♂️': 'elf_man',
  '🧝‍♀️': 'elf_woman',
  '🧞': 'genie',
  '🧞‍♂️': 'genie_man',
  '🧞‍♀️': 'genie_woman',
  '🧟': 'zombie',
  '🧟‍♂️': 'zombie_man',
  '🧟‍♀️': 'zombie_woman',
  '🧌': 'troll',
  '💆': 'massage',
  '💆‍♂️': 'massage_man',
  '💆‍♀️': 'massage_woman',
  '💇': 'haircut',
  '💇‍♂️': 'haircut_man',
  '💇‍♀️': 'haircut_woman',
  '🚶': 'walking',
  '🚶‍♂️': 'walking_man',
  '🚶‍♀️': 'walking_woman',
  '🧍': 'standing_person',
  '🧍‍♂️': 'standing_man',
  '🧍‍♀️': 'standing_woman',
  '🧎': 'kneeling_person',
  '🧎‍♂️': 'kneeling_man',
  '🧎‍♀️': 'kneeling_woman',
  '🧑‍🦯': 'person_with_probing_cane',
  '👨‍🦯': 'man_with_probing_cane',
  '👩‍🦯': 'woman_with_probing_cane',
  '🧑‍🦼': 'person_in_motorized_wheelchair',
  '👨‍🦼': 'man_in_motorized_wheelchair',
  '👩‍🦼': 'woman_in_motorized_wheelchair',
  '🧑‍🦽': 'person_in_manual_wheelchair',
  '👨‍🦽': 'man_in_manual_wheelchair',
  '👩‍🦽': 'woman_in_manual_wheelchair',
  '🏃': 'runner',
  '🏃‍♂️': 'running_man',
  '🏃‍♀️': 'running_woman',
  '💃': 'woman_dancing',
  '🕺': 'man_dancing',
  '🕴️': 'business_suit_levitating',
  '👯': 'dancers',
  '👯‍♂️': 'dancing_men',
  '👯‍♀️': 'dancing_women',
  '🧖': 'sauna_person',
  '🧖‍♂️': 'sauna_man',
  '🧖‍♀️': 'sauna_woman',
  '🧗': 'climbing',
  '🧗‍♂️': 'climbing_man',
  '🧗‍♀️': 'climbing_woman',
  '🤺': 'person_fencing',
  '🏇': 'horse_racing',
  '⛷️': 'skier',
  '🏂': 'snowboarder',
  '🏌️': 'golfing',
  '🏌️‍♂️': 'golfing_man',
  '🏌️‍♀️': 'golfing_woman',
  '🏄': 'surfer',
  '🏄‍♂️': 'surfing_man',
  '🏄‍♀️': 'surfing_woman',
  '🚣': 'rowboat',
  '🚣‍♂️': 'rowing_man',
  '🚣‍♀️': 'rowing_woman',
  '🏊': 'swimmer',
  '🏊‍♂️': 'swimming_man',
  '🏊‍♀️': 'swimming_woman',
  '⛹️': 'bouncing_ball_person',
  '⛹️‍♂️': 'bouncing_ball_man',
  '⛹️‍♀️': 'bouncing_ball_woman',
  '🏋️': 'weight_lifting',
  '🏋️‍♂️': 'weight_lifting_man',
  '🏋️‍♀️': 'weight_lifting_woman',
  '🚴': 'bicyclist',
  '🚴‍♂️': 'biking_man',
  '🚴‍♀️': 'biking_woman',
  '🚵': 'mountain_bicyclist',
  '🚵‍♂️': 'mountain_biking_man',
  '🚵‍♀️': 'mountain_biking_woman',
  '🤸': 'cartwheeling',
  '🤸‍♂️': 'man_cartwheeling',
  '🤸‍♀️': 'woman_cartwheeling',
  '🤼': 'wrestling',
  '🤼‍♂️': 'men_wrestling',
  '🤼‍♀️': 'women_wrestling',
  '🤽': 'water_polo',
  '🤽‍♂️': 'man_playing_water_polo',
  '🤽‍♀️': 'woman_playing_water_polo',
  '🤾': 'handball_person',
  '🤾‍♂️': 'man_playing_handball',
  '🤾‍♀️': 'woman_playing_handball',
  '🤹': 'juggling_person',
  '🤹‍♂️': 'man_juggling',
  '🤹‍♀️': 'woman_juggling',
  '🧘': 'lotus_position',
  '🧘‍♂️': 'lotus_position_man',
  '🧘‍♀️': 'lotus_position_woman',
  '🛀': 'bath',
  '🛌': 'sleeping_bed',
  '🧑‍🤝‍🧑': 'people_holding_hands',
  '👭': 'two_women_holding_hands',
  '👫': 'couple',
  '👬': 'two_men_holding_hands',
  '💏': 'couplekiss',
  '👩‍❤️‍💋‍👨': 'couplekiss_man_woman',
  '👨‍❤️‍💋‍👨': 'couplekiss_man_man',
  '👩‍❤️‍💋‍👩': 'couplekiss_woman_woman',
  '💑': 'couple_with_heart',
  '👩‍❤️‍👨': 'couple_with_heart_woman_man',
  '👨‍❤️‍👨': 'couple_with_heart_man_man',
  '👩‍❤️‍👩': 'couple_with_heart_woman_woman',
  '👪': 'family',
  '👨‍👩‍👦': 'family_man_woman_boy',
  '👨‍👩‍👧': 'family_man_woman_girl',
  '👨‍👩‍👧‍👦': 'family_man_woman_girl_boy',
  '👨‍👩‍👦‍👦': 'family_man_woman_boy_boy',
  '👨‍👩‍👧‍👧': 'family_man_woman_girl_girl',
  '👨‍👨‍👦': 'family_man_man_boy',
  '👨‍👨‍👧': 'family_man_man_girl',
  '👨‍👨‍👧‍👦': 'family_man_man_girl_boy',
  '👨‍👨‍👦‍👦': 'family_man_man_boy_boy',
  '👨‍👨‍👧‍👧': 'family_man_man_girl_girl',
  '👩‍👩‍👦': 'family_woman_woman_boy',
  '👩‍👩‍👧': 'family_woman_woman_girl',
  '👩‍👩‍👧‍👦': 'family_woman_woman_girl_boy',
  '👩‍👩‍👦‍👦': 'family_woman_woman_boy_boy',
  '👩‍👩‍👧‍👧': 'family_woman_woman_girl_girl',
  '👨‍👦': 'family_man_boy',
  '👨‍👦‍👦': 'family_man_boy_boy',
  '👨‍👧': 'family_man_girl',
  '👨‍👧‍👦': 'family_man_girl_boy',
  '👨‍👧‍👧': 'family_man_girl_girl',
  '👩‍👦': 'family_woman_boy',
  '👩‍👦‍👦': 'family_woman_boy_boy',
  '👩‍👧': 'family_woman_girl',
  '👩‍👧‍👦': 'family_woman_girl_boy',
  '👩‍👧‍👧': 'family_woman_girl_girl',
  '🗣️': 'speaking_head',
  '👤': 'bust_in_silhouette',
  '👥': 'busts_in_silhouette',
  '🫂': 'people_hugging',
  '👣': 'footprints',
  '🐵': 'monkey_face',
  '🐒': 'monkey',
  '🦍': 'gorilla',
  '🦧': 'orangutan',
  '🐶': 'dog',
  '🐕': 'dog2',
  '🦮': 'guide_dog',
  '🐕‍🦺': 'service_dog',
  '🐩': 'poodle',
  '🐺': 'wolf',
  '🦊': 'fox_face',
  '🦝': 'raccoon',
  '🐱': 'cat',
  '🐈': 'cat2',
  '🐈‍⬛': 'black_cat',
  '🦁': 'lion',
  '🐯': 'tiger',
  '🐅': 'tiger2',
  '🐆': 'leopard',
  '🐴': 'horse',
  '🫎': 'moose',
  '🫏': 'donkey',
  '🐎': 'racehorse',
  '🦄': 'unicorn',
  '🦓': 'zebra',
  '🦌': 'deer',
  '🦬': 'bison',
  '🐮': 'cow',
  '🐂': 'ox',
  '🐃': 'water_buffalo',
  '🐄': 'cow2',
  '🐷': 'pig',
  '🐖': 'pig2',
  '🐗': 'boar',
  '🐽': 'pig_nose',
  '🐏': 'ram',
  '🐑': 'sheep',
  '🐐': 'goat',
  '🐪': 'dromedary_camel',
  '🐫': 'camel',
  '🦙': 'llama',
  '🦒': 'giraffe',
  '🐘': 'elephant',
  '🦣': 'mammoth',
  '🦏': 'rhinoceros',
  '🦛': 'hippopotamus',
  '🐭': 'mouse',
  '🐁': 'mouse2',
  '🐀': 'rat',
  '🐹': 'hamster',
  '🐰': 'rabbit',
  '🐇': 'rabbit2',
  '🐿️': 'chipmunk',
  '🦫': 'beaver',
  '🦔': 'hedgehog',
  '🦇': 'bat',
  '🐻': 'bear',
  '🐻‍❄️': 'polar_bear',
  '🐨': 'koala',
  '🐼': 'panda_face',
  '🦥': 'sloth',
  '🦦': 'otter',
  '🦨': 'skunk',
  '🦘': 'kangaroo',
  '🦡': 'badger',
  '🐾': 'feet',
  '🦃': 'turkey',
  '🐔': 'chicken',
  '🐓': 'rooster',
  '🐣': 'hatching_chick',
  '🐤': 'baby_chick',
  '🐥': 'hatched_chick',
  '🐦': 'bird',
  '🐧': 'penguin',
  '🕊️': 'dove',
  '🦅': 'eagle',
  '🦆': 'duck',
  '🦢': 'swan',
  '🦉': 'owl',
  '🦤': 'dodo',
  '🪶': 'feather',
  '🦩': 'flamingo',
  '🦚': 'peacock',
  '🦜': 'parrot',
  '🪽': 'wing',
  '🐦‍⬛': 'black_bird',
  '🪿': 'goose',
  '🐸': 'frog',
  '🐊': 'crocodile',
  '🐢': 'turtle',
  '🦎': 'lizard',
  '🐍': 'snake',
  '🐲': 'dragon_face',
  '🐉': 'dragon',
  '🦕': 'sauropod',
  '🦖': 't-rex',
  '🐳': 'whale',
  '🐋': 'whale2',
  '🐬': 'dolphin',
  '🦭': 'seal',
  '🐟': 'fish',
  '🐠': 'tropical_fish',
  '🐡': 'blowfish',
  '🦈': 'shark',
  '🐙': 'octopus',
  '🐚': 'shell',
  '🪸': 'coral',
  '🪼': 'jellyfish',
  '🐌': 'snail',
  '🦋': 'butterfly',
  '🐛': 'bug',
  '🐜': 'ant',
  '🐝': 'bee',
  '🪲': 'beetle',
  '🐞': 'lady_beetle',
  '🦗': 'cricket',
  '🪳': 'cockroach',
  '🕷️': 'spider',
  '🕸️': 'spider_web',
  '🦂': 'scorpion',
  '🦟': 'mosquito',
  '🪰': 'fly',
  '🪱': 'worm',
  '🦠': 'microbe',
  '💐': 'bouquet',
  '🌸': 'cherry_blossom',
  '💮': 'white_flower',
  '🪷': 'lotus',
  '🏵️': 'rosette',
  '🌹': 'rose',
  '🥀': 'wilted_flower',
  '🌺': 'hibiscus',
  '🌻': 'sunflower',
  '🌼': 'blossom',
  '🌷': 'tulip',
  '🪻': 'hyacinth',
  '🌱': 'seedling',
  '🪴': 'potted_plant',
  '🌲': 'evergreen_tree',
  '🌳': 'deciduous_tree',
  '🌴': 'palm_tree',
  '🌵': 'cactus',
  '🌾': 'ear_of_rice',
  '🌿': 'herb',
  '☘️': 'shamrock',
  '🍀': 'four_leaf_clover',
  '🍁': 'maple_leaf',
  '🍂': 'fallen_leaf',
  '🍃': 'leaves',
  '🪹': 'empty_nest',
  '🪺': 'nest_with_eggs',
  '🍄': 'mushroom',
  '🍇': 'grapes',
  '🍈': 'melon',
  '🍉': 'watermelon',
  '🍊': 'tangerine',
  '🍋': 'lemon',
  '🍌': 'banana',
  '🍍': 'pineapple',
  '🥭': 'mango',
  '🍎': 'apple',
  '🍏': 'green_apple',
  '🍐': 'pear',
  '🍑': 'peach',
  '🍒': 'cherries',
  '🍓': 'strawberry',
  '🫐': 'blueberries',
  '🥝': 'kiwi_fruit',
  '🍅': 'tomato',
  '🫒': 'olive',
  '🥥': 'coconut',
  '🥑': 'avocado',
  '🍆': 'eggplant',
  '🥔': 'potato',
  '🥕': 'carrot',
  '🌽': 'corn',
  '🌶️': 'hot_pepper',
  '🫑': 'bell_pepper',
  '🥒': 'cucumber',
  '🥬': 'leafy_green',
  '🥦': 'broccoli',
  '🧄': 'garlic',
  '🧅': 'onion',
  '🥜': 'peanuts',
  '🫘': 'beans',
  '🌰': 'chestnut',
  '🫚': 'ginger_root',
  '🫛': 'pea_pod',
  '🍞': 'bread',
  '🥐': 'croissant',
  '🥖': 'baguette_bread',
  '🫓': 'flatbread',
  '🥨': 'pretzel',
  '🥯': 'bagel',
  '🥞': 'pancakes',
  '🧇': 'waffle',
  '🧀': 'cheese',
  '🍖': 'meat_on_bone',
  '🍗': 'poultry_leg',
  '🥩': 'cut_of_meat',
  '🥓': 'bacon',
  '🍔': 'hamburger',
  '🍟': 'fries',
  '🍕': 'pizza',
  '🌭': 'hotdog',
  '🥪': 'sandwich',
  '🌮': 'taco',
  '🌯': 'burrito',
  '🫔': 'tamale',
  '🥙': 'stuffed_flatbread',
  '🧆': 'falafel',
  '🥚': 'egg',
  '🍳': 'fried_egg',
  '🥘': 'shallow_pan_of_food',
  '🍲': 'stew',
  '🫕': 'fondue',
  '🥣': 'bowl_with_spoon',
  '🥗': 'green_salad',
  '🍿': 'popcorn',
  '🧈': 'butter',
  '🧂': 'salt',
  '🥫': 'canned_food',
  '🍱': 'bento',
  '🍘': 'rice_cracker',
  '🍙': 'rice_ball',
  '🍚': 'rice',
  '🍛': 'curry',
  '🍜': 'ramen',
  '🍝': 'spaghetti',
  '🍠': 'sweet_potato',
  '🍢': 'oden',
  '🍣': 'sushi',
  '🍤': 'fried_shrimp',
  '🍥': 'fish_cake',
  '🥮': 'moon_cake',
  '🍡': 'dango',
  '🥟': 'dumpling',
  '🥠': 'fortune_cookie',
  '🥡': 'takeout_box',
  '🦀': 'crab',
  '🦞': 'lobster',
  '🦐': 'shrimp',
  '🦑': 'squid',
  '🦪': 'oyster',
  '🍦': 'icecream',
  '🍧': 'shaved_ice',
  '🍨': 'ice_cream',
  '🍩': 'doughnut',
  '🍪': 'cookie',
  '🎂': 'birthday',
  '🍰': 'cake',
  '🧁': 'cupcake',
  '🥧': 'pie',
  '🍫': 'chocolate_bar',
  '🍬': 'candy',
  '🍭': 'lollipop',
  '🍮': 'custard',
  '🍯': 'honey_pot',
  '🍼': 'baby_bottle',
  '🥛': 'milk_glass',
  '☕': 'coffee',
  '🫖': 'teapot',
  '🍵': 'tea',
  '🍶': 'sake',
  '🍾': 'champagne',
  '🍷': 'wine_glass',
  '🍸': 'cocktail',
  '🍹': 'tropical_drink',
  '🍺': 'beer',
  '🍻': 'beers',
  '🥂': 'clinking_glasses',
  '🥃': 'tumbler_glass',
  '🫗': 'pouring_liquid',
  '🥤': 'cup_with_straw',
  '🧋': 'bubble_tea',
  '🧃': 'beverage_box',
  '🧉': 'mate',
  '🧊': 'ice_cube',
  '🥢': 'chopsticks',
  '🍽️': 'plate_with_cutlery',
  '🍴': 'fork_and_knife',
  '🥄': 'spoon',
  '🔪': 'hocho',
  '🫙': 'jar',
  '🏺': 'amphora',
  '🌍': 'earth_africa',
  '🌎': 'earth_americas',
  '🌏': 'earth_asia',
  '🌐': 'globe_with_meridians',
  '🗺️': 'world_map',
  '🗾': 'japan',
  '🧭': 'compass',
  '🏔️': 'mountain_snow',
  '⛰️': 'mountain',
  '🌋': 'volcano',
  '🗻': 'mount_fuji',
  '🏕️': 'camping',
  '🏖️': 'beach_umbrella',
  '🏜️': 'desert',
  '🏝️': 'desert_island',
  '🏞️': 'national_park',
  '🏟️': 'stadium',
  '🏛️': 'classical_building',
  '🏗️': 'building_construction',
  '🧱': 'bricks',
  '🪨': 'rock',
  '🪵': 'wood',
  '🛖': 'hut',
  '🏘️': 'houses',
  '🏚️': 'derelict_house',
  '🏠': 'house',
  '🏡': 'house_with_garden',
  '🏢': 'office',
  '🏣': 'post_office',
  '🏤': 'european_post_office',
  '🏥': 'hospital',
  '🏦': 'bank',
  '🏨': 'hotel',
  '🏩': 'love_hotel',
  '🏪': 'convenience_store',
  '🏫': 'school',
  '🏬': 'department_store',
  '🏭': 'factory',
  '🏯': 'japanese_castle',
  '🏰': 'european_castle',
  '💒': 'wedding',
  '🗼': 'tokyo_tower',
  '🗽': 'statue_of_liberty',
  '⛪': 'church',
  '🕌': 'mosque',
  '🛕': 'hindu_temple',
  '🕍': 'synagogue',
  '⛩️': 'shinto_shrine',
  '🕋': 'kaaba',
  '⛲': 'fountain',
  '⛺': 'tent',
  '🌁': 'foggy',
  '🌃': 'night_with_stars',
  '🏙️': 'cityscape',
  '🌄': 'sunrise_over_mountains',
  '🌅': 'sunrise',
  '🌆': 'city_sunset',
  '🌇': 'city_sunrise',
  '🌉': 'bridge_at_night',
  '♨️': 'hotsprings',
  '🎠': 'carousel_horse',
  '🛝': 'playground_slide',
  '🎡': 'ferris_wheel',
  '🎢': 'roller_coaster',
  '💈': 'barber',
  '🎪': 'circus_tent',
  '🚂': 'steam_locomotive',
  '🚃': 'railway_car',
  '🚄': 'bullettrain_side',
  '🚅': 'bullettrain_front',
  '🚆': 'train2',
  '🚇': 'metro',
  '🚈': 'light_rail',
  '🚉': 'station',
  '🚊': 'tram',
  '🚝': 'monorail',
  '🚞': 'mountain_railway',
  '🚋': 'train',
  '🚌': 'bus',
  '🚍': 'oncoming_bus',
  '🚎': 'trolleybus',
  '🚐': 'minibus',
  '🚑': 'ambulance',
  '🚒': 'fire_engine',
  '🚓': 'police_car',
  '🚔': 'oncoming_police_car',
  '🚕': 'taxi',
  '🚖': 'oncoming_taxi',
  '🚗': 'car',
  '🚘': 'oncoming_automobile',
  '🚙': 'blue_car',
  '🛻': 'pickup_truck',
  '🚚': 'truck',
  '🚛': 'articulated_lorry',
  '🚜': 'tractor',
  '🏎️': 'racing_car',
  '🏍️': 'motorcycle',
  '🛵': 'motor_scooter',
  '🦽': 'manual_wheelchair',
  '🦼': 'motorized_wheelchair',
  '🛺': 'auto_rickshaw',
  '🚲': 'bike',
  '🛴': 'kick_scooter',
  '🛹': 'skateboard',
  '🛼': 'roller_skate',
  '🚏': 'busstop',
  '🛣️': 'motorway',
  '🛤️': 'railway_track',
  '🛢️': 'oil_drum',
  '⛽': 'fuelpump',
  '🛞': 'wheel',
  '🚨': 'rotating_light',
  '🚥': 'traffic_light',
  '🚦': 'vertical_traffic_light',
  '🛑': 'stop_sign',
  '🚧': 'construction',
  '⚓': 'anchor',
  '🛟': 'ring_buoy',
  '⛵': 'boat',
  '🛶': 'canoe',
  '🚤': 'speedboat',
  '🛳️': 'passenger_ship',
  '⛴️': 'ferry',
  '🛥️': 'motor_boat',
  '🚢': 'ship',
  '✈️': 'airplane',
  '🛩️': 'small_airplane',
  '🛫': 'flight_departure',
  '🛬': 'flight_arrival',
  '🪂': 'parachute',
  '💺': 'seat',
  '🚁': 'helicopter',
  '🚟': 'suspension_railway',
  '🚠': 'mountain_cableway',
  '🚡': 'aerial_tramway',
  '🛰️': 'artificial_satellite',
  '🚀': 'rocket',
  '🛸': 'flying_saucer',
  '🛎️': 'bellhop_bell',
  '🧳': 'luggage',
  '⌛': 'hourglass',
  '⏳': 'hourglass_flowing_sand',
  '⌚': 'watch',
  '⏰': 'alarm_clock',
  '⏱️': 'stopwatch',
  '⏲️': 'timer_clock',
  '🕰️': 'mantelpiece_clock',
  '🕛': 'clock12',
  '🕧': 'clock1230',
  '🕐': 'clock1',
  '🕜': 'clock130',
  '🕑': 'clock2',
  '🕝': 'clock230',
  '🕒': 'clock3',
  '🕞': 'clock330',
  '🕓': 'clock4',
  '🕟': 'clock430',
  '🕔': 'clock5',
  '🕠': 'clock530',
  '🕕': 'clock6',
  '🕡': 'clock630',
  '🕖': 'clock7',
  '🕢': 'clock730',
  '🕗': 'clock8',
  '🕣': 'clock830',
  '🕘': 'clock9',
  '🕤': 'clock930',
  '🕙': 'clock10',
  '🕥': 'clock1030',
  '🕚': 'clock11',
  '🕦': 'clock1130',
  '🌑': 'new_moon',
  '🌒': 'waxing_crescent_moon',
  '🌓': 'first_quarter_moon',
  '🌔': 'moon',
  '🌕': 'full_moon',
  '🌖': 'waning_gibbous_moon',
  '🌗': 'last_quarter_moon',
  '🌘': 'waning_crescent_moon',
  '🌙': 'crescent_moon',
  '🌚': 'new_moon_with_face',
  '🌛': 'first_quarter_moon_with_face',
  '🌜': 'last_quarter_moon_with_face',
  '🌡️': 'thermometer',
  '☀️': 'sunny',
  '🌝': 'full_moon_with_face',
  '🌞': 'sun_with_face',
  '🪐': 'ringed_planet',
  '⭐': 'star',
  '🌟': 'star2',
  '🌠': 'stars',
  '🌌': 'milky_way',
  '☁️': 'cloud',
  '⛅': 'partly_sunny',
  '⛈️': 'cloud_with_lightning_and_rain',
  '🌤️': 'sun_behind_small_cloud',
  '🌥️': 'sun_behind_large_cloud',
  '🌦️': 'sun_behind_rain_cloud',
  '🌧️': 'cloud_with_rain',
  '🌨️': 'cloud_with_snow',
  '🌩️': 'cloud_with_lightning',
  '🌪️': 'tornado',
  '🌫️': 'fog',
  '🌬️': 'wind_face',
  '🌀': 'cyclone',
  '🌈': 'rainbow',
  '🌂': 'closed_umbrella',
  '☂️': 'open_umbrella',
  '☔': 'umbrella',
  '⛱️': 'parasol_on_ground',
  '⚡': 'zap',
  '❄️': 'snowflake',
  '☃️': 'snowman_with_snow',
  '⛄': 'snowman',
  '☄️': 'comet',
  '🔥': 'fire',
  '💧': 'droplet',
  '🌊': 'ocean',
  '🎃': 'jack_o_lantern',
  '🎄': 'christmas_tree',
  '🎆': 'fireworks',
  '🎇': 'sparkler',
  '🧨': 'firecracker',
  '✨': 'sparkles',
  '🎈': 'balloon',
  '🎉': 'tada',
  '🎊': 'confetti_ball',
  '🎋': 'tanabata_tree',
  '🎍': 'bamboo',
  '🎎': 'dolls',
  '🎏': 'flags',
  '🎐': 'wind_chime',
  '🎑': 'rice_scene',
  '🧧': 'red_envelope',
  '🎀': 'ribbon',
  '🎁': 'gift',
  '🎗️': 'reminder_ribbon',
  '🎟️': 'tickets',
  '🎫': 'ticket',
  '🎖️': 'medal_military',
  '🏆': 'trophy',
  '🏅': 'medal_sports',
  '🥇': '1st_place_medal',
  '🥈': '2nd_place_medal',
  '🥉': '3rd_place_medal',
  '⚽': 'soccer',
  '⚾': 'baseball',
  '🥎': 'softball',
  '🏀': 'basketball',
  '🏐': 'volleyball',
  '🏈': 'football',
  '🏉': 'rugby_football',
  '🎾': 'tennis',
  '🥏': 'flying_disc',
  '🎳': 'bowling',
  '🏏': 'cricket_game',
  '🏑': 'field_hockey',
  '🏒': 'ice_hockey',
  '🥍': 'lacrosse',
  '🏓': 'ping_pong',
  '🏸': 'badminton',
  '🥊': 'boxing_glove',
  '🥋': 'martial_arts_uniform',
  '🥅': 'goal_net',
  '⛳': 'golf',
  '⛸️': 'ice_skate',
  '🎣': 'fishing_pole_and_fish',
  '🤿': 'diving_mask',
  '🎽': 'running_shirt_with_sash',
  '🎿': 'ski',
  '🛷': 'sled',
  '🥌': 'curling_stone',
  '🎯': 'dart',
  '🪀': 'yo_yo',
  '🪁': 'kite',
  '🔫': 'gun',
  '🎱': '8ball',
  '🔮': 'crystal_ball',
  '🪄': 'magic_wand',
  '🎮': 'video_game',
  '🕹️': 'joystick',
  '🎰': 'slot_machine',
  '🎲': 'game_die',
  '🧩': 'jigsaw',
  '🧸': 'teddy_bear',
  '🪅': 'pinata',
  '🪩': 'mirror_ball',
  '🪆': 'nesting_dolls',
  '♠️': 'spades',
  '♥️': 'hearts',
  '♦️': 'diamonds',
  '♣️': 'clubs',
  '♟️': 'chess_pawn',
  '🃏': 'black_joker',
  '🀄': 'mahjong',
  '🎴': 'flower_playing_cards',
  '🎭': 'performing_arts',
  '🖼️': 'framed_picture',
  '🎨': 'art',
  '🧵': 'thread',
  '🪡': 'sewing_needle',
  '🧶': 'yarn',
  '🪢': 'knot',
  '👓': 'eyeglasses',
  '🕶️': 'dark_sunglasses',
  '🥽': 'goggles',
  '🥼': 'lab_coat',
  '🦺': 'safety_vest',
  '👔': 'necktie',
  '👕': 'shirt',
  '👖': 'jeans',
  '🧣': 'scarf',
  '🧤': 'gloves',
  '🧥': 'coat',
  '🧦': 'socks',
  '👗': 'dress',
  '👘': 'kimono',
  '🥻': 'sari',
  '🩱': 'one_piece_swimsuit',
  '🩲': 'swim_brief',
  '🩳': 'shorts',
  '👙': 'bikini',
  '👚': 'womans_clothes',
  '🪭': 'folding_hand_fan',
  '👛': 'purse',
  '👜': 'handbag',
  '👝': 'pouch',
  '🛍️': 'shopping',
  '🎒': 'school_satchel',
  '🩴': 'thong_sandal',
  '👞': 'mans_shoe',
  '👟': 'athletic_shoe',
  '🥾': 'hiking_boot',
  '🥿': 'flat_shoe',
  '👠': 'high_heel',
  '👡': 'sandal',
  '🩰': 'ballet_shoes',
  '👢': 'boot',
  '🪮': 'hair_pick',
  '👑': 'crown',
  '👒': 'womans_hat',
  '🎩': 'tophat',
  '🎓': 'mortar_board',
  '🧢': 'billed_cap',
  '🪖': 'military_helmet',
  '⛑️': 'rescue_worker_helmet',
  '📿': 'prayer_beads',
  '💄': 'lipstick',
  '💍': 'ring',
  '💎': 'gem',
  '🔇': 'mute',
  '🔈': 'speaker',
  '🔉': 'sound',
  '🔊': 'loud_sound',
  '📢': 'loudspeaker',
  '📣': 'mega',
  '📯': 'postal_horn',
  '🔔': 'bell',
  '🔕': 'no_bell',
  '🎼': 'musical_score',
  '🎵': 'musical_note',
  '🎶': 'notes',
  '🎙️': 'studio_microphone',
  '🎚️': 'level_slider',
  '🎛️': 'control_knobs',
  '🎤': 'microphone',
  '🎧': 'headphones',
  '📻': 'radio',
  '🎷': 'saxophone',
  '🪗': 'accordion',
  '🎸': 'guitar',
  '🎹': 'musical_keyboard',
  '🎺': 'trumpet',
  '🎻': 'violin',
  '🪕': 'banjo',
  '🥁': 'drum',
  '🪘': 'long_drum',
  '🪇': 'maracas',
  '🪈': 'flute',
  '📱': 'iphone',
  '📲': 'calling',
  '☎️': 'phone',
  '📞': 'telephone_receiver',
  '📟': 'pager',
  '📠': 'fax',
  '🔋': 'battery',
  '🪫': 'low_battery',
  '🔌': 'electric_plug',
  '💻': 'computer',
  '🖥️': 'desktop_computer',
  '🖨️': 'printer',
  '⌨️': 'keyboard',
  '🖱️': 'computer_mouse',
  '🖲️': 'trackball',
  '💽': 'minidisc',
  '💾': 'floppy_disk',
  '💿': 'cd',
  '📀': 'dvd',
  '🧮': 'abacus',
  '🎥': 'movie_camera',
  '🎞️': 'film_strip',
  '📽️': 'film_projector',
  '🎬': 'clapper',
  '📺': 'tv',
  '📷': 'camera',
  '📸': 'camera_flash',
  '📹': 'video_camera',
  '📼': 'vhs',
  '🔍': 'mag',
  '🔎': 'mag_right',
  '🕯️': 'candle',
  '💡': 'bulb',
  '🔦': 'flashlight',
  '🏮': 'izakaya_lantern',
  '🪔': 'diya_lamp',
  '📔': 'notebook_with_decorative_cover',
  '📕': 'closed_book',
  '📖': 'book',
  '📗': 'green_book',
  '📘': 'blue_book',
  '📙': 'orange_book',
  '📚': 'books',
  '📓': 'notebook',
  '📒': 'ledger',
  '📃': 'page_with_curl',
  '📜': 'scroll',
  '📄': 'page_facing_up',
  '📰': 'newspaper',
  '🗞️': 'newspaper_roll',
  '📑': 'bookmark_tabs',
  '🔖': 'bookmark',
  '🏷️': 'label',
  '💰': 'moneybag',
  '🪙': 'coin',
  '💴': 'yen',
  '💵': 'dollar',
  '💶': 'euro',
  '💷': 'pound',
  '💸': 'money_with_wings',
  '💳': 'credit_card',
  '🧾': 'receipt',
  '💹': 'chart',
  '✉️': 'envelope',
  '📧': 'email',
  '📨': 'incoming_envelope',
  '📩': 'envelope_with_arrow',
  '📤': 'outbox_tray',
  '📥': 'inbox_tray',
  '📦': 'package',
  '📫': 'mailbox',
  '📪': 'mailbox_closed',
  '📬': 'mailbox_with_mail',
  '📭': 'mailbox_with_no_mail',
  '📮': 'postbox',
  '🗳️': 'ballot_box',
  '✏️': 'pencil2',
  '✒️': 'black_nib',
  '🖋️': 'fountain_pen',
  '🖊️': 'pen',
  '🖌️': 'paintbrush',
  '🖍️': 'crayon',
  '📝': 'memo',
  '💼': 'briefcase',
  '📁': 'file_folder',
  '📂': 'open_file_folder',
  '🗂️': 'card_index_dividers',
  '📅': 'date',
  '📆': 'calendar',
  '🗒️': 'spiral_notepad',
  '🗓️': 'spiral_calendar',
  '📇': 'card_index',
  '📈': 'chart_with_upwards_trend',
  '📉': 'chart_with_downwards_trend',
  '📊': 'bar_chart',
  '📋': 'clipboard',
  '📌': 'pushpin',
  '📍': 'round_pushpin',
  '📎': 'paperclip',
  '🖇️': 'paperclips',
  '📏': 'straight_ruler',
  '📐': 'triangular_ruler',
  '✂️': 'scissors',
  '🗃️': 'card_file_box',
  '🗄️': 'file_cabinet',
  '🗑️': 'wastebasket',
  '🔒': 'lock',
  '🔓': 'unlock',
  '🔏': 'lock_with_ink_pen',
  '🔐': 'closed_lock_with_key',
  '🔑': 'key',
  '🗝️': 'old_key',
  '🔨': 'hammer',
  '🪓': 'axe',
  '⛏️': 'pick',
  '⚒️': 'hammer_and_pick',
  '🛠️': 'hammer_and_wrench',
  '🗡️': 'dagger',
  '⚔️': 'crossed_swords',
  '💣': 'bomb',
  '🪃': 'boomerang',
  '🏹': 'bow_and_arrow',
  '🛡️': 'shield',
  '🪚': 'carpentry_saw',
  '🔧': 'wrench',
  '🪛': 'screwdriver',
  '🔩': 'nut_and_bolt',
  '⚙️': 'gear',
  '🗜️': 'clamp',
  '⚖️': 'balance_scale',
  '🦯': 'probing_cane',
  '🔗': 'link',
  '⛓️': 'chains',
  '🪝': 'hook',
  '🧰': 'toolbox',
  '🧲': 'magnet',
  '🪜': 'ladder',
  '⚗️': 'alembic',
  '🧪': 'test_tube',
  '🧫': 'petri_dish',
  '🧬': 'dna',
  '🔬': 'microscope',
  '🔭': 'telescope',
  '📡': 'satellite',
  '💉': 'syringe',
  '🩸': 'drop_of_blood',
  '💊': 'pill',
  '🩹': 'adhesive_bandage',
  '🩼': 'crutch',
  '🩺': 'stethoscope',
  '🩻': 'x_ray',
  '🚪': 'door',
  '🛗': 'elevator',
  '🪞': 'mirror',
  '🪟': 'window',
  '🛏️': 'bed',
  '🛋️': 'couch_and_lamp',
  '🪑': 'chair',
  '🚽': 'toilet',
  '🪠': 'plunger',
  '🚿': 'shower',
  '🛁': 'bathtub',
  '🪤': 'mouse_trap',
  '🪒': 'razor',
  '🧴': 'lotion_bottle',
  '🧷': 'safety_pin',
  '🧹': 'broom',
  '🧺': 'basket',
  '🧻': 'roll_of_paper',
  '🪣': 'bucket',
  '🧼': 'soap',
  '🫧': 'bubbles',
  '🪥': 'toothbrush',
  '🧽': 'sponge',
  '🧯': 'fire_extinguisher',
  '🛒': 'shopping_cart',
  '🚬': 'smoking',
  '⚰️': 'coffin',
  '🪦': 'headstone',
  '⚱️': 'funeral_urn',
  '🧿': 'nazar_amulet',
  '🪬': 'hamsa',
  '🗿': 'moyai',
  '🪧': 'placard',
  '🪪': 'identification_card',
  '🏧': 'atm',
  '🚮': 'put_litter_in_its_place',
  '🚰': 'potable_water',
  '♿': 'wheelchair',
  '🚹': 'mens',
  '🚺': 'womens',
  '🚻': 'restroom',
  '🚼': 'baby_symbol',
  '🚾': 'wc',
  '🛂': 'passport_control',
  '🛃': 'customs',
  '🛄': 'baggage_claim',
  '🛅': 'left_luggage',
  '⚠️': 'warning',
  '🚸': 'children_crossing',
  '⛔': 'no_entry',
  '🚫': 'no_entry_sign',
  '🚳': 'no_bicycles',
  '🚭': 'no_smoking',
  '🚯': 'do_not_litter',
  '🚱': 'non-potable_water',
  '🚷': 'no_pedestrians',
  '📵': 'no_mobile_phones',
  '🔞': 'underage',
  '☢️': 'radioactive',
  '☣️': 'biohazard',
  '⬆️': 'arrow_up',
  '↗️': 'arrow_upper_right',
  '➡️': 'arrow_right',
  '↘️': 'arrow_lower_right',
  '⬇️': 'arrow_down',
  '↙️': 'arrow_lower_left',
  '⬅️': 'arrow_left',
  '↖️': 'arrow_upper_left',
  '↕️': 'arrow_up_down',
  '↔️': 'left_right_arrow',
  '↩️': 'leftwards_arrow_with_hook',
  '↪️': 'arrow_right_hook',
  '⤴️': 'arrow_heading_up',
  '⤵️': 'arrow_heading_down',
  '🔃': 'arrows_clockwise',
  '🔄': 'arrows_counterclockwise',
  '🔙': 'back',
  '🔚': 'end',
  '🔛': 'on',
  '🔜': 'soon',
  '🔝': 'top',
  '🛐': 'place_of_worship',
  '⚛️': 'atom_symbol',
  '🕉️': 'om',
  '✡️': 'star_of_david',
  '☸️': 'wheel_of_dharma',
  '☯️': 'yin_yang',
  '✝️': 'latin_cross',
  '☦️': 'orthodox_cross',
  '☪️': 'star_and_crescent',
  '☮️': 'peace_symbol',
  '🕎': 'menorah',
  '🔯': 'six_pointed_star',
  '🪯': 'khanda',
  '♈': 'aries',
  '♉': 'taurus',
  '♊': 'gemini',
  '♋': 'cancer',
  '♌': 'leo',
  '♍': 'virgo',
  '♎': 'libra',
  '♏': 'scorpius',
  '♐': 'sagittarius',
  '♑': 'capricorn',
  '♒': 'aquarius',
  '♓': 'pisces',
  '⛎': 'ophiuchus',
  '🔀': 'twisted_rightwards_arrows',
  '🔁': 'repeat',
  '🔂': 'repeat_one',
  '▶️': 'arrow_forward',
  '⏩': 'fast_forward',
  '⏭️': 'next_track_button',
  '⏯️': 'play_or_pause_button',
  '◀️': 'arrow_backward',
  '⏪': 'rewind',
  '⏮️': 'previous_track_button',
  '🔼': 'arrow_up_small',
  '⏫': 'arrow_double_up',
  '🔽': 'arrow_down_small',
  '⏬': 'arrow_double_down',
  '⏸️': 'pause_button',
  '⏹️': 'stop_button',
  '⏺️': 'record_button',
  '⏏️': 'eject_button',
  '🎦': 'cinema',
  '🔅': 'low_brightness',
  '🔆': 'high_brightness',
  '📶': 'signal_strength',
  '🛜': 'wireless',
  '📳': 'vibration_mode',
  '📴': 'mobile_phone_off',
  '♀️': 'female_sign',
  '♂️': 'male_sign',
  '⚧️': 'transgender_symbol',
  '✖️': 'heavy_multiplication_x',
  '➕': 'heavy_plus_sign',
  '➖': 'heavy_minus_sign',
  '➗': 'heavy_division_sign',
  '🟰': 'heavy_equals_sign',
  '♾️': 'infinity',
  '‼️': 'bangbang',
  '⁉️': 'interrobang',
  '❓': 'question',
  '❔': 'grey_question',
  '❕': 'grey_exclamation',
  '❗': 'exclamation',
  '〰️': 'wavy_dash',
  '💱': 'currency_exchange',
  '💲': 'heavy_dollar_sign',
  '⚕️': 'medical_symbol',
  '♻️': 'recycle',
  '⚜️': 'fleur_de_lis',
  '🔱': 'trident',
  '📛': 'name_badge',
  '🔰': 'beginner',
  '⭕': 'o',
  '✅': 'white_check_mark',
  '☑️': 'ballot_box_with_check',
  '✔️': 'heavy_check_mark',
  '❌': 'x',
  '❎': 'negative_squared_cross_mark',
  '➰': 'curly_loop',
  '➿': 'loop',
  '〽️': 'part_alternation_mark',
  '✳️': 'eight_spoked_asterisk',
  '✴️': 'eight_pointed_black_star',
  '❇️': 'sparkle',
  '©️': 'copyright',
  '®️': 'registered',
  '™️': 'tm',
  '#️⃣': 'hash',
  '*️⃣': 'asterisk',
  '0️⃣': 'zero',
  '1️⃣': 'one',
  '2️⃣': 'two',
  '3️⃣': 'three',
  '4️⃣': 'four',
  '5️⃣': 'five',
  '6️⃣': 'six',
  '7️⃣': 'seven',
  '8️⃣': 'eight',
  '9️⃣': 'nine',
  '🔟': 'keycap_ten',
  '🔠': 'capital_abcd',
  '🔡': 'abcd',
  '🔢': '1234',
  '🔣': 'symbols',
  '🔤': 'abc',
  '🅰️': 'a',
  '🆎': 'ab',
  '🅱️': 'b',
  '🆑': 'cl',
  '🆒': 'cool',
  '🆓': 'free',
  ℹ️: 'information_source',
  '🆔': 'id',
  'Ⓜ️': 'm',
  '🆕': 'new',
  '🆖': 'ng',
  '🅾️': 'o2',
  '🆗': 'ok',
  '🅿️': 'parking',
  '🆘': 'sos',
  '🆙': 'up',
  '🆚': 'vs',
  '🈁': 'koko',
  '🈂️': 'sa',
  '🈷️': 'u6708',
  '🈶': 'u6709',
  '🈯': 'u6307',
  '🉐': 'ideograph_advantage',
  '🈹': 'u5272',
  '🈚': 'u7121',
  '🈲': 'u7981',
  '🉑': 'accept',
  '🈸': 'u7533',
  '🈴': 'u5408',
  '🈳': 'u7a7a',
  '㊗️': 'congratulations',
  '㊙️': 'secret',
  '🈺': 'u55b6',
  '🈵': 'u6e80',
  '🔴': 'red_circle',
  '🟠': 'orange_circle',
  '🟡': 'yellow_circle',
  '🟢': 'green_circle',
  '🔵': 'large_blue_circle',
  '🟣': 'purple_circle',
  '🟤': 'brown_circle',
  '⚫': 'black_circle',
  '⚪': 'white_circle',
  '🟥': 'red_square',
  '🟧': 'orange_square',
  '🟨': 'yellow_square',
  '🟩': 'green_square',
  '🟦': 'blue_square',
  '🟪': 'purple_square',
  '🟫': 'brown_square',
  '⬛': 'black_large_square',
  '⬜': 'white_large_square',
  '◼️': 'black_medium_square',
  '◻️': 'white_medium_square',
  '◾': 'black_medium_small_square',
  '◽': 'white_medium_small_square',
  '▪️': 'black_small_square',
  '▫️': 'white_small_square',
  '🔶': 'large_orange_diamond',
  '🔷': 'large_blue_diamond',
  '🔸': 'small_orange_diamond',
  '🔹': 'small_blue_diamond',
  '🔺': 'small_red_triangle',
  '🔻': 'small_red_triangle_down',
  '💠': 'diamond_shape_with_a_dot_inside',
  '🔘': 'radio_button',
  '🔳': 'white_square_button',
  '🔲': 'black_square_button',
  '🏁': 'checkered_flag',
  '🚩': 'triangular_flag_on_post',
  '🎌': 'crossed_flags',
  '🏴': 'black_flag',
  '🏳️': 'white_flag',
  '🏳️‍🌈': 'rainbow_flag',
  '🏳️‍⚧️': 'transgender_flag',
  '🏴‍☠️': 'pirate_flag',
  '🇦🇨': 'ascension_island',
  '🇦🇩': 'andorra',
  '🇦🇪': 'united_arab_emirates',
  '🇦🇫': 'afghanistan',
  '🇦🇬': 'antigua_barbuda',
  '🇦🇮': 'anguilla',
  '🇦🇱': 'albania',
  '🇦🇲': 'armenia',
  '🇦🇴': 'angola',
  '🇦🇶': 'antarctica',
  '🇦🇷': 'argentina',
  '🇦🇸': 'american_samoa',
  '🇦🇹': 'austria',
  '🇦🇺': 'australia',
  '🇦🇼': 'aruba',
  '🇦🇽': 'aland_islands',
  '🇦🇿': 'azerbaijan',
  '🇧🇦': 'bosnia_herzegovina',
  '🇧🇧': 'barbados',
  '🇧🇩': 'bangladesh',
  '🇧🇪': 'belgium',
  '🇧🇫': 'burkina_faso',
  '🇧🇬': 'bulgaria',
  '🇧🇭': 'bahrain',
  '🇧🇮': 'burundi',
  '🇧🇯': 'benin',
  '🇧🇱': 'st_barthelemy',
  '🇧🇲': 'bermuda',
  '🇧🇳': 'brunei',
  '🇧🇴': 'bolivia',
  '🇧🇶': 'caribbean_netherlands',
  '🇧🇷': 'brazil',
  '🇧🇸': 'bahamas',
  '🇧🇹': 'bhutan',
  '🇧🇻': 'bouvet_island',
  '🇧🇼': 'botswana',
  '🇧🇾': 'belarus',
  '🇧🇿': 'belize',
  '🇨🇦': 'canada',
  '🇨🇨': 'cocos_islands',
  '🇨🇩': 'congo_kinshasa',
  '🇨🇫': 'central_african_republic',
  '🇨🇬': 'congo_brazzaville',
  '🇨🇭': 'switzerland',
  '🇨🇮': 'cote_divoire',
  '🇨🇰': 'cook_islands',
  '🇨🇱': 'chile',
  '🇨🇲': 'cameroon',
  '🇨🇳': 'cn',
  '🇨🇴': 'colombia',
  '🇨🇵': 'clipperton_island',
  '🇨🇷': 'costa_rica',
  '🇨🇺': 'cuba',
  '🇨🇻': 'cape_verde',
  '🇨🇼': 'curacao',
  '🇨🇽': 'christmas_island',
  '🇨🇾': 'cyprus',
  '🇨🇿': 'czech_republic',
  '🇩🇪': 'de',
  '🇩🇬': 'diego_garcia',
  '🇩🇯': 'djibouti',
  '🇩🇰': 'denmark',
  '🇩🇲': 'dominica',
  '🇩🇴': 'dominican_republic',
  '🇩🇿': 'algeria',
  '🇪🇦': 'ceuta_melilla',
  '🇪🇨': 'ecuador',
  '🇪🇪': 'estonia',
  '🇪🇬': 'egypt',
  '🇪🇭': 'western_sahara',
  '🇪🇷': 'eritrea',
  '🇪🇸': 'es',
  '🇪🇹': 'ethiopia',
  '🇪🇺': 'eu',
  '🇫🇮': 'finland',
  '🇫🇯': 'fiji',
  '🇫🇰': 'falkland_islands',
  '🇫🇲': 'micronesia',
  '🇫🇴': 'faroe_islands',
  '🇫🇷': 'fr',
  '🇬🇦': 'gabon',
  '🇬🇧': 'gb',
  '🇬🇩': 'grenada',
  '🇬🇪': 'georgia',
  '🇬🇫': 'french_guiana',
  '🇬🇬': 'guernsey',
  '🇬🇭': 'ghana',
  '🇬🇮': 'gibraltar',
  '🇬🇱': 'greenland',
  '🇬🇲': 'gambia',
  '🇬🇳': 'guinea',
  '🇬🇵': 'guadeloupe',
  '🇬🇶': 'equatorial_guinea',
  '🇬🇷': 'greece',
  '🇬🇸': 'south_georgia_south_sandwich_islands',
  '🇬🇹': 'guatemala',
  '🇬🇺': 'guam',
  '🇬🇼': 'guinea_bissau',
  '🇬🇾': 'guyana',
  '🇭🇰': 'hong_kong',
  '🇭🇲': 'heard_mcdonald_islands',
  '🇭🇳': 'honduras',
  '🇭🇷': 'croatia',
  '🇭🇹': 'haiti',
  '🇭🇺': 'hungary',
  '🇮🇨': 'canary_islands',
  '🇮🇩': 'indonesia',
  '🇮🇪': 'ireland',
  '🇮🇱': 'israel',
  '🇮🇲': 'isle_of_man',
  '🇮🇳': 'india',
  '🇮🇴': 'british_indian_ocean_territory',
  '🇮🇶': 'iraq',
  '🇮🇷': 'iran',
  '🇮🇸': 'iceland',
  '🇮🇹': 'it',
  '🇯🇪': 'jersey',
  '🇯🇲': 'jamaica',
  '🇯🇴': 'jordan',
  '🇯🇵': 'jp',
  '🇰🇪': 'kenya',
  '🇰🇬': 'kyrgyzstan',
  '🇰🇭': 'cambodia',
  '🇰🇮': 'kiribati',
  '🇰🇲': 'comoros',
  '🇰🇳': 'st_kitts_nevis',
  '🇰🇵': 'north_korea',
  '🇰🇷': 'kr',
  '🇰🇼': 'kuwait',
  '🇰🇾': 'cayman_islands',
  '🇰🇿': 'kazakhstan',
  '🇱🇦': 'laos',
  '🇱🇧': 'lebanon',
  '🇱🇨': 'st_lucia',
  '🇱🇮': 'liechtenstein',
  '🇱🇰': 'sri_lanka',
  '🇱🇷': 'liberia',
  '🇱🇸': 'lesotho',
  '🇱🇹': 'lithuania',
  '🇱🇺': 'luxembourg',
  '🇱🇻': 'latvia',
  '🇱🇾': 'libya',
  '🇲🇦': 'morocco',
  '🇲🇨': 'monaco',
  '🇲🇩': 'moldova',
  '🇲🇪': 'montenegro',
  '🇲🇫': 'st_martin',
  '🇲🇬': 'madagascar',
  '🇲🇭': 'marshall_islands',
  '🇲🇰': 'macedonia',
  '🇲🇱': 'mali',
  '🇲🇲': 'myanmar',
  '🇲🇳': 'mongolia',
  '🇲🇴': 'macau',
  '🇲🇵': 'northern_mariana_islands',
  '🇲🇶': 'martinique',
  '🇲🇷': 'mauritania',
  '🇲🇸': 'montserrat',
  '🇲🇹': 'malta',
  '🇲🇺': 'mauritius',
  '🇲🇻': 'maldives',
  '🇲🇼': 'malawi',
  '🇲🇽': 'mexico',
  '🇲🇾': 'malaysia',
  '🇲🇿': 'mozambique',
  '🇳🇦': 'namibia',
  '🇳🇨': 'new_caledonia',
  '🇳🇪': 'niger',
  '🇳🇫': 'norfolk_island',
  '🇳🇬': 'nigeria',
  '🇳🇮': 'nicaragua',
  '🇳🇱': 'netherlands',
  '🇳🇴': 'norway',
  '🇳🇵': 'nepal',
  '🇳🇷': 'nauru',
  '🇳🇺': 'niue',
  '🇳🇿': 'new_zealand',
  '🇴🇲': 'oman',
  '🇵🇦': 'panama',
  '🇵🇪': 'peru',
  '🇵🇫': 'french_polynesia',
  '🇵🇬': 'papua_new_guinea',
  '🇵🇭': 'philippines',
  '🇵🇰': 'pakistan',
  '🇵🇱': 'poland',
  '🇵🇲': 'st_pierre_miquelon',
  '🇵🇳': 'pitcairn_islands',
  '🇵🇷': 'puerto_rico',
  '🇵🇸': 'palestinian_territories',
  '🇵🇹': 'portugal',
  '🇵🇼': 'palau',
  '🇵🇾': 'paraguay',
  '🇶🇦': 'qatar',
  '🇷🇪': 'reunion',
  '🇷🇴': 'romania',
  '🇷🇸': 'serbia',
  '🇷🇺': 'ru',
  '🇷🇼': 'rwanda',
  '🇸🇦': 'saudi_arabia',
  '🇸🇧': 'solomon_islands',
  '🇸🇨': 'seychelles',
  '🇸🇩': 'sudan',
  '🇸🇪': 'sweden',
  '🇸🇬': 'singapore',
  '🇸🇭': 'st_helena',
  '🇸🇮': 'slovenia',
  '🇸🇯': 'svalbard_jan_mayen',
  '🇸🇰': 'slovakia',
  '🇸🇱': 'sierra_leone',
  '🇸🇲': 'san_marino',
  '🇸🇳': 'senegal',
  '🇸🇴': 'somalia',
  '🇸🇷': 'suriname',
  '🇸🇸': 'south_sudan',
  '🇸🇹': 'sao_tome_principe',
  '🇸🇻': 'el_salvador',
  '🇸🇽': 'sint_maarten',
  '🇸🇾': 'syria',
  '🇸🇿': 'swaziland',
  '🇹🇦': 'tristan_da_cunha',
  '🇹🇨': 'turks_caicos_islands',
  '🇹🇩': 'chad',
  '🇹🇫': 'french_southern_territories',
  '🇹🇬': 'togo',
  '🇹🇭': 'thailand',
  '🇹🇯': 'tajikistan',
  '🇹🇰': 'tokelau',
  '🇹🇱': 'timor_leste',
  '🇹🇲': 'turkmenistan',
  '🇹🇳': 'tunisia',
  '🇹🇴': 'tonga',
  '🇹🇷': 'tr',
  '🇹🇹': 'trinidad_tobago',
  '🇹🇻': 'tuvalu',
  '🇹🇼': 'taiwan',
  '🇹🇿': 'tanzania',
  '🇺🇦': 'ukraine',
  '🇺🇬': 'uganda',
  '🇺🇲': 'us_outlying_islands',
  '🇺🇳': 'united_nations',
  '🇺🇸': 'us',
  '🇺🇾': 'uruguay',
  '🇺🇿': 'uzbekistan',
  '🇻🇦': 'vatican_city',
  '🇻🇨': 'st_vincent_grenadines',
  '🇻🇪': 'venezuela',
  '🇻🇬': 'british_virgin_islands',
  '🇻🇮': 'us_virgin_islands',
  '🇻🇳': 'vietnam',
  '🇻🇺': 'vanuatu',
  '🇼🇫': 'wallis_futuna',
  '🇼🇸': 'samoa',
  '🇽🇰': 'kosovo',
  '🇾🇪': 'yemen',
  '🇾🇹': 'mayotte',
  '🇿🇦': 'south_africa',
  '🇿🇲': 'zambia',
  '🇿🇼': 'zimbabwe',
  '🏴󠁧󠁢󠁥󠁮󠁧󠁿': 'england',
  '🏴󠁧󠁢󠁳󠁣󠁴󠁿': 'scotland',
  '🏴󠁧󠁢󠁷󠁬󠁳󠁿': 'wales'
}
